function Cid10() {
  const cid10 = [
    {
      "CAT": "A00",
      "DESCRICAO": "Cólera"
    },
    {
      "CAT": "A01",
      "DESCRICAO": "Febres tifóide e paratifóide"
    },
    {
      "CAT": "A02",
      "DESCRICAO": "Outras infecções por Salmonella"
    },
    {
      "CAT": "A03",
      "DESCRICAO": "Shiguelose"
    },
    {
      "CAT": "A04",
      "DESCRICAO": "Outras infecções intestinais bacterianas"
    },
    {
      "CAT": "A05",
      "DESCRICAO": "Outras intoxicações alimentares bacterianas"
    },
    {
      "CAT": "A06",
      "DESCRICAO": "Amebíase"
    },
    {
      "CAT": "A07",
      "DESCRICAO": "Outras doenças intestinais por protozoários"
    },
    {
      "CAT": "A08",
      "DESCRICAO": "Infecções intestinais virais"
    },
    {
      "CAT": "A09",
      "DESCRICAO": "Diarréia e gastroenterite de origem infecciosa presumível"
    },
    {
      "CAT": "A15",
      "DESCRICAO": "Tuberculose respiratória"
    },
    {
      "CAT": "A16",
      "DESCRICAO": "Tuberculose das vias respiratórias"
    },
    {
      "CAT": "A17",
      "DESCRICAO": "Tuberculose do sistema nervoso"
    },
    {
      "CAT": "A18",
      "DESCRICAO": "Tuberculose de outros órgãos"
    },
    {
      "CAT": "A19",
      "DESCRICAO": "Tuberculose miliar"
    },
    {
      "CAT": "A20",
      "DESCRICAO": "Peste"
    },
    {
      "CAT": "A21",
      "DESCRICAO": "Tularemia"
    },
    {
      "CAT": "A22",
      "DESCRICAO": "Carbúnculo"
    },
    {
      "CAT": "A23",
      "DESCRICAO": "Brucelose"
    },
    {
      "CAT": "A24",
      "DESCRICAO": "Mormo e melioidose"
    },
    {
      "CAT": "A25",
      "DESCRICAO": "Febres transmitidas por mordedura de rato"
    },
    {
      "CAT": "A26",
      "DESCRICAO": "Erisipelóide"
    },
    {
      "CAT": "A27",
      "DESCRICAO": "Leptospirose"
    },
    {
      "CAT": "A28",
      "DESCRICAO": "Outras doenças bacterianas zoonóticas não classificadas em outra parte"
    },
    {
      "CAT": "A30",
      "DESCRICAO": "Hanseníase [doença de Hansen] [lepra]"
    },
    {
      "CAT": "A31",
      "DESCRICAO": "Infecções devidas a outras micobactérias"
    },
    {
      "CAT": "A32",
      "DESCRICAO": "Listeriose [listeríase]"
    },
    {
      "CAT": "A33",
      "DESCRICAO": "Tétano do recém-nascido [neonatal]"
    },
    {
      "CAT": "A34",
      "DESCRICAO": "Tétano obstétrico"
    },
    {
      "CAT": "A35",
      "DESCRICAO": "Outros tipos de tétano"
    },
    {
      "CAT": "A36",
      "DESCRICAO": "Difteria"
    },
    {
      "CAT": "A37",
      "DESCRICAO": "Coqueluche"
    },
    {
      "CAT": "A38",
      "DESCRICAO": "Escarlatina"
    },
    {
      "CAT": "A39",
      "DESCRICAO": "Infecção meningogócica"
    },
    {
      "CAT": "A40",
      "DESCRICAO": "Septicemia estreptocócica"
    },
    {
      "CAT": "A41",
      "DESCRICAO": "Outras septicemias"
    },
    {
      "CAT": "A42",
      "DESCRICAO": "Actinomicose"
    },
    {
      "CAT": "A43",
      "DESCRICAO": "Nocardiose"
    },
    {
      "CAT": "A44",
      "DESCRICAO": "Bartonelose"
    },
    {
      "CAT": "A46",
      "DESCRICAO": "Erisipela"
    },
    {
      "CAT": "A48",
      "DESCRICAO": "Outras doenças bacterianas não classificadas em outra parte"
    },
    {
      "CAT": "A49",
      "DESCRICAO": "Infecção bacteriana de localização não especificada"
    },
    {
      "CAT": "A50",
      "DESCRICAO": "Sífilis congênita"
    },
    {
      "CAT": "A51",
      "DESCRICAO": "Sífilis precoce"
    },
    {
      "CAT": "A52",
      "DESCRICAO": "Sífilis tardia"
    },
    {
      "CAT": "A53",
      "DESCRICAO": "Outras formas e as não especificadas da sífilis"
    },
    {
      "CAT": "A54",
      "DESCRICAO": "Infecção gonocócica"
    },
    {
      "CAT": "A55",
      "DESCRICAO": "Linfogranuloma (venéreo) por clamídia"
    },
    {
      "CAT": "A56",
      "DESCRICAO": "Outras infecções causadas por clamídias transmitidas por via sexual"
    },
    {
      "CAT": "A57",
      "DESCRICAO": "Cancro mole"
    },
    {
      "CAT": "A58",
      "DESCRICAO": "Granuloma inguinal"
    },
    {
      "CAT": "A59",
      "DESCRICAO": "Tricomoníase"
    },
    {
      "CAT": "A60",
      "DESCRICAO": "Infecções anogenitais pelo vírus do herpes [herpes simples]"
    },
    {
      "CAT": "A63",
      "DESCRICAO": "Outras doenças de transmissão predominantemente sexual"
    },
    {
      "CAT": "A64",
      "DESCRICAO": "Doenças sexualmente transmitidas"
    },
    {
      "CAT": "A65",
      "DESCRICAO": "Sífilis não-venérea"
    },
    {
      "CAT": "A66",
      "DESCRICAO": "Bouba"
    },
    {
      "CAT": "A67",
      "DESCRICAO": "Pinta [carate]"
    },
    {
      "CAT": "A68",
      "DESCRICAO": "Febres recorrentes [Borrelioses]"
    },
    {
      "CAT": "A69",
      "DESCRICAO": "Outras infecções por espiroquetas"
    },
    {
      "CAT": "A70",
      "DESCRICAO": "Infecções causadas por Clamídia psittaci"
    },
    {
      "CAT": "A71",
      "DESCRICAO": "Tracoma"
    },
    {
      "CAT": "A74",
      "DESCRICAO": "Outras doenças causadas por Clamídias"
    },
    {
      "CAT": "A75",
      "DESCRICAO": "Tifo exantemático"
    },
    {
      "CAT": "A77",
      "DESCRICAO": "Febre maculosa [rickettsioses transmitidas por carrapatos]"
    },
    {
      "CAT": "A78",
      "DESCRICAO": "Febre Q"
    },
    {
      "CAT": "A79",
      "DESCRICAO": "Outras rickettsioses"
    },
    {
      "CAT": "A80",
      "DESCRICAO": "Poliomielite aguda"
    },
    {
      "CAT": "A81",
      "DESCRICAO": "Infecções por vírus atípicos do sistema nervoso central"
    },
    {
      "CAT": "A82",
      "DESCRICAO": "Raiva"
    },
    {
      "CAT": "A83",
      "DESCRICAO": "Encefalite por vírus transmitidos por mosquitos"
    },
    {
      "CAT": "A84",
      "DESCRICAO": "Encefalite por vírus transmitido por carrapatos"
    },
    {
      "CAT": "A85",
      "DESCRICAO": "Outras encefalites virais"
    },
    {
      "CAT": "A86",
      "DESCRICAO": "Encefalite viral"
    },
    {
      "CAT": "A87",
      "DESCRICAO": "Meningite viral"
    },
    {
      "CAT": "A88",
      "DESCRICAO": "Outras infecções virais do sistema nervoso central não classificadas em outra parte"
    },
    {
      "CAT": "A89",
      "DESCRICAO": "Infecções virais não especificadas do sistema nervoso central"
    },
    {
      "CAT": "A90",
      "DESCRICAO": "Dengue [dengue clássico]"
    },
    {
      "CAT": "A91",
      "DESCRICAO": "Febre hemorrágica devida ao vírus do dengue"
    },
    {
      "CAT": "A92",
      "DESCRICAO": "Outras febres virais transmitidas por mosquitos"
    },
    {
      "CAT": "A93",
      "DESCRICAO": "Outras febres por vírus transmitidas por artrópodes não classificadas em outra parte"
    },
    {
      "CAT": "A94",
      "DESCRICAO": "Febre viral transmitida por artrópodes"
    },
    {
      "CAT": "A95",
      "DESCRICAO": "Febre amarela"
    },
    {
      "CAT": "A96",
      "DESCRICAO": "Febre hemorrágica por arenavírus"
    },
    {
      "CAT": "A98",
      "DESCRICAO": "Outras febres hemorrágicas por vírus"
    },
    {
      "CAT": "A99",
      "DESCRICAO": "Febres hemorrágicas virais não especificadas"
    },
    {
      "CAT": "B00",
      "DESCRICAO": "Infecções pelo vírus do herpes [herpes simples]"
    },
    {
      "CAT": "B01",
      "DESCRICAO": "Varicela [Catapora]"
    },
    {
      "CAT": "B02",
      "DESCRICAO": "Herpes zoster [Zona]"
    },
    {
      "CAT": "B03",
      "DESCRICAO": "Varíola"
    },
    {
      "CAT": "B04",
      "DESCRICAO": "Varíola dos macacos [Monkeypox]"
    },
    {
      "CAT": "B05",
      "DESCRICAO": "Sarampo"
    },
    {
      "CAT": "B06",
      "DESCRICAO": "Rubéola"
    },
    {
      "CAT": "B07",
      "DESCRICAO": "Verrugas de origem viral"
    },
    {
      "CAT": "B08",
      "DESCRICAO": "Outras infecções virais caracterizadas por lesões da pele e das membranas mucosas"
    },
    {
      "CAT": "B09",
      "DESCRICAO": "Infecção viral não especificada caracterizada por lesões da pele e membranas mucosas"
    },
    {
      "CAT": "B15",
      "DESCRICAO": "Hepatite aguda A"
    },
    {
      "CAT": "B16",
      "DESCRICAO": "Hepatite aguda B"
    },
    {
      "CAT": "B17",
      "DESCRICAO": "Outras hepatites virais agudas"
    },
    {
      "CAT": "B18",
      "DESCRICAO": "Hepatite viral crônica"
    },
    {
      "CAT": "B19",
      "DESCRICAO": "Hepatite viral não especificada"
    },
    {
      "CAT": "B20",
      "DESCRICAO": "Doença pelo vírus da imunodeficiência humana [HIV]"
    },
    {
      "CAT": "B21",
      "DESCRICAO": "Doença pelo vírus da imunodeficiência humana [HIV]"
    },
    {
      "CAT": "B22",
      "DESCRICAO": "Doença pelo vírus da imunodeficiência humana [HIV] resultando em outras doenças especificadas"
    },
    {
      "CAT": "B23",
      "DESCRICAO": "Doença pelo vírus da imunodeficiência humana [HIV] resultando em outras doenças"
    },
    {
      "CAT": "B24",
      "DESCRICAO": "Doença pelo vírus da imunodeficiência humana [HIV] não especificada"
    },
    {
      "CAT": "B25",
      "DESCRICAO": "Doença por citomegalovírus"
    },
    {
      "CAT": "B26",
      "DESCRICAO": "Caxumba [Parotidite epidêmica]"
    },
    {
      "CAT": "B27",
      "DESCRICAO": "Mononucleose infecciosa"
    },
    {
      "CAT": "B30",
      "DESCRICAO": "Conjuntivite viral"
    },
    {
      "CAT": "B33",
      "DESCRICAO": "Outras doenças por vírus não classificada em outra parte"
    },
    {
      "CAT": "B34",
      "DESCRICAO": "Doenças por vírus"
    },
    {
      "CAT": "B35",
      "DESCRICAO": "Dermatofitose"
    },
    {
      "CAT": "B36",
      "DESCRICAO": "Outras micoses superficiais"
    },
    {
      "CAT": "B37",
      "DESCRICAO": "Candidíase"
    },
    {
      "CAT": "B38",
      "DESCRICAO": "Coccidioidomicose"
    },
    {
      "CAT": "B39",
      "DESCRICAO": "Histoplasmose"
    },
    {
      "CAT": "B40",
      "DESCRICAO": "Blastomicose"
    },
    {
      "CAT": "B41",
      "DESCRICAO": "Paracoccidioidomicose"
    },
    {
      "CAT": "B42",
      "DESCRICAO": "Esporotricose"
    },
    {
      "CAT": "B43",
      "DESCRICAO": "Cromomicose e abscesso feomicótico"
    },
    {
      "CAT": "B44",
      "DESCRICAO": "Aspergilose"
    },
    {
      "CAT": "B45",
      "DESCRICAO": "Criptococose"
    },
    {
      "CAT": "B46",
      "DESCRICAO": "Zigomicose"
    },
    {
      "CAT": "B47",
      "DESCRICAO": "Micetoma"
    },
    {
      "CAT": "B48",
      "DESCRICAO": "Outras micoses"
    },
    {
      "CAT": "B49",
      "DESCRICAO": "Micose não especificada"
    },
    {
      "CAT": "B50",
      "DESCRICAO": "Malária por Plasmodium falciparum"
    },
    {
      "CAT": "B51",
      "DESCRICAO": "Malária por Plasmodium vivax"
    },
    {
      "CAT": "B52",
      "DESCRICAO": "Malária por Plasmodium malariae"
    },
    {
      "CAT": "B53",
      "DESCRICAO": "Outras formas de malária confirmadas por exames parasitológicos"
    },
    {
      "CAT": "B54",
      "DESCRICAO": "Malária não especificada"
    },
    {
      "CAT": "B55",
      "DESCRICAO": "Leishmaniose"
    },
    {
      "CAT": "B56",
      "DESCRICAO": "Tripanossomíase africana"
    },
    {
      "CAT": "B57",
      "DESCRICAO": "Doença de Chagas"
    },
    {
      "CAT": "B58",
      "DESCRICAO": "Toxoplasmose"
    },
    {
      "CAT": "B59",
      "DESCRICAO": "Pneumocistose"
    },
    {
      "CAT": "B60",
      "DESCRICAO": "Outras doenças devidas a protozoários"
    },
    {
      "CAT": "B64",
      "DESCRICAO": "Doença não especificada devida a protozoários"
    },
    {
      "CAT": "B65",
      "DESCRICAO": "Esquistossomose [bilharziose] [Schistosomíase]"
    },
    {
      "CAT": "B66",
      "DESCRICAO": "Outras infestações por trematódeos"
    },
    {
      "CAT": "B67",
      "DESCRICAO": "Equinococose"
    },
    {
      "CAT": "B68",
      "DESCRICAO": "Infestação por Taenia"
    },
    {
      "CAT": "B69",
      "DESCRICAO": "Cisticercose"
    },
    {
      "CAT": "B70",
      "DESCRICAO": "Difilobotríase e esparganose"
    },
    {
      "CAT": "B71",
      "DESCRICAO": "Outras infestações por cestóides"
    },
    {
      "CAT": "B72",
      "DESCRICAO": "Dracontíase"
    },
    {
      "CAT": "B73",
      "DESCRICAO": "Oncocercose"
    },
    {
      "CAT": "B74",
      "DESCRICAO": "Filariose"
    },
    {
      "CAT": "B75",
      "DESCRICAO": "Triquinose"
    },
    {
      "CAT": "B76",
      "DESCRICAO": "Ancilostomíase"
    },
    {
      "CAT": "B77",
      "DESCRICAO": "Ascaridíase"
    },
    {
      "CAT": "B78",
      "DESCRICAO": "Estrongiloidíase"
    },
    {
      "CAT": "B79",
      "DESCRICAO": "Tricuríase"
    },
    {
      "CAT": "B80",
      "DESCRICAO": "Oxiuríase"
    },
    {
      "CAT": "B81",
      "DESCRICAO": "Outras helmintíases intestinais"
    },
    {
      "CAT": "B82",
      "DESCRICAO": "Parasitose intestinal não especificada"
    },
    {
      "CAT": "B83",
      "DESCRICAO": "Outras helmintíases"
    },
    {
      "CAT": "B85",
      "DESCRICAO": "Pediculose e ftiríase"
    },
    {
      "CAT": "B86",
      "DESCRICAO": "Escabiose [sarna]"
    },
    {
      "CAT": "B87",
      "DESCRICAO": "Miíase"
    },
    {
      "CAT": "B88",
      "DESCRICAO": "Outras infestações"
    },
    {
      "CAT": "B89",
      "DESCRICAO": "Doença parasitária não especificada"
    },
    {
      "CAT": "B90",
      "DESCRICAO": "Seqüelas de tuberculose"
    },
    {
      "CAT": "B91",
      "DESCRICAO": "Seqüelas de poliomielite"
    },
    {
      "CAT": "B92",
      "DESCRICAO": "Seqüelas de hanseníase [lepra]"
    },
    {
      "CAT": "B94",
      "DESCRICAO": "Seqüelas de outras doenças infecciosas e parasitárias e das não especificadas"
    },
    {
      "CAT": "B95",
      "DESCRICAO": "Estreptococos e estafilococos como causa de doenças classificadas em outros capítulos"
    },
    {
      "CAT": "B96",
      "DESCRICAO": "Outros agentes bacterianos"
    },
    {
      "CAT": "B97",
      "DESCRICAO": "Vírus como causa de doenças classificadas em outros capítulos"
    },
    {
      "CAT": "B99",
      "DESCRICAO": "Doenças infecciosas"
    },
    {
      "CAT": "C00",
      "DESCRICAO": "Neoplasia maligna do lábio"
    },
    {
      "CAT": "C01",
      "DESCRICAO": "Neoplasia maligna da base da língua"
    },
    {
      "CAT": "C02",
      "DESCRICAO": "Neoplasia maligna de outras partes e de partes não especificadas da língua"
    },
    {
      "CAT": "C03",
      "DESCRICAO": "Neoplasia maligna da gengiva"
    },
    {
      "CAT": "C04",
      "DESCRICAO": "Neoplasia maligna do assoalho da boca"
    },
    {
      "CAT": "C05",
      "DESCRICAO": "Neoplasia maligna do palato"
    },
    {
      "CAT": "C06",
      "DESCRICAO": "Neoplasia maligna de outras partes e de partes não especificadas da boca"
    },
    {
      "CAT": "C07",
      "DESCRICAO": "Neoplasia maligna da glândula parótida"
    },
    {
      "CAT": "C08",
      "DESCRICAO": "Neoplasia maligna de outras glândulas salivares maiores e as não especificadas"
    },
    {
      "CAT": "C09",
      "DESCRICAO": "Neoplasia maligna da amígdala"
    },
    {
      "CAT": "C10",
      "DESCRICAO": "Neoplasia maligna da orofaringe"
    },
    {
      "CAT": "C11",
      "DESCRICAO": "Neoplasia maligna da nasofaringe"
    },
    {
      "CAT": "C12",
      "DESCRICAO": "Neoplasia maligna do seio piriforme"
    },
    {
      "CAT": "C13",
      "DESCRICAO": "Neoplasia maligna da hipofaringe"
    },
    {
      "CAT": "C14",
      "DESCRICAO": "Neoplasia maligna de outras localizações e de localizações mal definida"
    },
    {
      "CAT": "C15",
      "DESCRICAO": "Neoplasia maligna do esôfago"
    },
    {
      "CAT": "C16",
      "DESCRICAO": "Neoplasia maligna do estômago"
    },
    {
      "CAT": "C17",
      "DESCRICAO": "Neoplasia maligna do intestino delgado"
    },
    {
      "CAT": "C18",
      "DESCRICAO": "Neoplasia maligna do cólon"
    },
    {
      "CAT": "C19",
      "DESCRICAO": "Neoplasia maligna da junção retossigmóide"
    },
    {
      "CAT": "C20",
      "DESCRICAO": "Neoplasia maligna do reto"
    },
    {
      "CAT": "C21",
      "DESCRICAO": "Neoplasia maligna do ânus e do canal anal"
    },
    {
      "CAT": "C22",
      "DESCRICAO": "Neoplasia maligna do fígado e das vias biliares intra-hepáticas"
    },
    {
      "CAT": "C23",
      "DESCRICAO": "Neoplasia maligna da vesícula biliar"
    },
    {
      "CAT": "C24",
      "DESCRICAO": "Neoplasia maligna de outras partes"
    },
    {
      "CAT": "C25",
      "DESCRICAO": "Neoplasia maligna do pâncreas"
    },
    {
      "CAT": "C26",
      "DESCRICAO": "Neoplasia maligna de outros órgãos digestivos e de localizações mal definidas no aparelho digestivo"
    },
    {
      "CAT": "C30",
      "DESCRICAO": "Neoplasia maligna da cavidade nasal e do ouvido médio"
    },
    {
      "CAT": "C31",
      "DESCRICAO": "Neoplasia maligna dos seios da face"
    },
    {
      "CAT": "C32",
      "DESCRICAO": "Neoplasia maligna da laringe"
    },
    {
      "CAT": "C33",
      "DESCRICAO": "Neoplasia maligna da traquéia"
    },
    {
      "CAT": "C34",
      "DESCRICAO": "Neoplasia maligna dos brônquios e dos pulmões"
    },
    {
      "CAT": "C37",
      "DESCRICAO": "Neoplasia maligna do timo"
    },
    {
      "CAT": "C38",
      "DESCRICAO": "Neoplasia maligna do coração"
    },
    {
      "CAT": "C39",
      "DESCRICAO": "Neoplasia maligna de outras localizações e de localizações mal definidas do aparelho respiratório e dos órgãos intratorácicos"
    },
    {
      "CAT": "C40",
      "DESCRICAO": "Neoplasia maligna dos ossos e cartilagens articulares dos membros"
    },
    {
      "CAT": "C41",
      "DESCRICAO": "Neoplasia maligna dos ossos e das cartilagens articulares de outras localizações e de localizações não especificadas"
    },
    {
      "CAT": "C43",
      "DESCRICAO": "Melanoma maligno da pele"
    },
    {
      "CAT": "C44",
      "DESCRICAO": "Outras neoplasias malignas da pele"
    },
    {
      "CAT": "C45",
      "DESCRICAO": "Mesotelioma"
    },
    {
      "CAT": "C46",
      "DESCRICAO": "Sarcoma de Kaposi"
    },
    {
      "CAT": "C47",
      "DESCRICAO": "Neoplasia maligna dos nervos periféricos e do sistema nervoso autônomo"
    },
    {
      "CAT": "C48",
      "DESCRICAO": "Neoplasia maligna dos tecidos moles do retroperitônio e do peritônio"
    },
    {
      "CAT": "C49",
      "DESCRICAO": "Neoplasia maligna do tecido conjuntivo e de outros tecidos moles"
    },
    {
      "CAT": "C50",
      "DESCRICAO": "Neoplasia maligna da mama"
    },
    {
      "CAT": "C51",
      "DESCRICAO": "Neoplasia maligna da vulva"
    },
    {
      "CAT": "C52",
      "DESCRICAO": "Neoplasia maligna da vagina"
    },
    {
      "CAT": "C53",
      "DESCRICAO": "Neoplasia maligna do colo do útero"
    },
    {
      "CAT": "C54",
      "DESCRICAO": "Neoplasia maligna do corpo do útero"
    },
    {
      "CAT": "C55",
      "DESCRICAO": "Neoplasia maligna do útero"
    },
    {
      "CAT": "C56",
      "DESCRICAO": "Neoplasia maligna do ovário"
    },
    {
      "CAT": "C57",
      "DESCRICAO": "Neoplasia maligna de outros órgãos genitais femininos e dos não especificados"
    },
    {
      "CAT": "C58",
      "DESCRICAO": "Neoplasia maligna da placenta"
    },
    {
      "CAT": "C60",
      "DESCRICAO": "Neoplasia maligna do pênis"
    },
    {
      "CAT": "C61",
      "DESCRICAO": "Neoplasia maligna da próstata"
    },
    {
      "CAT": "C62",
      "DESCRICAO": "Neoplasia maligna dos testículos"
    },
    {
      "CAT": "C63",
      "DESCRICAO": "Neoplasia maligna de outros órgãos genitais masculinos e dos não especificados"
    },
    {
      "CAT": "C64",
      "DESCRICAO": "Neoplasia maligna do rim"
    },
    {
      "CAT": "C65",
      "DESCRICAO": "Neoplasia maligna da pelve renal"
    },
    {
      "CAT": "C66",
      "DESCRICAO": "Neoplasia maligna dos ureteres"
    },
    {
      "CAT": "C67",
      "DESCRICAO": "Neoplasia maligna da bexiga"
    },
    {
      "CAT": "C68",
      "DESCRICAO": "Neoplasia maligna de outros órgãos urinários e dos não especificados"
    },
    {
      "CAT": "C69",
      "DESCRICAO": "Neoplasia maligna do olho e anexos"
    },
    {
      "CAT": "C70",
      "DESCRICAO": "Neoplasia maligna das meninges"
    },
    {
      "CAT": "C71",
      "DESCRICAO": "Neoplasia maligna do encéfalo"
    },
    {
      "CAT": "C72",
      "DESCRICAO": "Neoplasia maligna da medula espinhal"
    },
    {
      "CAT": "C73",
      "DESCRICAO": "Neoplasia maligna da glândula tireóide"
    },
    {
      "CAT": "C74",
      "DESCRICAO": "Neoplasia maligna da glândula supra-renal [Glândula adrenal]"
    },
    {
      "CAT": "C75",
      "DESCRICAO": "Neoplasia maligna de outras glândulas endócrinas e de estruturas relacionadas"
    },
    {
      "CAT": "C76",
      "DESCRICAO": "Neoplasia maligna de outras localizações e de localizações mal definidas"
    },
    {
      "CAT": "C77",
      "DESCRICAO": "Neoplasia maligna secundária e não especificada dos gânglios linfáticos"
    },
    {
      "CAT": "C78",
      "DESCRICAO": "Neoplasia maligna secundária dos órgãos respiratórios e digestivos"
    },
    {
      "CAT": "C79",
      "DESCRICAO": "Neoplasia maligna secundária de outras localizações"
    },
    {
      "CAT": "C80",
      "DESCRICAO": "Neoplasia maligna"
    },
    {
      "CAT": "C81",
      "DESCRICAO": "Doença de Hodgkin"
    },
    {
      "CAT": "C82",
      "DESCRICAO": "Linfoma não-Hodgkin"
    },
    {
      "CAT": "C83",
      "DESCRICAO": "Linfoma não-Hodgkin difuso"
    },
    {
      "CAT": "C84",
      "DESCRICAO": "Linfomas de células T cutâneas e periféricas"
    },
    {
      "CAT": "C85",
      "DESCRICAO": "Linfoma não-Hodgkin de outros tipos e de tipo não especificado"
    },
    {
      "CAT": "C88",
      "DESCRICAO": "Doenças imunoproliferativas malignas"
    },
    {
      "CAT": "C90",
      "DESCRICAO": "Mieloma múltiplo e neoplasias malignas de plasmócitos"
    },
    {
      "CAT": "C91",
      "DESCRICAO": "Leucemia linfóide"
    },
    {
      "CAT": "C92",
      "DESCRICAO": "Leucemia mielóide"
    },
    {
      "CAT": "C93",
      "DESCRICAO": "Leucemia monocítica"
    },
    {
      "CAT": "C94",
      "DESCRICAO": "Outras leucemias de células de tipo especificado"
    },
    {
      "CAT": "C95",
      "DESCRICAO": "Leucemia de tipo celular não especificado"
    },
    {
      "CAT": "C96",
      "DESCRICAO": "Outras neoplasias malignas e as não especificadas dos tecidos linfático"
    },
    {
      "CAT": "C97",
      "DESCRICAO": "Neoplasias malignas de localizações múltiplas independentes (primárias)"
    },
    {
      "CAT": "D00",
      "DESCRICAO": "Carcinoma in situ da cavidade oral"
    },
    {
      "CAT": "D01",
      "DESCRICAO": "Carcinoma in situ de outros órgãos digestivos"
    },
    {
      "CAT": "D02",
      "DESCRICAO": "Carcinoma in situ do ouvido médio e do aparelho respiratório"
    },
    {
      "CAT": "D03",
      "DESCRICAO": "Melanoma in situ"
    },
    {
      "CAT": "D04",
      "DESCRICAO": "Carcinoma in situ da pele"
    },
    {
      "CAT": "D05",
      "DESCRICAO": "Carcinoma in situ da mama"
    },
    {
      "CAT": "D06",
      "DESCRICAO": "Carcinoma in situ do colo do útero (cérvix)"
    },
    {
      "CAT": "D07",
      "DESCRICAO": "Carcinoma in situ de outros órgãos genitais e dos não especificados"
    },
    {
      "CAT": "D09",
      "DESCRICAO": "Carcinoma in situ de outras localizações e das não especificadas"
    },
    {
      "CAT": "D10",
      "DESCRICAO": "Neoplasia benigna da boca e da faringe"
    },
    {
      "CAT": "D11",
      "DESCRICAO": "Neoplasia benigna de glândulas salivares maiores"
    },
    {
      "CAT": "D12",
      "DESCRICAO": "Neoplasia benigna do cólon"
    },
    {
      "CAT": "D13",
      "DESCRICAO": "Neoplasia benigna de outras partes e de partes mal definidas do aparelho digestivo"
    },
    {
      "CAT": "D14",
      "DESCRICAO": "Neoplasia benigna do ouvido médio e do aparelho respiratório"
    },
    {
      "CAT": "D15",
      "DESCRICAO": "Neoplasia benigna de outros órgãos intratorácicos e dos não especificados"
    },
    {
      "CAT": "D16",
      "DESCRICAO": "Neoplasia benigna de osso e de cartilagem articular"
    },
    {
      "CAT": "D17",
      "DESCRICAO": "Neoplasia lipomatosa benigna"
    },
    {
      "CAT": "D18",
      "DESCRICAO": "Hemangioma e linfangioma de qualquer localização"
    },
    {
      "CAT": "D19",
      "DESCRICAO": "Neoplasia benigna de tecido mesotelial"
    },
    {
      "CAT": "D20",
      "DESCRICAO": "Neoplasia benigna de tecido mole do retroperitônio e do peritônio"
    },
    {
      "CAT": "D21",
      "DESCRICAO": "Outras neoplasias benignas do tecido conjuntivo e de outros tecidos moles"
    },
    {
      "CAT": "D22",
      "DESCRICAO": "Nevos melanocíticos"
    },
    {
      "CAT": "D23",
      "DESCRICAO": "Outras neoplasias benignas da pele"
    },
    {
      "CAT": "D24",
      "DESCRICAO": "Neoplasia benigna da mama"
    },
    {
      "CAT": "D25",
      "DESCRICAO": "Leiomioma do útero"
    },
    {
      "CAT": "D26",
      "DESCRICAO": "Outras neoplasias benignas do útero"
    },
    {
      "CAT": "D27",
      "DESCRICAO": "Neoplasia benigna do ovário"
    },
    {
      "CAT": "D28",
      "DESCRICAO": "Neoplasia benigna de outros órgãos genitais femininos e de órgãos não especificados"
    },
    {
      "CAT": "D29",
      "DESCRICAO": "Neoplasia benigna dos órgãos genitais masculinos"
    },
    {
      "CAT": "D30",
      "DESCRICAO": "Neoplasia benigna dos órgãos urinários"
    },
    {
      "CAT": "D31",
      "DESCRICAO": "Neoplasia benigna do olho e anexos"
    },
    {
      "CAT": "D32",
      "DESCRICAO": "Neoplasia benigna das meninges"
    },
    {
      "CAT": "D33",
      "DESCRICAO": "Neoplasia benigna do encéfalo e de outras partes do sistema nervoso central"
    },
    {
      "CAT": "D34",
      "DESCRICAO": "Neoplasia benigna da glândula tireóide"
    },
    {
      "CAT": "D35",
      "DESCRICAO": "Neoplasia benigna de outras glândulas endócrinas e das não especificadas"
    },
    {
      "CAT": "D36",
      "DESCRICAO": "Neoplasia benigna de outras localizações e de localizações não especificadas"
    },
    {
      "CAT": "D37",
      "DESCRICAO": "Neoplasia de comportamento incerto ou desconhecido da cavidade oral e dos órgãos digestivos"
    },
    {
      "CAT": "D38",
      "DESCRICAO": "Neoplasia de comportamento incerto ou desconhecido do ouvido médio e dos órgãos respiratórios e intratorácicos"
    },
    {
      "CAT": "D39",
      "DESCRICAO": "Neoplasia de comportamento incerto ou desconhecido dos órgãos genitais femininos"
    },
    {
      "CAT": "D40",
      "DESCRICAO": "Neoplasia de comportamento incerto ou desconhecido dos órgãos genitais masculinos"
    },
    {
      "CAT": "D41",
      "DESCRICAO": "Neoplasia de comportamento incerto ou desconhecido dos órgãos urinários"
    },
    {
      "CAT": "D42",
      "DESCRICAO": "Neoplasia de comportamento incerto ou desconhecido das meninges"
    },
    {
      "CAT": "D43",
      "DESCRICAO": "Neoplasia de comportamento incerto ou desconhecido do encéfalo e do sistema nervoso central"
    },
    {
      "CAT": "D44",
      "DESCRICAO": "Neoplasia de comportamento incerto ou desconhecido das glândulas endócrinas"
    },
    {
      "CAT": "D45",
      "DESCRICAO": "Policitemia vera"
    },
    {
      "CAT": "D46",
      "DESCRICAO": "Síndromes mielodisplásicas"
    },
    {
      "CAT": "D47",
      "DESCRICAO": "Outras neoplasias de comportamento incerto ou desconhecido dos tecidos linfático"
    },
    {
      "CAT": "D48",
      "DESCRICAO": "Neoplasia de comportamento incerto ou desconhecido de outras localizações e de localizações não especificadas"
    },
    {
      "CAT": "D50",
      "DESCRICAO": "Anemia por deficiência de ferro"
    },
    {
      "CAT": "D51",
      "DESCRICAO": "Anemia por deficiência de vitamina B12"
    },
    {
      "CAT": "D52",
      "DESCRICAO": "Anemia por deficiência de folato"
    },
    {
      "CAT": "D53",
      "DESCRICAO": "Outras anemias nutricionais"
    },
    {
      "CAT": "D55",
      "DESCRICAO": "Anemia devida a transtornos enzimáticos"
    },
    {
      "CAT": "D56",
      "DESCRICAO": "Talassemia"
    },
    {
      "CAT": "D57",
      "DESCRICAO": "Transtornos falciformes"
    },
    {
      "CAT": "D58",
      "DESCRICAO": "Outras anemias hemolíticas hereditárias"
    },
    {
      "CAT": "D59",
      "DESCRICAO": "Anemia hemolítica adquirida"
    },
    {
      "CAT": "D60",
      "DESCRICAO": "Aplasia pura da série vermelha"
    },
    {
      "CAT": "D61",
      "DESCRICAO": "Outras anemias aplásticas"
    },
    {
      "CAT": "D62",
      "DESCRICAO": "Anemia aguda pós-hemorrágica"
    },
    {
      "CAT": "D63",
      "DESCRICAO": "Anemia em doenças crônicas classificadas em outra parte"
    },
    {
      "CAT": "D64",
      "DESCRICAO": "Outras anemias"
    },
    {
      "CAT": "D65",
      "DESCRICAO": "Coagulação intravascular disseminada [síndrome de desfibrinação]"
    },
    {
      "CAT": "D66",
      "DESCRICAO": "Deficiência hereditária do fator VIII"
    },
    {
      "CAT": "D67",
      "DESCRICAO": "Deficiência hereditária do fator IX"
    },
    {
      "CAT": "D68",
      "DESCRICAO": "Outros defeitos da coagulação"
    },
    {
      "CAT": "D69",
      "DESCRICAO": "Púrpura e outras afecções hemorrágicas"
    },
    {
      "CAT": "D70",
      "DESCRICAO": "Agranulocitose"
    },
    {
      "CAT": "D71",
      "DESCRICAO": "Transtornos funcionais dos neutrófilos polimorfonucleares"
    },
    {
      "CAT": "D72",
      "DESCRICAO": "Outros transtornos dos glóbulos brancos"
    },
    {
      "CAT": "D73",
      "DESCRICAO": "Doenças do baço"
    },
    {
      "CAT": "D74",
      "DESCRICAO": "Metemoglobinemia"
    },
    {
      "CAT": "D75",
      "DESCRICAO": "Outras doenças do sangue e dos órgãos hematopoéticos"
    },
    {
      "CAT": "D76",
      "DESCRICAO": "Algumas doenças que envolvem o tecido linforreticular e o sistema reticulohistiocítico"
    },
    {
      "CAT": "D77",
      "DESCRICAO": "Outros transtornos do sangue e dos órgãos hematopoéticos em doenças classificadas em outra parte"
    },
    {
      "CAT": "D80",
      "DESCRICAO": "Imunodeficiência com predominância de defeitos de anticorpos"
    },
    {
      "CAT": "D81",
      "DESCRICAO": "Deficiências imunitárias combinadas"
    },
    {
      "CAT": "D82",
      "DESCRICAO": "Imunodeficiência associada com outros defeitos \"major"
    },
    {
      "CAT": "D83",
      "DESCRICAO": "Imunodeficiência comum variável"
    },
    {
      "CAT": "D84",
      "DESCRICAO": "Outras imunodeficiências"
    },
    {
      "CAT": "D86",
      "DESCRICAO": "Sarcoidose"
    },
    {
      "CAT": "D89",
      "DESCRICAO": "Outros transtornos que comprometem o mecanismo imunitário não classificados em outra parte"
    },
    {
      "CAT": "E00",
      "DESCRICAO": "Síndrome de deficiência congênita de iodo"
    },
    {
      "CAT": "E01",
      "DESCRICAO": "Transtornos tireoidianos e afecções associadas"
    },
    {
      "CAT": "E02",
      "DESCRICAO": "Hipotireoidismo subclínico por deficiência de iodo"
    },
    {
      "CAT": "E03",
      "DESCRICAO": "Outros hipotireoidismos"
    },
    {
      "CAT": "E04",
      "DESCRICAO": "Outros bócios não-tóxicos"
    },
    {
      "CAT": "E05",
      "DESCRICAO": "Tireotoxicose [hipertireoidismo]"
    },
    {
      "CAT": "E06",
      "DESCRICAO": "Tireoidite"
    },
    {
      "CAT": "E07",
      "DESCRICAO": "Outros transtornos da tireóide"
    },
    {
      "CAT": "E10",
      "DESCRICAO": "Diabetes mellitus insulino-dependente"
    },
    {
      "CAT": "E11",
      "DESCRICAO": "Diabetes mellitus não-insulino-dependente"
    },
    {
      "CAT": "E12",
      "DESCRICAO": "Diabetes mellitus relacionado com a desnutrição"
    },
    {
      "CAT": "E13",
      "DESCRICAO": "Outros tipos especificados de diabetes mellitus"
    },
    {
      "CAT": "E14",
      "DESCRICAO": "Diabetes mellitus não especificado"
    },
    {
      "CAT": "E15",
      "DESCRICAO": "Coma hipoglicêmico não-diabético"
    },
    {
      "CAT": "E16",
      "DESCRICAO": "Outros transtornos da secreção pancreática interna"
    },
    {
      "CAT": "E20",
      "DESCRICAO": "Hipoparatireoidismo"
    },
    {
      "CAT": "E21",
      "DESCRICAO": "Hiperparatireoidismo e outros transtornos da glândula paratireóide"
    },
    {
      "CAT": "E22",
      "DESCRICAO": "Hiperfunção da hipófise"
    },
    {
      "CAT": "E23",
      "DESCRICAO": "Hipofunção e outros transtornos da hipófise"
    },
    {
      "CAT": "E24",
      "DESCRICAO": "Síndrome de Cushing"
    },
    {
      "CAT": "E25",
      "DESCRICAO": "Transtornos adrenogenitais"
    },
    {
      "CAT": "E26",
      "DESCRICAO": "Hiperaldosteronismo"
    },
    {
      "CAT": "E27",
      "DESCRICAO": "Outros transtornos da glândula supra-renal"
    },
    {
      "CAT": "E28",
      "DESCRICAO": "Disfunção ovariana"
    },
    {
      "CAT": "E29",
      "DESCRICAO": "Disfunção testicular"
    },
    {
      "CAT": "E30",
      "DESCRICAO": "Transtornos da puberdade não classificados em outra parte"
    },
    {
      "CAT": "E31",
      "DESCRICAO": "Disfunção poliglandular"
    },
    {
      "CAT": "E32",
      "DESCRICAO": "Doenças do timo"
    },
    {
      "CAT": "E34",
      "DESCRICAO": "Outros transtornos endócrinos"
    },
    {
      "CAT": "E35",
      "DESCRICAO": "Transtornos das glândulas endócrinas em doenças classificadas em outra parte"
    },
    {
      "CAT": "E40",
      "DESCRICAO": "Kwashiorkor"
    },
    {
      "CAT": "E41",
      "DESCRICAO": "Marasmo nutricional"
    },
    {
      "CAT": "E42",
      "DESCRICAO": "Kwashiorkor marasmático"
    },
    {
      "CAT": "E43",
      "DESCRICAO": "Desnutrição protéico-calórica grave não especificada"
    },
    {
      "CAT": "E44",
      "DESCRICAO": "Desnutrição protéico-calórica de graus moderado e leve"
    },
    {
      "CAT": "E45",
      "DESCRICAO": "Atraso do desenvolvimento devido à desnutrição protéico-calórica"
    },
    {
      "CAT": "E46",
      "DESCRICAO": "Desnutrição protéico-calórica não especificada"
    },
    {
      "CAT": "E50",
      "DESCRICAO": "Deficiência de vitamina A"
    },
    {
      "CAT": "E51",
      "DESCRICAO": "Deficiência de tiamina"
    },
    {
      "CAT": "E52",
      "DESCRICAO": "Deficiência de niacina [pelagra]"
    },
    {
      "CAT": "E53",
      "DESCRICAO": "Deficiência de outras vitaminas do grupo B"
    },
    {
      "CAT": "E54",
      "DESCRICAO": "Deficiência de ácido ascórbico"
    },
    {
      "CAT": "E55",
      "DESCRICAO": "Deficiência de vitamina D"
    },
    {
      "CAT": "E56",
      "DESCRICAO": "Outras deficiências vitamínicas"
    },
    {
      "CAT": "E58",
      "DESCRICAO": "Deficiência de cálcio da dieta"
    },
    {
      "CAT": "E59",
      "DESCRICAO": "Deficiência de selênio da dieta"
    },
    {
      "CAT": "E60",
      "DESCRICAO": "Deficiência de zinco da dieta"
    },
    {
      "CAT": "E61",
      "DESCRICAO": "Deficiência de outros elementos nutrientes"
    },
    {
      "CAT": "E63",
      "DESCRICAO": "Outras deficiências nutricionais"
    },
    {
      "CAT": "E64",
      "DESCRICAO": "Seqüelas de desnutrição e de outras deficiências nutricionais"
    },
    {
      "CAT": "E65",
      "DESCRICAO": "Adiposidade localizada"
    },
    {
      "CAT": "E66",
      "DESCRICAO": "Obesidade"
    },
    {
      "CAT": "E67",
      "DESCRICAO": "Outras formas de hiperalimentação"
    },
    {
      "CAT": "E68",
      "DESCRICAO": "Seqüelas de hiperalimentação"
    },
    {
      "CAT": "E70",
      "DESCRICAO": "Distúrbios do metabolismo de aminoácidos aromáticos"
    },
    {
      "CAT": "E71",
      "DESCRICAO": "Distúrbios do metabolismo de aminoácidos de cadeia ramificada e do metabolismo dos ácidos graxos"
    },
    {
      "CAT": "E72",
      "DESCRICAO": "Outros distúrbios do metabolismo de aminoácidos"
    },
    {
      "CAT": "E73",
      "DESCRICAO": "Intolerância à lactose"
    },
    {
      "CAT": "E74",
      "DESCRICAO": "Outros distúrbios do metabolismo de carboidratos"
    },
    {
      "CAT": "E75",
      "DESCRICAO": "Distúrbios do metabolismo de esfingolípides e outros distúrbios de depósito de lípides"
    },
    {
      "CAT": "E76",
      "DESCRICAO": "Distúrbios do metabolismo do glicosaminoglicano"
    },
    {
      "CAT": "E77",
      "DESCRICAO": "Distúrbios do metabolismo de glicoproteínas"
    },
    {
      "CAT": "E78",
      "DESCRICAO": "Distúrbios do metabolismo de lipoproteínas e outras lipidemias"
    },
    {
      "CAT": "E79",
      "DESCRICAO": "Distúrbios do metabolismo de purina e pirimidina"
    },
    {
      "CAT": "E80",
      "DESCRICAO": "Distúrbios do metabolismo da porfirina e da bilirrubina"
    },
    {
      "CAT": "E83",
      "DESCRICAO": "Distúrbios do metabolismo de minerais"
    },
    {
      "CAT": "E84",
      "DESCRICAO": "Fibrose cística"
    },
    {
      "CAT": "E85",
      "DESCRICAO": "Amiloidose"
    },
    {
      "CAT": "E86",
      "DESCRICAO": "Depleção de volume"
    },
    {
      "CAT": "E87",
      "DESCRICAO": "Outros transtornos do equilíbrio hidroeletrolítico e ácido-básico"
    },
    {
      "CAT": "E88",
      "DESCRICAO": "Outros distúrbios metabólicos"
    },
    {
      "CAT": "E89",
      "DESCRICAO": "Transtornos endócrinos e metabólicos pós-procedimentos"
    },
    {
      "CAT": "E90",
      "DESCRICAO": "Transtornos nutricionais e metabólicos em doenças classificadas em outra parte"
    },
    {
      "CAT": "F00",
      "DESCRICAO": "Demência na doença de Alzheimer"
    },
    {
      "CAT": "F01",
      "DESCRICAO": "Demência vascular"
    },
    {
      "CAT": "F02",
      "DESCRICAO": "Demência em outras doenças classificadas em outra parte"
    },
    {
      "CAT": "F03",
      "DESCRICAO": "Demência não especificada"
    },
    {
      "CAT": "F04",
      "DESCRICAO": "Síndrome amnésica orgânica não induzida pelo álcool ou por outras substâncias psicoativas"
    },
    {
      "CAT": "F05",
      "DESCRICAO": "Delirium não induzido pelo álcool ou por outras substâncias psicoativas"
    },
    {
      "CAT": "F06",
      "DESCRICAO": "Outros transtornos mentais devidos a lesão e disfunção cerebral e a doença física"
    },
    {
      "CAT": "F07",
      "DESCRICAO": "Transtornos de personalidade e do comportamento devidos a doença"
    },
    {
      "CAT": "F09",
      "DESCRICAO": "Transtorno mental orgânico ou sintomático não especificado"
    },
    {
      "CAT": "F10",
      "DESCRICAO": "Transtornos mentais e comportamentais devidos ao uso de álcool"
    },
    {
      "CAT": "F11",
      "DESCRICAO": "Transtornos mentais e comportamentais devidos ao uso de opiáceos"
    },
    {
      "CAT": "F12",
      "DESCRICAO": "Transtornos mentais e comportamentais devidos ao uso de canabinóides"
    },
    {
      "CAT": "F13",
      "DESCRICAO": "Transtornos mentais e comportamentais devidos ao uso de sedativos e hipnóticos"
    },
    {
      "CAT": "F14",
      "DESCRICAO": "Transtornos mentais e comportamentais devidos ao uso da cocaína"
    },
    {
      "CAT": "F15",
      "DESCRICAO": "Transtornos mentais e comportamentais devidos ao uso de outros estimulantes"
    },
    {
      "CAT": "F16",
      "DESCRICAO": "Transtornos mentais e comportamentais devidos ao uso de alucinógenos"
    },
    {
      "CAT": "F17",
      "DESCRICAO": "Transtornos mentais e comportamentais devidos ao uso de fumo"
    },
    {
      "CAT": "F18",
      "DESCRICAO": "Transtornos mentais e comportamentais devidos ao uso de solventes voláteis"
    },
    {
      "CAT": "F19",
      "DESCRICAO": "Transtornos mentais e comportamentais devidos ao uso de múltiplas drogas e ao uso de outras substâncias psicoativas"
    },
    {
      "CAT": "F20",
      "DESCRICAO": "Esquizofrenia"
    },
    {
      "CAT": "F21",
      "DESCRICAO": "Transtorno esquizotípico"
    },
    {
      "CAT": "F22",
      "DESCRICAO": "Transtornos delirantes persistentes"
    },
    {
      "CAT": "F23",
      "DESCRICAO": "Transtornos psicóticos agudos e transitórios"
    },
    {
      "CAT": "F24",
      "DESCRICAO": "Transtorno delirante induzido"
    },
    {
      "CAT": "F25",
      "DESCRICAO": "Transtornos esquizoafetivos"
    },
    {
      "CAT": "F28",
      "DESCRICAO": "Outros transtornos psicóticos não-orgânicos"
    },
    {
      "CAT": "F29",
      "DESCRICAO": "Psicose não-orgânica não especificada"
    },
    {
      "CAT": "F30",
      "DESCRICAO": "Episódio maníaco"
    },
    {
      "CAT": "F31",
      "DESCRICAO": "Transtorno afetivo bipolar"
    },
    {
      "CAT": "F32",
      "DESCRICAO": "Episódios depressivos"
    },
    {
      "CAT": "F33",
      "DESCRICAO": "Transtorno depressivo recorrente"
    },
    {
      "CAT": "F34",
      "DESCRICAO": "Transtornos de humor [afetivos] persistentes"
    },
    {
      "CAT": "F38",
      "DESCRICAO": "Outros transtornos do humor [afetivos]"
    },
    {
      "CAT": "F39",
      "DESCRICAO": "Transtorno do humor [afetivo] não especificado"
    },
    {
      "CAT": "F40",
      "DESCRICAO": "Transtornos fóbico-ansiosos"
    },
    {
      "CAT": "F41",
      "DESCRICAO": "Outros transtornos ansiosos"
    },
    {
      "CAT": "F42",
      "DESCRICAO": "Transtorno obsessivo-compulsivo"
    },
    {
      "CAT": "F43",
      "DESCRICAO": "Reações ao \"stress\" grave e transtornos de adaptação"
    },
    {
      "CAT": "F44",
      "DESCRICAO": "Transtornos dissociativos [de conversão]"
    },
    {
      "CAT": "F45",
      "DESCRICAO": "Transtornos somatoformes"
    },
    {
      "CAT": "F48",
      "DESCRICAO": "Outros transtornos neuróticos"
    },
    {
      "CAT": "F50",
      "DESCRICAO": "Transtornos da alimentação"
    },
    {
      "CAT": "F51",
      "DESCRICAO": "Transtornos não-orgânicos do sono devidos a fatores emocionais"
    },
    {
      "CAT": "F52",
      "DESCRICAO": "Disfunção sexual"
    },
    {
      "CAT": "F53",
      "DESCRICAO": "Transtornos mentais e comportamentais associados ao puerpério"
    },
    {
      "CAT": "F54",
      "DESCRICAO": "Fatores psicológicos ou comportamentais associados a doença ou a transtornos classificados em outra parte"
    },
    {
      "CAT": "F55",
      "DESCRICAO": "Abuso de substâncias que não produzem dependência"
    },
    {
      "CAT": "F59",
      "DESCRICAO": "Síndromes comportamentais associados a transtornos das funções fisiológicas e a fatores físicos"
    },
    {
      "CAT": "F60",
      "DESCRICAO": "Transtornos específicos da personalidade"
    },
    {
      "CAT": "F61",
      "DESCRICAO": "Transtornos mistos da personalidade e outros transtornos da personalidade"
    },
    {
      "CAT": "F62",
      "DESCRICAO": "Modificações duradouras da personalidade não atribuíveis a lesão ou doença cerebral"
    },
    {
      "CAT": "F63",
      "DESCRICAO": "Transtornos dos hábitos e dos impulsos"
    },
    {
      "CAT": "F64",
      "DESCRICAO": "Transtornos da identidade sexual"
    },
    {
      "CAT": "F65",
      "DESCRICAO": "Transtornos da preferência sexual"
    },
    {
      "CAT": "F66",
      "DESCRICAO": "Transtornos psicológicos e comportamentais associados ao desenvolvimento sexual e à sua orientação"
    },
    {
      "CAT": "F68",
      "DESCRICAO": "Outros transtornos da personalidade e do comportamento do adulto"
    },
    {
      "CAT": "F69",
      "DESCRICAO": "Transtorno da personalidade e do comportamento do adulto"
    },
    {
      "CAT": "F70",
      "DESCRICAO": "Retardo mental leve"
    },
    {
      "CAT": "F71",
      "DESCRICAO": "Retardo mental moderado"
    },
    {
      "CAT": "F72",
      "DESCRICAO": "Retardo mental grave"
    },
    {
      "CAT": "F73",
      "DESCRICAO": "Retardo mental profundo"
    },
    {
      "CAT": "F78",
      "DESCRICAO": "Outro retardo mental"
    },
    {
      "CAT": "F79",
      "DESCRICAO": "Retardo mental não especificado"
    },
    {
      "CAT": "F80",
      "DESCRICAO": "Transtornos específicos do desenvolvimento da fala e da linguagem"
    },
    {
      "CAT": "F81",
      "DESCRICAO": "Transtornos específicos do desenvolvimento das habilidades escolares"
    },
    {
      "CAT": "F82",
      "DESCRICAO": "Transtorno específico do desenvolvimento motor"
    },
    {
      "CAT": "F83",
      "DESCRICAO": "Transtornos específicos misto do desenvolvimento"
    },
    {
      "CAT": "F84",
      "DESCRICAO": "Transtornos globais do desenvolvimento"
    },
    {
      "CAT": "F88",
      "DESCRICAO": "Outros transtornos do desenvolvimento psicológico"
    },
    {
      "CAT": "F89",
      "DESCRICAO": "Transtorno do desenvolvimento psicológico não especificado"
    },
    {
      "CAT": "F90",
      "DESCRICAO": "Transtornos hipercinéticos"
    },
    {
      "CAT": "F91",
      "DESCRICAO": "Distúrbios de conduta"
    },
    {
      "CAT": "F92",
      "DESCRICAO": "Transtornos mistos de conduta e das emoções"
    },
    {
      "CAT": "F93",
      "DESCRICAO": "Transtornos emocionais com início especificamente na infância"
    },
    {
      "CAT": "F94",
      "DESCRICAO": "Transtornos do funcionamento social com início especificamente durante a infância ou a adolescência"
    },
    {
      "CAT": "F95",
      "DESCRICAO": "Tiques"
    },
    {
      "CAT": "F98",
      "DESCRICAO": "Outros transtornos comportamentais e emocionais com início habitualmente durante a infância ou a adolescência"
    },
    {
      "CAT": "F99",
      "DESCRICAO": "Transtorno mental não especificado em outra parte"
    },
    {
      "CAT": "G00",
      "DESCRICAO": "Meningite bacteriana não classificada em outra parte"
    },
    {
      "CAT": "G01",
      "DESCRICAO": "Meningite em doenças bacterianas classificadas em outra parte"
    },
    {
      "CAT": "G02",
      "DESCRICAO": "Meningite em outras doenças infecciosas e parasitárias classificadas em outra parte"
    },
    {
      "CAT": "G03",
      "DESCRICAO": "Meningite devida a outras causas e a causas não especificadas"
    },
    {
      "CAT": "G04",
      "DESCRICAO": "Encefalite"
    },
    {
      "CAT": "G05",
      "DESCRICAO": "Encefalite"
    },
    {
      "CAT": "G06",
      "DESCRICAO": "Abscesso e granuloma intracranianos e intra-raquidianos"
    },
    {
      "CAT": "G07",
      "DESCRICAO": "Abscesso e granuloma intracranianos e intraspinais em doenças classificadas em outra parte"
    },
    {
      "CAT": "G08",
      "DESCRICAO": "Flebite e tromboflebite intracranianas e intra-raquidianas"
    },
    {
      "CAT": "G09",
      "DESCRICAO": "Seqüelas de doenças inflamatórias do sistema nervoso central"
    },
    {
      "CAT": "G10",
      "DESCRICAO": "Doença de Huntington"
    },
    {
      "CAT": "G11",
      "DESCRICAO": "Ataxia hereditária"
    },
    {
      "CAT": "G12",
      "DESCRICAO": "Atrofia muscular espinal e síndromes correlatas"
    },
    {
      "CAT": "G13",
      "DESCRICAO": "Atrofias sistêmicas que afetam principalmente o sistema nervoso central em doenças classificadas em outra parte"
    },
    {
      "CAT": "G20",
      "DESCRICAO": "Doença de Parkinson"
    },
    {
      "CAT": "G21",
      "DESCRICAO": "Parkinsonismo secundário"
    },
    {
      "CAT": "G22",
      "DESCRICAO": "Parkinsonismo em doenças classificadas em outra parte"
    },
    {
      "CAT": "G23",
      "DESCRICAO": "Outras doenças degenerativas dos gânglios da base"
    },
    {
      "CAT": "G24",
      "DESCRICAO": "Distonia"
    },
    {
      "CAT": "G25",
      "DESCRICAO": "Outras doenças extrapiramidais e transtornos dos movimentos"
    },
    {
      "CAT": "G26",
      "DESCRICAO": "Doenças extrapiramidais e transtornos dos movimentos em doenças classificadas em outra parte"
    },
    {
      "CAT": "G30",
      "DESCRICAO": "Doença de Alzheimer"
    },
    {
      "CAT": "G31",
      "DESCRICAO": "Outras doenças degenerativas do sistema nervoso não classificadas em outra parte"
    },
    {
      "CAT": "G32",
      "DESCRICAO": "Outros transtornos degenerativos do sistema nervoso em doenças classificadas em outra parte"
    },
    {
      "CAT": "G35",
      "DESCRICAO": "Esclerose múltipla"
    },
    {
      "CAT": "G36",
      "DESCRICAO": "Outras desmielinizações disseminadas agudas"
    },
    {
      "CAT": "G37",
      "DESCRICAO": "Outras doenças desmielinizantes do sistema nervoso central"
    },
    {
      "CAT": "G40",
      "DESCRICAO": "Epilepsia"
    },
    {
      "CAT": "G41",
      "DESCRICAO": "Estado de mal epiléptico"
    },
    {
      "CAT": "G43",
      "DESCRICAO": "Enxaqueca"
    },
    {
      "CAT": "G44",
      "DESCRICAO": "Outras síndromes de algias cefálicas"
    },
    {
      "CAT": "G45",
      "DESCRICAO": "Acidentes vasculares cerebrais isquêmicos transitórios e síndromes correlatas"
    },
    {
      "CAT": "G46",
      "DESCRICAO": "Síndromes vasculares cerebrais que ocorrem em doenças cerebrovasculares"
    },
    {
      "CAT": "G47",
      "DESCRICAO": "Distúrbios do sono"
    },
    {
      "CAT": "G50",
      "DESCRICAO": "Transtornos do nervo trigêmeo"
    },
    {
      "CAT": "G51",
      "DESCRICAO": "Transtornos do nervo facial"
    },
    {
      "CAT": "G52",
      "DESCRICAO": "Transtornos de outros nervos cranianos"
    },
    {
      "CAT": "G53",
      "DESCRICAO": "Transtornos dos nervos cranianos em doenças classificadas em outra parte"
    },
    {
      "CAT": "G54",
      "DESCRICAO": "Transtornos das raízes e dos plexos nervosos"
    },
    {
      "CAT": "G55",
      "DESCRICAO": "Compressões das raízes e dos plexos nervosos em doenças classificadas em outra parte"
    },
    {
      "CAT": "G56",
      "DESCRICAO": "Mononeuropatias dos membros superiores"
    },
    {
      "CAT": "G57",
      "DESCRICAO": "Mononeuropatias dos membros inferiores"
    },
    {
      "CAT": "G58",
      "DESCRICAO": "Outras mononeuropatias"
    },
    {
      "CAT": "G59",
      "DESCRICAO": "Mononeuropatias em doenças classificadas em outra parte"
    },
    {
      "CAT": "G60",
      "DESCRICAO": "Neuropatia hereditária e idiopática"
    },
    {
      "CAT": "G61",
      "DESCRICAO": "Polineuropatia inflamatória"
    },
    {
      "CAT": "G62",
      "DESCRICAO": "Outras polineuropatias"
    },
    {
      "CAT": "G63",
      "DESCRICAO": "Polineuropatia em doenças classificadas em outra parte"
    },
    {
      "CAT": "G64",
      "DESCRICAO": "Outros transtornos do sistema nervoso periférico"
    },
    {
      "CAT": "G70",
      "DESCRICAO": "Miastenia gravis e outros transtornos neuromusculares"
    },
    {
      "CAT": "G71",
      "DESCRICAO": "Transtornos primários dos músculos"
    },
    {
      "CAT": "G72",
      "DESCRICAO": "Outras miopatias"
    },
    {
      "CAT": "G73",
      "DESCRICAO": "Transtornos da junção mioneural e dos músculos em doenças classificadas em outra parte"
    },
    {
      "CAT": "G80",
      "DESCRICAO": "Paralisia cerebral"
    },
    {
      "CAT": "G81",
      "DESCRICAO": "Hemiplegia"
    },
    {
      "CAT": "G82",
      "DESCRICAO": "Paraplegia e tetraplegia"
    },
    {
      "CAT": "G83",
      "DESCRICAO": "Outras síndromes paralíticas"
    },
    {
      "CAT": "G90",
      "DESCRICAO": "Transtornos do sistema nervoso autônomo"
    },
    {
      "CAT": "G91",
      "DESCRICAO": "Hidrocefalia"
    },
    {
      "CAT": "G92",
      "DESCRICAO": "Encefalopatia tóxica"
    },
    {
      "CAT": "G93",
      "DESCRICAO": "Outros transtornos do encéfalo"
    },
    {
      "CAT": "G94",
      "DESCRICAO": "Outros transtornos do encéfalo em doenças classificadas em outra parte"
    },
    {
      "CAT": "G95",
      "DESCRICAO": "Outras doenças da medula espinal"
    },
    {
      "CAT": "G96",
      "DESCRICAO": "Outros transtornos do sistema nervoso central"
    },
    {
      "CAT": "G97",
      "DESCRICAO": "Transtornos pós-procedimento do sistema nervoso não classificados em outra parte"
    },
    {
      "CAT": "G98",
      "DESCRICAO": "Outros transtornos do sistema nervoso não classificados em outra parte"
    },
    {
      "CAT": "G99",
      "DESCRICAO": "Outros transtornos do sistema nervoso em doenças classificadas em outra parte"
    },
    {
      "CAT": "H00",
      "DESCRICAO": "Hordéolo e calázio"
    },
    {
      "CAT": "H01",
      "DESCRICAO": "Outras inflamações da pálpebra"
    },
    {
      "CAT": "H02",
      "DESCRICAO": "Outros transtornos da pálpebra"
    },
    {
      "CAT": "H03",
      "DESCRICAO": "Transtornos da pálpebra em doenças classificadas em outras partes"
    },
    {
      "CAT": "H04",
      "DESCRICAO": "Transtornos do aparelho lacrimal"
    },
    {
      "CAT": "H05",
      "DESCRICAO": "Transtornos da órbita"
    },
    {
      "CAT": "H06",
      "DESCRICAO": "Transtornos do aparelho lacrimal e da órbita em doenças classificadas em outra parte"
    },
    {
      "CAT": "H10",
      "DESCRICAO": "Conjuntivite"
    },
    {
      "CAT": "H11",
      "DESCRICAO": "Outros transtornos da conjuntiva"
    },
    {
      "CAT": "H13",
      "DESCRICAO": "Transtornos da conjuntiva em doenças classificadas em outra parte"
    },
    {
      "CAT": "H15",
      "DESCRICAO": "Transtornos da esclerótica"
    },
    {
      "CAT": "H16",
      "DESCRICAO": "Ceratite"
    },
    {
      "CAT": "H17",
      "DESCRICAO": "Cicatrizes e opacidades da córnea"
    },
    {
      "CAT": "H18",
      "DESCRICAO": "Outros transtornos da córnea"
    },
    {
      "CAT": "H19",
      "DESCRICAO": "Transtorno da esclerótica e da córnea em doenças classificadas em outra parte"
    },
    {
      "CAT": "H20",
      "DESCRICAO": "Iridociclite"
    },
    {
      "CAT": "H21",
      "DESCRICAO": "Outros transtornos da íris e do corpo ciliar"
    },
    {
      "CAT": "H22",
      "DESCRICAO": "Transtornos da íris e do corpo ciliar em doenças classificadas em outra parte"
    },
    {
      "CAT": "H25",
      "DESCRICAO": "Catarata senil"
    },
    {
      "CAT": "H26",
      "DESCRICAO": "Outras cataratas"
    },
    {
      "CAT": "H27",
      "DESCRICAO": "Outros transtornos do cristalino"
    },
    {
      "CAT": "H28",
      "DESCRICAO": "Catarata e outros transtornos do cristalino em doenças classificadas em outra parte"
    },
    {
      "CAT": "H30",
      "DESCRICAO": "Inflamação coriorretiniana"
    },
    {
      "CAT": "H31",
      "DESCRICAO": "Outros transtornos da coróide"
    },
    {
      "CAT": "H32",
      "DESCRICAO": "Transtornos coriorretinianos em doenças classificadas em outra parte"
    },
    {
      "CAT": "H33",
      "DESCRICAO": "Descolamentos e defeitos da retina"
    },
    {
      "CAT": "H34",
      "DESCRICAO": "Oclusões vasculares da retina"
    },
    {
      "CAT": "H35",
      "DESCRICAO": "Outros transtornos da retina"
    },
    {
      "CAT": "H36",
      "DESCRICAO": "Transtornos da retina em doenças classificadas em outra parte"
    },
    {
      "CAT": "H40",
      "DESCRICAO": "Glaucoma"
    },
    {
      "CAT": "H42",
      "DESCRICAO": "Glaucoma em doenças classificadas em outra parte"
    },
    {
      "CAT": "H43",
      "DESCRICAO": "Transtornos do humor vítreo"
    },
    {
      "CAT": "H44",
      "DESCRICAO": "Transtornos do globo ocular"
    },
    {
      "CAT": "H45",
      "DESCRICAO": "Transtornos do humor vítreo e do globo ocular em doenças classificadas em outra parte"
    },
    {
      "CAT": "H46",
      "DESCRICAO": "Neurite óptica"
    },
    {
      "CAT": "H47",
      "DESCRICAO": "Outros transtornos do nervo óptico e das vias ópticas"
    },
    {
      "CAT": "H48",
      "DESCRICAO": "Transtornos do nervo óptico [segundo par] e das vias ópticas em doenças classificadas em outra parte"
    },
    {
      "CAT": "H49",
      "DESCRICAO": "Estrabismo paralítico"
    },
    {
      "CAT": "H50",
      "DESCRICAO": "Outros estrabismos"
    },
    {
      "CAT": "H51",
      "DESCRICAO": "Outros transtornos do movimento binocular"
    },
    {
      "CAT": "H52",
      "DESCRICAO": "Transtornos da refração e da acomodação"
    },
    {
      "CAT": "H53",
      "DESCRICAO": "Distúrbios visuais"
    },
    {
      "CAT": "H54",
      "DESCRICAO": "Cegueira e visão subnormal"
    },
    {
      "CAT": "H55",
      "DESCRICAO": "Nistagmo e outros movimentos irregulares do olho"
    },
    {
      "CAT": "H57",
      "DESCRICAO": "Outros transtornos do olho e anexos"
    },
    {
      "CAT": "H58",
      "DESCRICAO": "Outros transtornos do olho e anexos em doenças classificadas em outra parte"
    },
    {
      "CAT": "H59",
      "DESCRICAO": "Transtornos do olho e anexos pós-procedimento não classificados em outra parte"
    },
    {
      "CAT": "H60",
      "DESCRICAO": "Otite externa"
    },
    {
      "CAT": "H61",
      "DESCRICAO": "Outros transtornos do ouvido externo"
    },
    {
      "CAT": "H62",
      "DESCRICAO": "Transtornos do ouvido externo em doenças classificadas em outra parte"
    },
    {
      "CAT": "H65",
      "DESCRICAO": "Otite média não-supurativa"
    },
    {
      "CAT": "H66",
      "DESCRICAO": "Otite média supurativa e as não especificadas"
    },
    {
      "CAT": "H67",
      "DESCRICAO": "Otite média em doenças classificadas em outra parte"
    },
    {
      "CAT": "H68",
      "DESCRICAO": "Salpingite e obstrução da trompa de Eustáquio"
    },
    {
      "CAT": "H69",
      "DESCRICAO": "Outros transtornos da trompa de Eustáquio"
    },
    {
      "CAT": "H70",
      "DESCRICAO": "Mastoidite e afecções correlatas"
    },
    {
      "CAT": "H71",
      "DESCRICAO": "Colesteatoma do ouvido médio"
    },
    {
      "CAT": "H72",
      "DESCRICAO": "Perfuração da membrana do tímpano"
    },
    {
      "CAT": "H73",
      "DESCRICAO": "Outros transtornos da membrana do tímpano"
    },
    {
      "CAT": "H74",
      "DESCRICAO": "Outros transtornos do ouvido médio e da mastóide"
    },
    {
      "CAT": "H75",
      "DESCRICAO": "Outros transtornos do ouvido médio e da mastóide em doenças classificadas em outra parte"
    },
    {
      "CAT": "H80",
      "DESCRICAO": "Otosclerose"
    },
    {
      "CAT": "H81",
      "DESCRICAO": "Transtornos da função vestibular"
    },
    {
      "CAT": "H82",
      "DESCRICAO": "Síndromes vertiginosas em doenças classificadas em outra parte"
    },
    {
      "CAT": "H83",
      "DESCRICAO": "Outros transtornos do ouvido interno"
    },
    {
      "CAT": "H90",
      "DESCRICAO": "Perda de audição por transtorno de condução e/ou neuro-sensorial"
    },
    {
      "CAT": "H91",
      "DESCRICAO": "Outras perdas de audição"
    },
    {
      "CAT": "H92",
      "DESCRICAO": "Otalgia e secreção auditiva"
    },
    {
      "CAT": "H93",
      "DESCRICAO": "Outros transtornos do ouvido não classificados em outra parte"
    },
    {
      "CAT": "H94",
      "DESCRICAO": "Outros transtornos do ouvido em doenças classificadas em outra parte"
    },
    {
      "CAT": "H95",
      "DESCRICAO": "Transtornos do ouvido e da apófise mastóide pós-procedimentos"
    },
    {
      "CAT": "I00",
      "DESCRICAO": "Febre reumática sem menção de comprometimento do coração"
    },
    {
      "CAT": "I01",
      "DESCRICAO": "Febre reumática com comprometimento do coração"
    },
    {
      "CAT": "I02",
      "DESCRICAO": "Coréia reumática"
    },
    {
      "CAT": "I05",
      "DESCRICAO": "Doenças reumáticas da valva mitral"
    },
    {
      "CAT": "I06",
      "DESCRICAO": "Doenças reumáticas da valva aórtica"
    },
    {
      "CAT": "I07",
      "DESCRICAO": "Doenças reumáticas da valva tricúspide"
    },
    {
      "CAT": "I08",
      "DESCRICAO": "Doenças de múltiplas valvas"
    },
    {
      "CAT": "I09",
      "DESCRICAO": "Outras doenças reumáticas do coração"
    },
    {
      "CAT": "I10",
      "DESCRICAO": "Hipertensão essencial (primária)"
    },
    {
      "CAT": "I11",
      "DESCRICAO": "Doença cardíaca hipertensiva"
    },
    {
      "CAT": "I12",
      "DESCRICAO": "Doença renal hipertensiva"
    },
    {
      "CAT": "I13",
      "DESCRICAO": "Doença cardíaca e renal hipertensiva"
    },
    {
      "CAT": "I15",
      "DESCRICAO": "Hipertensão secundária"
    },
    {
      "CAT": "I20",
      "DESCRICAO": "Angina pectoris"
    },
    {
      "CAT": "I21",
      "DESCRICAO": "Infarto agudo do miocárdio"
    },
    {
      "CAT": "I22",
      "DESCRICAO": "Infarto do miocárdio recorrente"
    },
    {
      "CAT": "I23",
      "DESCRICAO": "Algumas complicações atuais subseqüentes ao infarto agudo do miocárdio"
    },
    {
      "CAT": "I24",
      "DESCRICAO": "Outras doenças isquêmicas agudas do coração"
    },
    {
      "CAT": "I25",
      "DESCRICAO": "Doença isquêmica crônica do coração"
    },
    {
      "CAT": "I26",
      "DESCRICAO": "Embolia pulmonar"
    },
    {
      "CAT": "I27",
      "DESCRICAO": "Outras formas de doença cardíaca pulmonar"
    },
    {
      "CAT": "I28",
      "DESCRICAO": "Outras doenças dos vasos pulmonares"
    },
    {
      "CAT": "I30",
      "DESCRICAO": "Pericardite aguda"
    },
    {
      "CAT": "I31",
      "DESCRICAO": "Outras doenças do pericárdio"
    },
    {
      "CAT": "I32",
      "DESCRICAO": "Pericardite em doenças classificadas em outra parte"
    },
    {
      "CAT": "I33",
      "DESCRICAO": "Endocardite aguda e subaguda"
    },
    {
      "CAT": "I34",
      "DESCRICAO": "Transtornos não-reumáticos da valva mitral"
    },
    {
      "CAT": "I35",
      "DESCRICAO": "Transtornos não-reumáticos da valva aórtica"
    },
    {
      "CAT": "I36",
      "DESCRICAO": "Transtornos não-reumáticos da valva tricúspide"
    },
    {
      "CAT": "I37",
      "DESCRICAO": "Transtornos da valva pulmonar"
    },
    {
      "CAT": "I38",
      "DESCRICAO": "Endocardite de valva não especificada"
    },
    {
      "CAT": "I39",
      "DESCRICAO": "Endocardite e transtornos valvulares cardíacos em doenças classificadas em outra parte"
    },
    {
      "CAT": "I40",
      "DESCRICAO": "Miocardite aguda"
    },
    {
      "CAT": "I41",
      "DESCRICAO": "Miocardite em doenças classificadas em outra parte"
    },
    {
      "CAT": "I42",
      "DESCRICAO": "Cardiomiopatias"
    },
    {
      "CAT": "I43",
      "DESCRICAO": "Cardiomiopatia em doenças classificadas em outra parte"
    },
    {
      "CAT": "I44",
      "DESCRICAO": "Bloqueio atrioventricular e do ramo esquerdo"
    },
    {
      "CAT": "I45",
      "DESCRICAO": "Outros transtornos de condução"
    },
    {
      "CAT": "I46",
      "DESCRICAO": "Parada cardíaca"
    },
    {
      "CAT": "I47",
      "DESCRICAO": "Taquicardia paroxística"
    },
    {
      "CAT": "I48",
      "DESCRICAO": "Flutter\" e fibrilação atrial"
    },
    {
      "CAT": "I49",
      "DESCRICAO": "Outras arritmias cardíacas"
    },
    {
      "CAT": "I50",
      "DESCRICAO": "Insuficiência cardíaca"
    },
    {
      "CAT": "I51",
      "DESCRICAO": "Complicações de cardiopatias e doenças cardíacas mal definidas"
    },
    {
      "CAT": "I52",
      "DESCRICAO": "Outras afecções cardíacas em doenças classificadas em outra parte"
    },
    {
      "CAT": "I60",
      "DESCRICAO": "Hemorragia subaracnóide"
    },
    {
      "CAT": "I61",
      "DESCRICAO": "Hemorragia intracerebral"
    },
    {
      "CAT": "I62",
      "DESCRICAO": "Outras hemorragias intracranianas não-traumáticas"
    },
    {
      "CAT": "I63",
      "DESCRICAO": "Infarto cerebral"
    },
    {
      "CAT": "I64",
      "DESCRICAO": "Acidente vascular cerebral"
    },
    {
      "CAT": "I65",
      "DESCRICAO": "Oclusão e estenose de artérias pré-cerebrais que não resultam em infarto cerebral"
    },
    {
      "CAT": "I66",
      "DESCRICAO": "Oclusão e estenose de artérias cerebrais que não resultam em infarto cerebral"
    },
    {
      "CAT": "I67",
      "DESCRICAO": "Outras doenças cerebrovasculares"
    },
    {
      "CAT": "I68",
      "DESCRICAO": "Transtornos cerebrovasculares em doenças classificadas em outra parte"
    },
    {
      "CAT": "I69",
      "DESCRICAO": "Seqüelas de doenças cerebrovasculares"
    },
    {
      "CAT": "I70",
      "DESCRICAO": "Aterosclerose"
    },
    {
      "CAT": "I71",
      "DESCRICAO": "Aneurisma e dissecção da aorta"
    },
    {
      "CAT": "I72",
      "DESCRICAO": "Outros aneurismas"
    },
    {
      "CAT": "I73",
      "DESCRICAO": "Outras doenças vasculares periféricas"
    },
    {
      "CAT": "I74",
      "DESCRICAO": "Embolia e trombose arteriais"
    },
    {
      "CAT": "I77",
      "DESCRICAO": "Outras afecções das artérias e arteríolas"
    },
    {
      "CAT": "I78",
      "DESCRICAO": "Doenças dos capilares"
    },
    {
      "CAT": "I79",
      "DESCRICAO": "Transtornos das artérias"
    },
    {
      "CAT": "I80",
      "DESCRICAO": "Flebite e tromboflebite"
    },
    {
      "CAT": "I81",
      "DESCRICAO": "Trombose da veia porta"
    },
    {
      "CAT": "I82",
      "DESCRICAO": "Outra embolia e trombose venosas"
    },
    {
      "CAT": "I83",
      "DESCRICAO": "Varizes dos membros inferiores"
    },
    {
      "CAT": "I84",
      "DESCRICAO": "Hemorróidas"
    },
    {
      "CAT": "I85",
      "DESCRICAO": "Varizes esofagianas"
    },
    {
      "CAT": "I86",
      "DESCRICAO": "Varizes de outras localizações"
    },
    {
      "CAT": "I87",
      "DESCRICAO": "Outros transtornos das veias"
    },
    {
      "CAT": "I88",
      "DESCRICAO": "Linfadenite inespecífica"
    },
    {
      "CAT": "I89",
      "DESCRICAO": "Outros transtornos não-infecciosos dos vasos linfáticos e dos gânglios linfáticos"
    },
    {
      "CAT": "I95",
      "DESCRICAO": "Hipotensão"
    },
    {
      "CAT": "I97",
      "DESCRICAO": "Transtornos do aparelho circulatório"
    },
    {
      "CAT": "I98",
      "DESCRICAO": "Outros transtornos do aparelho circulatório em doenças classificadas em outra parte"
    },
    {
      "CAT": "I99",
      "DESCRICAO": "Outros transtornos do aparelho circulatório e os não especificados"
    },
    {
      "CAT": "J00",
      "DESCRICAO": "Nasofaringite aguda [resfriado comum]"
    },
    {
      "CAT": "J01",
      "DESCRICAO": "Sinusite aguda"
    },
    {
      "CAT": "J02",
      "DESCRICAO": "Faringite aguda"
    },
    {
      "CAT": "J03",
      "DESCRICAO": "Amigdalite aguda"
    },
    {
      "CAT": "J04",
      "DESCRICAO": "Laringite e traqueíte agudas"
    },
    {
      "CAT": "J05",
      "DESCRICAO": "Laringite obstrutiva aguda [crupe] e epiglotite"
    },
    {
      "CAT": "J06",
      "DESCRICAO": "Infecções agudas das vias aéreas superiores de localizações múltiplas e não especificadas"
    },
    {
      "CAT": "J09",
      "DESCRICAO": "Influenza [gripe] devida a vírus identificado da gripe aviária"
    },
    {
      "CAT": "J10",
      "DESCRICAO": "Influenza devida a outro vírus da influenza [gripe] identificado"
    },
    {
      "CAT": "J11",
      "DESCRICAO": "Influenza [gripe] devida a vírus não identificado"
    },
    {
      "CAT": "J12",
      "DESCRICAO": "Pneumonia viral não classificada em outra parte"
    },
    {
      "CAT": "J13",
      "DESCRICAO": "Pneumonia devida a Streptococcus pneumoniae"
    },
    {
      "CAT": "J14",
      "DESCRICAO": "Pneumonia devida a Haemophilus infuenzae"
    },
    {
      "CAT": "J15",
      "DESCRICAO": "Pneumonia bacteriana não classificada em outra parte"
    },
    {
      "CAT": "J16",
      "DESCRICAO": "Pneumonia devida a outros microorganismos infecciosos especificados não classificados em outra parte"
    },
    {
      "CAT": "J17",
      "DESCRICAO": "Pneumonia em doenças classificadas em outra parte"
    },
    {
      "CAT": "J18",
      "DESCRICAO": "Pneumonia por microorganismo não especificada"
    },
    {
      "CAT": "J20",
      "DESCRICAO": "Bronquite aguda"
    },
    {
      "CAT": "J21",
      "DESCRICAO": "Bronquiolite aguda"
    },
    {
      "CAT": "J22",
      "DESCRICAO": "Infecções agudas não especificada das vias aéreas inferiores"
    },
    {
      "CAT": "J30",
      "DESCRICAO": "Rinite alérgica e vasomotora"
    },
    {
      "CAT": "J31",
      "DESCRICAO": "Rinite"
    },
    {
      "CAT": "J32",
      "DESCRICAO": "Sinusite crônica"
    },
    {
      "CAT": "J33",
      "DESCRICAO": "Pólipo nasal"
    },
    {
      "CAT": "J34",
      "DESCRICAO": "Outros transtornos do nariz e dos seios paranasais"
    },
    {
      "CAT": "J35",
      "DESCRICAO": "Doenças crônicas das amígdalas e das adenóides"
    },
    {
      "CAT": "J36",
      "DESCRICAO": "Abscesso periamigdaliano"
    },
    {
      "CAT": "J37",
      "DESCRICAO": "Laringite e laringotraqueíte crônicas"
    },
    {
      "CAT": "J38",
      "DESCRICAO": "Doenças das cordas vocais e da laringe não classificadas em outra parte"
    },
    {
      "CAT": "J39",
      "DESCRICAO": "Outras doenças das vias aéreas superiores"
    },
    {
      "CAT": "J40",
      "DESCRICAO": "Bronquite não especificada como aguda ou crônica"
    },
    {
      "CAT": "J41",
      "DESCRICAO": "Bronquite crônica simples e a mucopurulenta"
    },
    {
      "CAT": "J42",
      "DESCRICAO": "Bronquite crônica não especificada"
    },
    {
      "CAT": "J43",
      "DESCRICAO": "Enfisema"
    },
    {
      "CAT": "J44",
      "DESCRICAO": "Outras doenças pulmonares obstrutivas crônicas"
    },
    {
      "CAT": "J45",
      "DESCRICAO": "Asma"
    },
    {
      "CAT": "J46",
      "DESCRICAO": "Estado de mal asmático"
    },
    {
      "CAT": "J47",
      "DESCRICAO": "Bronquectasia"
    },
    {
      "CAT": "J60",
      "DESCRICAO": "Pneumoconiose dos mineiros de carvão"
    },
    {
      "CAT": "J61",
      "DESCRICAO": "Pneumoconiose devida a amianto [asbesto] e outras fibras minerais"
    },
    {
      "CAT": "J62",
      "DESCRICAO": "Pneumoconiose devida a poeira que contenham sílica"
    },
    {
      "CAT": "J63",
      "DESCRICAO": "Pneumoconiose devida a outras poeiras inorgânicas"
    },
    {
      "CAT": "J64",
      "DESCRICAO": "Pneumoconiose não especificada"
    },
    {
      "CAT": "J65",
      "DESCRICAO": "Pneumoconiose associada com tuberculose"
    },
    {
      "CAT": "J66",
      "DESCRICAO": "Doenças das vias aéreas devida a poeiras orgânicas específicas"
    },
    {
      "CAT": "J67",
      "DESCRICAO": "Pneumonite de hipersensibilidade devida a poeiras orgânicas"
    },
    {
      "CAT": "J68",
      "DESCRICAO": "Afecções respiratórias devidas a inalação de produtos químicos"
    },
    {
      "CAT": "J69",
      "DESCRICAO": "Pneumonite devida a sólidos e líquidos"
    },
    {
      "CAT": "J70",
      "DESCRICAO": "Afecções respiratórias devida a outros agentes externos"
    },
    {
      "CAT": "J80",
      "DESCRICAO": "Síndrome do desconforto respiratório do adulto"
    },
    {
      "CAT": "J81",
      "DESCRICAO": "Edema pulmonar"
    },
    {
      "CAT": "J82",
      "DESCRICAO": "Eosinofilia pulmonar"
    },
    {
      "CAT": "J84",
      "DESCRICAO": "Outras doenças pulmonares intersticiais"
    },
    {
      "CAT": "J85",
      "DESCRICAO": "Abscesso do pulmão e do mediastino"
    },
    {
      "CAT": "J86",
      "DESCRICAO": "Piotórax"
    },
    {
      "CAT": "J90",
      "DESCRICAO": "Derrame pleural não classificado em outra parte"
    },
    {
      "CAT": "J91",
      "DESCRICAO": "Derrame pleural em afecções classificadas em outra parte"
    },
    {
      "CAT": "J92",
      "DESCRICAO": "Placas pleurais"
    },
    {
      "CAT": "J93",
      "DESCRICAO": "Pneumotórax"
    },
    {
      "CAT": "J94",
      "DESCRICAO": "Outras afecções pleurais"
    },
    {
      "CAT": "J95",
      "DESCRICAO": "Afecções respiratórias pós-procedimentos não classificadas em outra parte"
    },
    {
      "CAT": "J96",
      "DESCRICAO": "Insuficiência respiratória não classificada de outra parte"
    },
    {
      "CAT": "J98",
      "DESCRICAO": "Outros transtornos respiratórios"
    },
    {
      "CAT": "J99",
      "DESCRICAO": "Transtornos respiratórios em doenças classificadas em outra parte"
    },
    {
      "CAT": "K00",
      "DESCRICAO": "Distúrbios do desenvolvimento e da erupção dos dentes"
    },
    {
      "CAT": "K01",
      "DESCRICAO": "Dentes inclusos e impactados"
    },
    {
      "CAT": "K02",
      "DESCRICAO": "Cárie dentária"
    },
    {
      "CAT": "K03",
      "DESCRICAO": "Outras doenças dos tecidos dentários duros"
    },
    {
      "CAT": "K04",
      "DESCRICAO": "Doenças da polpa e dos tecidos periapicais"
    },
    {
      "CAT": "K05",
      "DESCRICAO": "Gengivite e doenças periodontais"
    },
    {
      "CAT": "K06",
      "DESCRICAO": "Outros transtornos da gengiva e do rebordo alveolar sem dentes"
    },
    {
      "CAT": "K07",
      "DESCRICAO": "Anomalias dentofaciais (inclusive a maloclusão)"
    },
    {
      "CAT": "K08",
      "DESCRICAO": "Outros transtornos dos dentes e de suas estruturas de sustentação"
    },
    {
      "CAT": "K09",
      "DESCRICAO": "Cistos da região bucal não classificados em outra parte"
    },
    {
      "CAT": "K10",
      "DESCRICAO": "Outras doenças dos maxilares"
    },
    {
      "CAT": "K11",
      "DESCRICAO": "Doenças das glândulas salivares"
    },
    {
      "CAT": "K12",
      "DESCRICAO": "Estomatite e lesões correlatas"
    },
    {
      "CAT": "K13",
      "DESCRICAO": "Outras doenças do lábio e da mucosa oral"
    },
    {
      "CAT": "K14",
      "DESCRICAO": "Doenças da língua"
    },
    {
      "CAT": "K20",
      "DESCRICAO": "Esofagite"
    },
    {
      "CAT": "K21",
      "DESCRICAO": "Doença de refluxo gastroesofágico"
    },
    {
      "CAT": "K22",
      "DESCRICAO": "Outras doenças do esôfago"
    },
    {
      "CAT": "K23",
      "DESCRICAO": "Transtornos do esôfago em doenças classificadas em outra parte"
    },
    {
      "CAT": "K25",
      "DESCRICAO": "Úlcera gástrica"
    },
    {
      "CAT": "K26",
      "DESCRICAO": "Úlcera duodenal"
    },
    {
      "CAT": "K27",
      "DESCRICAO": "Úlcera péptica de localização não especificada"
    },
    {
      "CAT": "K28",
      "DESCRICAO": "Úlcera gastrojejunal"
    },
    {
      "CAT": "K29",
      "DESCRICAO": "Gastrite e duodenite"
    },
    {
      "CAT": "K30",
      "DESCRICAO": "Dispepsia"
    },
    {
      "CAT": "K31",
      "DESCRICAO": "Outras doenças do estômago e do duodeno"
    },
    {
      "CAT": "K35",
      "DESCRICAO": "Apendicite aguda"
    },
    {
      "CAT": "K36",
      "DESCRICAO": "Outras formas de apendicite"
    },
    {
      "CAT": "K37",
      "DESCRICAO": "Apendicite"
    },
    {
      "CAT": "K38",
      "DESCRICAO": "Outras doenças do apêndice"
    },
    {
      "CAT": "K40",
      "DESCRICAO": "Hérnia inguinal"
    },
    {
      "CAT": "K41",
      "DESCRICAO": "Hérnia femoral"
    },
    {
      "CAT": "K42",
      "DESCRICAO": "Hérnia umbilical"
    },
    {
      "CAT": "K43",
      "DESCRICAO": "Hérnia ventral"
    },
    {
      "CAT": "K44",
      "DESCRICAO": "Hérnia diafragmática"
    },
    {
      "CAT": "K45",
      "DESCRICAO": "Outras hérnias abdominais"
    },
    {
      "CAT": "K46",
      "DESCRICAO": "Hérnia abdominal não especificada"
    },
    {
      "CAT": "K50",
      "DESCRICAO": "Doença de Crohn [enterite regional]"
    },
    {
      "CAT": "K51",
      "DESCRICAO": "Colite ulcerativa"
    },
    {
      "CAT": "K52",
      "DESCRICAO": "Outras gastroenterites e colites não-infecciosas"
    },
    {
      "CAT": "K55",
      "DESCRICAO": "Transtornos vasculares do intestino"
    },
    {
      "CAT": "K56",
      "DESCRICAO": "Íleo paralítico e obstrução intestinal sem hérnia"
    },
    {
      "CAT": "K57",
      "DESCRICAO": "Doença diverticular do intestino"
    },
    {
      "CAT": "K58",
      "DESCRICAO": "Síndrome do cólon irritável"
    },
    {
      "CAT": "K59",
      "DESCRICAO": "Outros transtornos funcionais do intestino"
    },
    {
      "CAT": "K60",
      "DESCRICAO": "Fissura e fístula das regiões anal e retal"
    },
    {
      "CAT": "K61",
      "DESCRICAO": "Abscesso das regiões anal e retal"
    },
    {
      "CAT": "K62",
      "DESCRICAO": "Outras doenças do reto e do ânus"
    },
    {
      "CAT": "K63",
      "DESCRICAO": "Outras doenças do intestino"
    },
    {
      "CAT": "K65",
      "DESCRICAO": "Peritonite"
    },
    {
      "CAT": "K66",
      "DESCRICAO": "Outros transtornos do peritônio"
    },
    {
      "CAT": "K67",
      "DESCRICAO": "Comprometimento do peritônio"
    },
    {
      "CAT": "K70",
      "DESCRICAO": "Doença alcoólica do fígado"
    },
    {
      "CAT": "K71",
      "DESCRICAO": "Doença hepática tóxica"
    },
    {
      "CAT": "K72",
      "DESCRICAO": "Insuficiência hepática não classificada em outra parte"
    },
    {
      "CAT": "K73",
      "DESCRICAO": "Hepatite crônica não classificada em outra parte"
    },
    {
      "CAT": "K74",
      "DESCRICAO": "Fibrose e cirrose hepáticas"
    },
    {
      "CAT": "K75",
      "DESCRICAO": "Outras doenças inflamatórias do fígado"
    },
    {
      "CAT": "K76",
      "DESCRICAO": "Outras doenças do fígado"
    },
    {
      "CAT": "K77",
      "DESCRICAO": "Transtornos do fígado em doenças classificadas em outra parte"
    },
    {
      "CAT": "K80",
      "DESCRICAO": "Colelitíase"
    },
    {
      "CAT": "K81",
      "DESCRICAO": "Colecistite"
    },
    {
      "CAT": "K82",
      "DESCRICAO": "Outras doenças da vesícula biliar"
    },
    {
      "CAT": "K83",
      "DESCRICAO": "Outras doenças das vias biliares"
    },
    {
      "CAT": "K85",
      "DESCRICAO": "Pancreatite aguda"
    },
    {
      "CAT": "K86",
      "DESCRICAO": "Outras doenças do pâncreas"
    },
    {
      "CAT": "K87",
      "DESCRICAO": "Transtornos da vesícula biliar"
    },
    {
      "CAT": "K90",
      "DESCRICAO": "Má-absorção intestinal"
    },
    {
      "CAT": "K91",
      "DESCRICAO": "Transtornos do aparelho digestivo pós-procedimentos"
    },
    {
      "CAT": "K92",
      "DESCRICAO": "Outras doenças do aparelho digestivo"
    },
    {
      "CAT": "K93",
      "DESCRICAO": "Transtornos de outros órgãos digestivos em doenças classificadas em outra parte"
    },
    {
      "CAT": "L00",
      "DESCRICAO": "Síndrome da pele escaldada estafilocócica do recém-nascido"
    },
    {
      "CAT": "L01",
      "DESCRICAO": "Impetigo"
    },
    {
      "CAT": "L02",
      "DESCRICAO": "Abscesso cutâneo"
    },
    {
      "CAT": "L03",
      "DESCRICAO": "Celulite (Flegmão)"
    },
    {
      "CAT": "L04",
      "DESCRICAO": "Linfadenite aguda"
    },
    {
      "CAT": "L05",
      "DESCRICAO": "Cisto pilonidal"
    },
    {
      "CAT": "L08",
      "DESCRICAO": "Outras infecções localizadas da pele e do tecido subcutâneo"
    },
    {
      "CAT": "L10",
      "DESCRICAO": "Pênfigo"
    },
    {
      "CAT": "L11",
      "DESCRICAO": "Outras afecções acantolíticas"
    },
    {
      "CAT": "L12",
      "DESCRICAO": "Penfigóide"
    },
    {
      "CAT": "L13",
      "DESCRICAO": "Outras afecções bolhosas"
    },
    {
      "CAT": "L14",
      "DESCRICAO": "Afecções bolhosas em doenças classificadas em outra parte"
    },
    {
      "CAT": "L20",
      "DESCRICAO": "Dermatite atópica"
    },
    {
      "CAT": "L21",
      "DESCRICAO": "Dermatite seborréica"
    },
    {
      "CAT": "L22",
      "DESCRICAO": "Dermatite das fraldas"
    },
    {
      "CAT": "L23",
      "DESCRICAO": "Dermatites alérgicas de contato"
    },
    {
      "CAT": "L24",
      "DESCRICAO": "Dermatites de contato por irritantes"
    },
    {
      "CAT": "L25",
      "DESCRICAO": "Dermatite de contato não especificada"
    },
    {
      "CAT": "L26",
      "DESCRICAO": "Dermatite esfoliativa"
    },
    {
      "CAT": "L27",
      "DESCRICAO": "Dermatite devida a substâncias de uso interno"
    },
    {
      "CAT": "L28",
      "DESCRICAO": "Líquen simples crônico e prurigo"
    },
    {
      "CAT": "L29",
      "DESCRICAO": "Prurido"
    },
    {
      "CAT": "L30",
      "DESCRICAO": "Outras dermatites"
    },
    {
      "CAT": "L40",
      "DESCRICAO": "Psoríase"
    },
    {
      "CAT": "L41",
      "DESCRICAO": "Parapsoríase"
    },
    {
      "CAT": "L42",
      "DESCRICAO": "Pitiríase rósea"
    },
    {
      "CAT": "L43",
      "DESCRICAO": "Líquen plano"
    },
    {
      "CAT": "L44",
      "DESCRICAO": "Outras afecções pápulo-descamativas"
    },
    {
      "CAT": "L45",
      "DESCRICAO": "Afecções pápulo-descamativas em doenças classificadas em outra parte"
    },
    {
      "CAT": "L50",
      "DESCRICAO": "Urticária"
    },
    {
      "CAT": "L51",
      "DESCRICAO": "Eritema polimorfo (eritema multiforme)"
    },
    {
      "CAT": "L52",
      "DESCRICAO": "Eritema nodoso"
    },
    {
      "CAT": "L53",
      "DESCRICAO": "Outras afecções eritematosas"
    },
    {
      "CAT": "L54",
      "DESCRICAO": "Eritema em doenças classificadas em outra parte"
    },
    {
      "CAT": "L55",
      "DESCRICAO": "Queimadura solar"
    },
    {
      "CAT": "L56",
      "DESCRICAO": "Outras alterações agudas da pele devidas a radiação ultravioleta"
    },
    {
      "CAT": "L57",
      "DESCRICAO": "Alterações da pele devidas à exposição crônica à radiação não ionizante"
    },
    {
      "CAT": "L58",
      "DESCRICAO": "Radiodermatite"
    },
    {
      "CAT": "L59",
      "DESCRICAO": "Outras afecções da pele e do tecido subcutâneo relacionadas com a radiação"
    },
    {
      "CAT": "L60",
      "DESCRICAO": "Afecções das unhas"
    },
    {
      "CAT": "L62",
      "DESCRICAO": "Afecções das unhas em doenças classificadas em outra parte"
    },
    {
      "CAT": "L63",
      "DESCRICAO": "Alopécia areata"
    },
    {
      "CAT": "L64",
      "DESCRICAO": "Alopécia androgênica"
    },
    {
      "CAT": "L65",
      "DESCRICAO": "Outras formas não cicatriciais da perda de cabelos ou pêlos"
    },
    {
      "CAT": "L66",
      "DESCRICAO": "Alopécia cicatricial [perda de cabelos ou pêlos"
    },
    {
      "CAT": "L67",
      "DESCRICAO": "Anormalidades da cor e do pedículo dos cabelos e dos pêlos"
    },
    {
      "CAT": "L68",
      "DESCRICAO": "Hipertricose"
    },
    {
      "CAT": "L70",
      "DESCRICAO": "Acne"
    },
    {
      "CAT": "L71",
      "DESCRICAO": "Rosácea"
    },
    {
      "CAT": "L72",
      "DESCRICAO": "Cistos foliculares da pele e do tecido subcutâneo"
    },
    {
      "CAT": "L73",
      "DESCRICAO": "Outras afecções foliculares"
    },
    {
      "CAT": "L74",
      "DESCRICAO": "Afecções das glândulas sudoríparas écrinas"
    },
    {
      "CAT": "L75",
      "DESCRICAO": "Afecções das glândulas sudoríparas apócrinas"
    },
    {
      "CAT": "L80",
      "DESCRICAO": "Vitiligo"
    },
    {
      "CAT": "L81",
      "DESCRICAO": "Outros transtornos da pigmentação"
    },
    {
      "CAT": "L82",
      "DESCRICAO": "Ceratose seborréica"
    },
    {
      "CAT": "L83",
      "DESCRICAO": "Acantose nigricans"
    },
    {
      "CAT": "L84",
      "DESCRICAO": "Calos e calosidades"
    },
    {
      "CAT": "L85",
      "DESCRICAO": "Outras formas de espessamento epidérmico"
    },
    {
      "CAT": "L86",
      "DESCRICAO": "Ceratodermia em doenças classificadas em outra parte"
    },
    {
      "CAT": "L87",
      "DESCRICAO": "Transtornos da eliminação transepidérmica"
    },
    {
      "CAT": "L88",
      "DESCRICAO": "Piodermite gangrenosa"
    },
    {
      "CAT": "L89",
      "DESCRICAO": "Úlcera de decúbito"
    },
    {
      "CAT": "L90",
      "DESCRICAO": "Afecções atróficas da pele"
    },
    {
      "CAT": "L91",
      "DESCRICAO": "Afecções hipertróficas da pele"
    },
    {
      "CAT": "L92",
      "DESCRICAO": "Afecções granulomatosas da pele e do tecido subcutâneo"
    },
    {
      "CAT": "L93",
      "DESCRICAO": "Lúpus eritematoso"
    },
    {
      "CAT": "L94",
      "DESCRICAO": "Outras afecções localizadas do tecido conjuntivo"
    },
    {
      "CAT": "L95",
      "DESCRICAO": "Vasculite limitada a pele não classificadas em outra parte"
    },
    {
      "CAT": "L97",
      "DESCRICAO": "Úlcera dos membros inferiores não classificada em outra parte"
    },
    {
      "CAT": "L98",
      "DESCRICAO": "Outras afecções da pele e do tecido subcutâneo não classificadas em outra parte"
    },
    {
      "CAT": "L99",
      "DESCRICAO": "Outras afecções da pele e do tecido subcutâneo em doenças classificadas em outra parte"
    },
    {
      "CAT": "M00",
      "DESCRICAO": "Artrite piogênica"
    },
    {
      "CAT": "M01",
      "DESCRICAO": "Infecções diretas da articulação em doenças infecciosas e parasitárias classificadas em outra parte"
    },
    {
      "CAT": "M02",
      "DESCRICAO": "Artropatias reacionais"
    },
    {
      "CAT": "M03",
      "DESCRICAO": "Artropatias pós-infecciosas e reacionais em doenças infecciosas classificadas em outra parte"
    },
    {
      "CAT": "M05",
      "DESCRICAO": "Artrite reumatóide soro-positiva"
    },
    {
      "CAT": "M06",
      "DESCRICAO": "Outras artrites reumatóides"
    },
    {
      "CAT": "M07",
      "DESCRICAO": "Artropatias psoriásicas e enteropáticas"
    },
    {
      "CAT": "M08",
      "DESCRICAO": "Artrite juvenil"
    },
    {
      "CAT": "M09",
      "DESCRICAO": "Artrite juvenil em doenças classificadas em outra parte"
    },
    {
      "CAT": "M10",
      "DESCRICAO": "Gota"
    },
    {
      "CAT": "M11",
      "DESCRICAO": "Outras artropatias por deposição de cristais"
    },
    {
      "CAT": "M12",
      "DESCRICAO": "Outras artropatias especificadas"
    },
    {
      "CAT": "M13",
      "DESCRICAO": "Outras artrites"
    },
    {
      "CAT": "M14",
      "DESCRICAO": "Artropatias em outras doenças classificadas em outra parte"
    },
    {
      "CAT": "M15",
      "DESCRICAO": "Poliartrose"
    },
    {
      "CAT": "M16",
      "DESCRICAO": "Coxartrose [artrose do quadril]"
    },
    {
      "CAT": "M17",
      "DESCRICAO": "Gonartrose [artrose do joelho]"
    },
    {
      "CAT": "M18",
      "DESCRICAO": "Artrose da primeira articulação carpometacarpiana"
    },
    {
      "CAT": "M19",
      "DESCRICAO": "Outras artroses"
    },
    {
      "CAT": "M20",
      "DESCRICAO": "Deformidades adquiridas dos dedos das mãos e dos pés"
    },
    {
      "CAT": "M21",
      "DESCRICAO": "Outras deformidades adquiridas dos membros"
    },
    {
      "CAT": "M22",
      "DESCRICAO": "Transtornos da rótula [patela]"
    },
    {
      "CAT": "M23",
      "DESCRICAO": "Transtornos internos dos joelhos"
    },
    {
      "CAT": "M24",
      "DESCRICAO": "Outros transtornos articulares específicos"
    },
    {
      "CAT": "M25",
      "DESCRICAO": "Outros transtornos articulares não classificados em outra parte"
    },
    {
      "CAT": "M30",
      "DESCRICAO": "Poliarterite nodosa e afecções correlatas"
    },
    {
      "CAT": "M31",
      "DESCRICAO": "Outras vasculopatias necrotizantes"
    },
    {
      "CAT": "M32",
      "DESCRICAO": "Lúpus eritematoso disseminado [sistêmico]"
    },
    {
      "CAT": "M33",
      "DESCRICAO": "Dermatopoliomiosite"
    },
    {
      "CAT": "M34",
      "DESCRICAO": "Esclerose sistêmica"
    },
    {
      "CAT": "M35",
      "DESCRICAO": "Outras afecções sistêmicas do tecido conjuntivo"
    },
    {
      "CAT": "M36",
      "DESCRICAO": "Doenças sistêmicas do tecido conjuntivo em doenças classificadas em outra parte"
    },
    {
      "CAT": "M40",
      "DESCRICAO": "Cifose e lordose"
    },
    {
      "CAT": "M41",
      "DESCRICAO": "Escoliose"
    },
    {
      "CAT": "M42",
      "DESCRICAO": "Osteocondrose da coluna vertebral"
    },
    {
      "CAT": "M43",
      "DESCRICAO": "Outras dorsopatias deformantes"
    },
    {
      "CAT": "M45",
      "DESCRICAO": "Espondilite ancilosante"
    },
    {
      "CAT": "M46",
      "DESCRICAO": "Outras espondilopatias inflamatórias"
    },
    {
      "CAT": "M47",
      "DESCRICAO": "Espondilose"
    },
    {
      "CAT": "M48",
      "DESCRICAO": "Outras espondilopatias"
    },
    {
      "CAT": "M49",
      "DESCRICAO": "Espondilopatias em doenças classificadas em outra parte"
    },
    {
      "CAT": "M50",
      "DESCRICAO": "Transtornos dos discos cervicais"
    },
    {
      "CAT": "M51",
      "DESCRICAO": "Outros transtornos de discos intervertebrais"
    },
    {
      "CAT": "M53",
      "DESCRICAO": "Outras dorsopatias não classificadas em outra parte"
    },
    {
      "CAT": "M54",
      "DESCRICAO": "Dorsalgia"
    },
    {
      "CAT": "M60",
      "DESCRICAO": "Miosite"
    },
    {
      "CAT": "M61",
      "DESCRICAO": "Calcificação e ossificação do músculo"
    },
    {
      "CAT": "M62",
      "DESCRICAO": "Outros transtornos musculares"
    },
    {
      "CAT": "M63",
      "DESCRICAO": "Transtornos de músculo em doenças classificadas em outra parte"
    },
    {
      "CAT": "M65",
      "DESCRICAO": "Sinovite e tenossinovite"
    },
    {
      "CAT": "M66",
      "DESCRICAO": "Ruptura espontânea de sinóvia e de tendão"
    },
    {
      "CAT": "M67",
      "DESCRICAO": "Outros transtornos das sinóvias e dos tendões"
    },
    {
      "CAT": "M68",
      "DESCRICAO": "Transtorno de sinóvias e de tendões em doenças classificadas em outra parte"
    },
    {
      "CAT": "M70",
      "DESCRICAO": "Transtornos dos tecidos moles relacionados com o uso"
    },
    {
      "CAT": "M71",
      "DESCRICAO": "Outras bursopatias"
    },
    {
      "CAT": "M72",
      "DESCRICAO": "Transtornos fibroblásticos"
    },
    {
      "CAT": "M73",
      "DESCRICAO": "Transtornos dos tecidos moles em doenças classificadas em outra parte"
    },
    {
      "CAT": "M75",
      "DESCRICAO": "Lesões do ombro"
    },
    {
      "CAT": "M76",
      "DESCRICAO": "Entesopatias dos membros inferiores"
    },
    {
      "CAT": "M77",
      "DESCRICAO": "Outras entesopatias"
    },
    {
      "CAT": "M79",
      "DESCRICAO": "Outros transtornos dos tecidos moles"
    },
    {
      "CAT": "M80",
      "DESCRICAO": "Osteoporose com fratura patológica"
    },
    {
      "CAT": "M81",
      "DESCRICAO": "Osteoporose sem fratura patológica"
    },
    {
      "CAT": "M82",
      "DESCRICAO": "Osteoporose em doenças classificadas em outra parte"
    },
    {
      "CAT": "M83",
      "DESCRICAO": "Osteomalácia do adulto"
    },
    {
      "CAT": "M84",
      "DESCRICAO": "Transtornos da continuidade do osso"
    },
    {
      "CAT": "M85",
      "DESCRICAO": "Outros transtornos da densidade e da estrutura ósseas"
    },
    {
      "CAT": "M86",
      "DESCRICAO": "Osteomielite"
    },
    {
      "CAT": "M87",
      "DESCRICAO": "Osteonecrose"
    },
    {
      "CAT": "M88",
      "DESCRICAO": "Doença de Paget do osso (osteíte deformante)"
    },
    {
      "CAT": "M89",
      "DESCRICAO": "Outros transtornos ósseos"
    },
    {
      "CAT": "M90",
      "DESCRICAO": "Osteopatias em doenças classificadas em outra parte"
    },
    {
      "CAT": "M91",
      "DESCRICAO": "Osteocondrose juvenil do quadril e da pelve"
    },
    {
      "CAT": "M92",
      "DESCRICAO": "Outras osteocondroses juvenis"
    },
    {
      "CAT": "M93",
      "DESCRICAO": "Outras osteocondropatias"
    },
    {
      "CAT": "M94",
      "DESCRICAO": "Outros transtornos das cartilagens"
    },
    {
      "CAT": "M95",
      "DESCRICAO": "Outras deformidades adquiridas do sistema osteomuscular e do tecido conjuntivo"
    },
    {
      "CAT": "M96",
      "DESCRICAO": "Transtornos osteomusculares pós-procedimentos não classificados em outra parte"
    },
    {
      "CAT": "M99",
      "DESCRICAO": "Lesões biomecânicas não classificadas em outra parte"
    },
    {
      "CAT": "N00",
      "DESCRICAO": "Síndrome nefrítica aguda"
    },
    {
      "CAT": "N01",
      "DESCRICAO": "Síndrome nefrítica rapidamente progressiva"
    },
    {
      "CAT": "N02",
      "DESCRICAO": "Hematúria recidivante e persistente"
    },
    {
      "CAT": "N03",
      "DESCRICAO": "Síndrome nefrítica crônica"
    },
    {
      "CAT": "N04",
      "DESCRICAO": "Síndrome nefrótica"
    },
    {
      "CAT": "N05",
      "DESCRICAO": "Síndrome nefrítica não especificada"
    },
    {
      "CAT": "N06",
      "DESCRICAO": "Proteinúria isolada com lesão morfológica especificada"
    },
    {
      "CAT": "N07",
      "DESCRICAO": "Nefropatia hereditária não classificada em outra parte"
    },
    {
      "CAT": "N08",
      "DESCRICAO": "Transtornos glomerulares em doenças classificadas em outra parte"
    },
    {
      "CAT": "N10",
      "DESCRICAO": "Nefrite túbulo-intersticial aguda"
    },
    {
      "CAT": "N11",
      "DESCRICAO": "Nefrite túbulo-intersticial crônica"
    },
    {
      "CAT": "N12",
      "DESCRICAO": "Nefrite túbulo-intersticial não especificada se aguda ou crônica"
    },
    {
      "CAT": "N13",
      "DESCRICAO": "Uropatia obstrutiva e por refluxo"
    },
    {
      "CAT": "N14",
      "DESCRICAO": "Afecções tubulares e túbulo-intersticiais induzidas por drogas ou metais pesados"
    },
    {
      "CAT": "N15",
      "DESCRICAO": "Outras doenças renais túbulo-intersticiais"
    },
    {
      "CAT": "N16",
      "DESCRICAO": "Transtornos renais túbulo-intersticiais em doenças classificadas em outra parte"
    },
    {
      "CAT": "N17",
      "DESCRICAO": "Insuficiência renal aguda"
    },
    {
      "CAT": "N18",
      "DESCRICAO": "Insuficiência renal crônica"
    },
    {
      "CAT": "N19",
      "DESCRICAO": "Insuficiência renal não especificada"
    },
    {
      "CAT": "N20",
      "DESCRICAO": "Calculose do rim e do ureter"
    },
    {
      "CAT": "N21",
      "DESCRICAO": "Calculose do trato urinário inferior"
    },
    {
      "CAT": "N22",
      "DESCRICAO": "Calculose do trato urinário inferior em doenças classificadas em outra parte"
    },
    {
      "CAT": "N23",
      "DESCRICAO": "Cólica nefrética não especificada"
    },
    {
      "CAT": "N25",
      "DESCRICAO": "Transtornos resultantes de função renal tubular alterada"
    },
    {
      "CAT": "N26",
      "DESCRICAO": "Rim contraído"
    },
    {
      "CAT": "N27",
      "DESCRICAO": "Hipoplasia renal de causa desconhecida"
    },
    {
      "CAT": "N28",
      "DESCRICAO": "Outros transtornos do rim e do ureter não classificado em outra parte"
    },
    {
      "CAT": "N29",
      "DESCRICAO": "Outros transtornos do rim e do ureter em doenças classificadas em outra parte"
    },
    {
      "CAT": "N30",
      "DESCRICAO": "Cistite"
    },
    {
      "CAT": "N31",
      "DESCRICAO": "Disfunções neuromusculares da bexiga não classificados em outra parte"
    },
    {
      "CAT": "N32",
      "DESCRICAO": "Outros transtornos da bexiga"
    },
    {
      "CAT": "N33",
      "DESCRICAO": "Transtornos da bexiga em doenças classificadas em outra parte"
    },
    {
      "CAT": "N34",
      "DESCRICAO": "Uretrite e síndrome uretral"
    },
    {
      "CAT": "N35",
      "DESCRICAO": "Estenose da uretra"
    },
    {
      "CAT": "N36",
      "DESCRICAO": "Outros transtornos da uretra"
    },
    {
      "CAT": "N37",
      "DESCRICAO": "Transtornos da uretra em doenças classificadas em outra parte"
    },
    {
      "CAT": "N39",
      "DESCRICAO": "Outros transtornos do trato urinário"
    },
    {
      "CAT": "N40",
      "DESCRICAO": "Hiperplasia da próstata"
    },
    {
      "CAT": "N41",
      "DESCRICAO": "Doenças inflamatórias da próstata"
    },
    {
      "CAT": "N42",
      "DESCRICAO": "Outras afecções da próstata"
    },
    {
      "CAT": "N43",
      "DESCRICAO": "Hidrocele e espermatocele"
    },
    {
      "CAT": "N44",
      "DESCRICAO": "Torção do testículo"
    },
    {
      "CAT": "N45",
      "DESCRICAO": "Orquite e epididimite"
    },
    {
      "CAT": "N46",
      "DESCRICAO": "Infertilidade masculina"
    },
    {
      "CAT": "N47",
      "DESCRICAO": "Hipertrofia do prepúcio"
    },
    {
      "CAT": "N48",
      "DESCRICAO": "Outros transtornos do pênis"
    },
    {
      "CAT": "N49",
      "DESCRICAO": "Transtornos inflamatórios de órgãos genitais masculinos"
    },
    {
      "CAT": "N50",
      "DESCRICAO": "Outros transtornos dos órgãos genitais masculinos"
    },
    {
      "CAT": "N51",
      "DESCRICAO": "Transtornos dos órgãos genitais masculinos em doenças classificadas em outra parte"
    },
    {
      "CAT": "N60",
      "DESCRICAO": "Displasias mamárias benignas"
    },
    {
      "CAT": "N61",
      "DESCRICAO": "Transtornos inflamatórios da mama"
    },
    {
      "CAT": "N62",
      "DESCRICAO": "Hipertrofia da mama"
    },
    {
      "CAT": "N63",
      "DESCRICAO": "Nódulo mamário não especificado"
    },
    {
      "CAT": "N64",
      "DESCRICAO": "Outras doenças da mama"
    },
    {
      "CAT": "N70",
      "DESCRICAO": "Salpingite e ooforite"
    },
    {
      "CAT": "N71",
      "DESCRICAO": "Doença inflamatória do útero"
    },
    {
      "CAT": "N72",
      "DESCRICAO": "Doença inflamatória do colo do útero"
    },
    {
      "CAT": "N73",
      "DESCRICAO": "Outras doenças inflamatórias pélvicas femininas"
    },
    {
      "CAT": "N74",
      "DESCRICAO": "Transtornos inflamatórios da pelve feminina em doenças classificadas em outra parte"
    },
    {
      "CAT": "N75",
      "DESCRICAO": "Doenças da glândula de Bartholin"
    },
    {
      "CAT": "N76",
      "DESCRICAO": "Outras afecções inflamatórias da vagina e da vulva"
    },
    {
      "CAT": "N77",
      "DESCRICAO": "Ulceração e inflamação vulvovaginais em doenças classificadas em outra parte"
    },
    {
      "CAT": "N80",
      "DESCRICAO": "Endometriose"
    },
    {
      "CAT": "N81",
      "DESCRICAO": "Prolapso genital feminino"
    },
    {
      "CAT": "N82",
      "DESCRICAO": "Fístulas do trato genital feminino"
    },
    {
      "CAT": "N83",
      "DESCRICAO": "Transtornos não-inflamatórios do ovário"
    },
    {
      "CAT": "N84",
      "DESCRICAO": "Pólipo do trato genital feminino"
    },
    {
      "CAT": "N85",
      "DESCRICAO": "Outros transtornos não-inflamatórios do útero"
    },
    {
      "CAT": "N86",
      "DESCRICAO": "Erosão e ectrópio do colo do útero"
    },
    {
      "CAT": "N87",
      "DESCRICAO": "Displasia do colo do útero"
    },
    {
      "CAT": "N88",
      "DESCRICAO": "Outros transtornos não-inflamatórios do colo do útero"
    },
    {
      "CAT": "N89",
      "DESCRICAO": "Outros transtornos não-inflamatórios da vagina"
    },
    {
      "CAT": "N90",
      "DESCRICAO": "Outros transtornos não-inflamatórios da vulva e do períneo"
    },
    {
      "CAT": "N91",
      "DESCRICAO": "Menstruação ausente"
    },
    {
      "CAT": "N92",
      "DESCRICAO": "Menstruação excessiva"
    },
    {
      "CAT": "N93",
      "DESCRICAO": "Outros sangramentos anormais do útero e da vagina"
    },
    {
      "CAT": "N94",
      "DESCRICAO": "Dor e outras afecções associadas com os órgãos genitais femininos e com o ciclo menstrual"
    },
    {
      "CAT": "N95",
      "DESCRICAO": "Transtornos da menopausa e da perimenopausa"
    },
    {
      "CAT": "N96",
      "DESCRICAO": "Abortamento habitual"
    },
    {
      "CAT": "N97",
      "DESCRICAO": "Infertilidade feminina"
    },
    {
      "CAT": "N98",
      "DESCRICAO": "Complicações associadas à fecundação artificial"
    },
    {
      "CAT": "N99",
      "DESCRICAO": "Transtornos do trato geniturinário pós-procedimentos não classificados em outra parte"
    },
    {
      "CAT": "O00",
      "DESCRICAO": "Gravidez ectópica"
    },
    {
      "CAT": "O01",
      "DESCRICAO": "Mola hidatiforme"
    },
    {
      "CAT": "O02",
      "DESCRICAO": "Outros produtos anormais da concepção"
    },
    {
      "CAT": "O03",
      "DESCRICAO": "Aborto espontâneo"
    },
    {
      "CAT": "O04",
      "DESCRICAO": "Aborto por razões médicas e legais"
    },
    {
      "CAT": "O05",
      "DESCRICAO": "Outros tipos de aborto"
    },
    {
      "CAT": "O06",
      "DESCRICAO": "Aborto não especificado"
    },
    {
      "CAT": "O07",
      "DESCRICAO": "Falha de tentativa de aborto"
    },
    {
      "CAT": "O08",
      "DESCRICAO": "Complicações conseqüentes a aborto e gravidez ectópica ou molar"
    },
    {
      "CAT": "O10",
      "DESCRICAO": "Hipertensão pré-existente complicando a gravidez"
    },
    {
      "CAT": "O11",
      "DESCRICAO": "Distúrbio hipertensivo pré-existente com proteinúria superposta"
    },
    {
      "CAT": "O12",
      "DESCRICAO": "Edema e proteinúria gestacionais [induzidos pela gravidez]"
    },
    {
      "CAT": "O13",
      "DESCRICAO": "Hipertensão gestacional [induzida pela gravidez] sem proteinúria significativa"
    },
    {
      "CAT": "O14",
      "DESCRICAO": "Hipertensão gestacional [induzida pela gravidez] com proteinúria significativa"
    },
    {
      "CAT": "O15",
      "DESCRICAO": "Eclâmpsia"
    },
    {
      "CAT": "O16",
      "DESCRICAO": "Hipertensão materna não especificada"
    },
    {
      "CAT": "O20",
      "DESCRICAO": "Hemorragia do início da gravidez"
    },
    {
      "CAT": "O21",
      "DESCRICAO": "Vômitos excessivos na gravidez"
    },
    {
      "CAT": "O22",
      "DESCRICAO": "Complicações venosas na gravidez"
    },
    {
      "CAT": "O23",
      "DESCRICAO": "Infecções do trato geniturinário na gravidez"
    },
    {
      "CAT": "O24",
      "DESCRICAO": "Diabetes mellitus na gravidez"
    },
    {
      "CAT": "O25",
      "DESCRICAO": "Desnutrição na gravidez"
    },
    {
      "CAT": "O26",
      "DESCRICAO": "Assistência materna por outras complicações ligadas predominantemente à gravidez"
    },
    {
      "CAT": "O28",
      "DESCRICAO": "Achados anormais do rastreamento [\"screening\"] antenatal da mãe"
    },
    {
      "CAT": "O29",
      "DESCRICAO": "Complicações de anestesia administrada durante a gravidez"
    },
    {
      "CAT": "O30",
      "DESCRICAO": "Gestação múltipla"
    },
    {
      "CAT": "O31",
      "DESCRICAO": "Complicações específicas de gestação múltipla"
    },
    {
      "CAT": "O32",
      "DESCRICAO": "Assistência prestada à mãe por motivo de apresentação anormal"
    },
    {
      "CAT": "O33",
      "DESCRICAO": "Assistência prestada à mãe por uma desproporção conhecida ou suspeita"
    },
    {
      "CAT": "O34",
      "DESCRICAO": "Assistência prestada à mãe por anormalidade"
    },
    {
      "CAT": "O35",
      "DESCRICAO": "Assistência prestada à mãe por anormalidade e lesão fetais"
    },
    {
      "CAT": "O36",
      "DESCRICAO": "Assistência prestada à mãe por outros problemas fetais conhecidos ou suspeitados"
    },
    {
      "CAT": "O40",
      "DESCRICAO": "Polihidrâmnio"
    },
    {
      "CAT": "O41",
      "DESCRICAO": "Outros transtornos das membranas e do líquido amniótico"
    },
    {
      "CAT": "O42",
      "DESCRICAO": "Ruptura prematura de membranas"
    },
    {
      "CAT": "O43",
      "DESCRICAO": "Transtornos da placenta"
    },
    {
      "CAT": "O44",
      "DESCRICAO": "Placenta prévia"
    },
    {
      "CAT": "O45",
      "DESCRICAO": "Descolamento prematuro da placenta [abruptio placentae]"
    },
    {
      "CAT": "O46",
      "DESCRICAO": "Hemorragia anteparto não classificada em outra parte"
    },
    {
      "CAT": "O47",
      "DESCRICAO": "Falso trabalho de parto"
    },
    {
      "CAT": "O48",
      "DESCRICAO": "Gravidez prolongada"
    },
    {
      "CAT": "O60",
      "DESCRICAO": "Trabalho de parto pré-termo"
    },
    {
      "CAT": "O61",
      "DESCRICAO": "Falha na indução do trabalho de parto"
    },
    {
      "CAT": "O62",
      "DESCRICAO": "Anormalidades da contração uterina"
    },
    {
      "CAT": "O63",
      "DESCRICAO": "Trabalho de parto prolongado"
    },
    {
      "CAT": "O64",
      "DESCRICAO": "Obstrução do trabalho de parto devida à má-posição ou má-apresentação do feto"
    },
    {
      "CAT": "O65",
      "DESCRICAO": "Obstrução do trabalho de parto devida a anormalidade pélvica da mãe"
    },
    {
      "CAT": "O66",
      "DESCRICAO": "Outras formas de obstrução do trabalho de parto"
    },
    {
      "CAT": "O67",
      "DESCRICAO": "Trabalho de parto e parto complicados por hemorragia intraparto não classificados em outra parte"
    },
    {
      "CAT": "O68",
      "DESCRICAO": "Trabalho de parto e parto complicados por sofrimento fetal"
    },
    {
      "CAT": "O69",
      "DESCRICAO": "Trabalho de parto e parto complicados por anormalidade do cordão umbilical"
    },
    {
      "CAT": "O70",
      "DESCRICAO": "Laceração do períneo durante o parto"
    },
    {
      "CAT": "O71",
      "DESCRICAO": "Outros traumatismos obstétricos"
    },
    {
      "CAT": "O72",
      "DESCRICAO": "Hemorragia pós-parto"
    },
    {
      "CAT": "O73",
      "DESCRICAO": "Retenção da placenta e das membranas"
    },
    {
      "CAT": "O74",
      "DESCRICAO": "Complicações de anestesia durante o trabalho de parto e o parto"
    },
    {
      "CAT": "O75",
      "DESCRICAO": "Outras complicações do trabalho de parto e do parto não classificadas em outra parte"
    },
    {
      "CAT": "O80",
      "DESCRICAO": "Parto único espontâneo"
    },
    {
      "CAT": "O81",
      "DESCRICAO": "Parto único por fórceps ou vácuo-extrator"
    },
    {
      "CAT": "O82",
      "DESCRICAO": "Parto único por cesariana"
    },
    {
      "CAT": "O83",
      "DESCRICAO": "Outros tipos de parto único assistido"
    },
    {
      "CAT": "O84",
      "DESCRICAO": "Parto múltiplo"
    },
    {
      "CAT": "O85",
      "DESCRICAO": "Infecção puerperal"
    },
    {
      "CAT": "O86",
      "DESCRICAO": "Outras infecções puerperais"
    },
    {
      "CAT": "O87",
      "DESCRICAO": "Complicações venosas no puerpério"
    },
    {
      "CAT": "O88",
      "DESCRICAO": "Embolia de origem obstétrica"
    },
    {
      "CAT": "O89",
      "DESCRICAO": "Complicações da anestesia administrada durante o puerpério"
    },
    {
      "CAT": "O90",
      "DESCRICAO": "Complicações do puerpério não classificadas em outra parte"
    },
    {
      "CAT": "O91",
      "DESCRICAO": "Infecções mamárias associadas ao parto"
    },
    {
      "CAT": "O92",
      "DESCRICAO": "Outras afecções da mama e da lactação associadas ao parto"
    },
    {
      "CAT": "O94",
      "DESCRICAO": "Seqüelas de complicações da gravidez"
    },
    {
      "CAT": "O95",
      "DESCRICAO": "Morte obstétrica de causa não especificada"
    },
    {
      "CAT": "O96",
      "DESCRICAO": "Morte"
    },
    {
      "CAT": "O97",
      "DESCRICAO": "Morte por seqüelas de causas obstétricas diretas"
    },
    {
      "CAT": "O98",
      "DESCRICAO": "Doenças infecciosas e parasitárias maternas classificáveis em outra parte mas que compliquem a gravidez"
    },
    {
      "CAT": "O99",
      "DESCRICAO": "Outras doenças da mãe"
    },
    {
      "CAT": "P00",
      "DESCRICAO": "Feto e recém-nascido afetados por afecções maternas"
    },
    {
      "CAT": "P01",
      "DESCRICAO": "Feto e recém-nascido afetados por complicações maternas da gravidez"
    },
    {
      "CAT": "P02",
      "DESCRICAO": "Feto e recém-nascido afetados por complicações da placenta"
    },
    {
      "CAT": "P03",
      "DESCRICAO": "Feto e recém-nascido afetados por outras complicações do trabalho de parto e do parto"
    },
    {
      "CAT": "P04",
      "DESCRICAO": "Feto e recém-nascido afetados por influências nocivas transmitidas ao feto via placenta ou leite materno"
    },
    {
      "CAT": "P05",
      "DESCRICAO": "Crescimento fetal retardado e desnutrição fetal"
    },
    {
      "CAT": "P07",
      "DESCRICAO": "Transtornos relacionados com a gestação de curta duração e peso baixo ao nascer não classificados em outra parte"
    },
    {
      "CAT": "P08",
      "DESCRICAO": "Transtornos relacionados com a gestação prolongada e peso elevado ao nascer"
    },
    {
      "CAT": "P10",
      "DESCRICAO": "Laceração intracraniana e hemorragia devidas a traumatismo de parto"
    },
    {
      "CAT": "P11",
      "DESCRICAO": "Outros traumatismos de parto do sistema nervoso central"
    },
    {
      "CAT": "P12",
      "DESCRICAO": "Lesão do couro cabeludo devida a traumatismo de parto"
    },
    {
      "CAT": "P13",
      "DESCRICAO": "Lesões do esqueleto devidas a traumatismo de parto"
    },
    {
      "CAT": "P14",
      "DESCRICAO": "Lesões ao nascer do sistema nervoso periférico"
    },
    {
      "CAT": "P15",
      "DESCRICAO": "Outros traumatismos de parto"
    },
    {
      "CAT": "P20",
      "DESCRICAO": "Hipóxia intra-uterina"
    },
    {
      "CAT": "P21",
      "DESCRICAO": "Asfixia ao nascer"
    },
    {
      "CAT": "P22",
      "DESCRICAO": "Desconforto (angústia) respiratório(a) do recém-nascido"
    },
    {
      "CAT": "P23",
      "DESCRICAO": "Pneumonia congênita"
    },
    {
      "CAT": "P24",
      "DESCRICAO": "Síndrome de aspiração neonatal"
    },
    {
      "CAT": "P25",
      "DESCRICAO": "Enfisema intersticial e afecções correlatas originadas no período perinatal"
    },
    {
      "CAT": "P26",
      "DESCRICAO": "Hemorragia pulmonar originada no período perinatal"
    },
    {
      "CAT": "P27",
      "DESCRICAO": "Doença respiratória crônica originada no período perinatal"
    },
    {
      "CAT": "P28",
      "DESCRICAO": "Outras afecções respiratórias originadas no período perinatal"
    },
    {
      "CAT": "P29",
      "DESCRICAO": "Transtornos cardiovasculares originados no período perinatal"
    },
    {
      "CAT": "P35",
      "DESCRICAO": "Doenças virais congênitas"
    },
    {
      "CAT": "P36",
      "DESCRICAO": "Septicemia bacteriana do recém-nascido"
    },
    {
      "CAT": "P37",
      "DESCRICAO": "Outras doenças infecciosas e parasitárias congênitas"
    },
    {
      "CAT": "P38",
      "DESCRICAO": "Onfalite do recém-nascido com ou sem hemorragia leve"
    },
    {
      "CAT": "P39",
      "DESCRICAO": "Outras infecções específicas do período perinatal"
    },
    {
      "CAT": "P50",
      "DESCRICAO": "Perda sangüínea fetal"
    },
    {
      "CAT": "P51",
      "DESCRICAO": "Hemorragia umbilical do recém-nascido"
    },
    {
      "CAT": "P52",
      "DESCRICAO": "Hemorragia intracraniana não-traumática do feto e do recém-nascido"
    },
    {
      "CAT": "P53",
      "DESCRICAO": "Doença hemorrágica do feto e do recém-nascido"
    },
    {
      "CAT": "P54",
      "DESCRICAO": "Outras hemorragias neonatais"
    },
    {
      "CAT": "P55",
      "DESCRICAO": "Doença hemolítica do feto e do recém-nascido"
    },
    {
      "CAT": "P56",
      "DESCRICAO": "Hidropsia fetal devida a doença hemolítica"
    },
    {
      "CAT": "P57",
      "DESCRICAO": "Kernicterus"
    },
    {
      "CAT": "P58",
      "DESCRICAO": "Icterícia neonatal devida a outras hemólises excessivas"
    },
    {
      "CAT": "P59",
      "DESCRICAO": "Icterícia neonatal devida a outras causas e às não especificadas"
    },
    {
      "CAT": "P60",
      "DESCRICAO": "Coagulação intravascular disseminada do feto e do recém-nascido"
    },
    {
      "CAT": "P61",
      "DESCRICAO": "Outros transtornos hematológicos perinatais"
    },
    {
      "CAT": "P70",
      "DESCRICAO": "Transtornos transitórios do metabolismo dos carboidratos específicos do feto e do recém-nascido"
    },
    {
      "CAT": "P71",
      "DESCRICAO": "Transtornos transitórios do metabolismo do cálcio e do magnésio do período neonatal"
    },
    {
      "CAT": "P72",
      "DESCRICAO": "Outros transtornos endócrinos transitórios do período neonatal"
    },
    {
      "CAT": "P74",
      "DESCRICAO": "Outros distúrbios eletrolíticos e metabólicos transitórios do período neonatal"
    },
    {
      "CAT": "P75",
      "DESCRICAO": "Íleo meconial"
    },
    {
      "CAT": "P76",
      "DESCRICAO": "Outras obstruções intestinais do recém-nascido"
    },
    {
      "CAT": "P77",
      "DESCRICAO": "Enterocolite necrotizante do feto e do recém-nascido"
    },
    {
      "CAT": "P78",
      "DESCRICAO": "Outros transtornos do aparelho digestivo do período perinatal"
    },
    {
      "CAT": "P80",
      "DESCRICAO": "Hipotermia do recém-nascido"
    },
    {
      "CAT": "P81",
      "DESCRICAO": "Outros distúrbios da regulação térmica do recém-nascido"
    },
    {
      "CAT": "P83",
      "DESCRICAO": "Outras afecções comprometendo o tegumento específicas do feto e do recém-nascido"
    },
    {
      "CAT": "P90",
      "DESCRICAO": "Convulsões do recém-nascido"
    },
    {
      "CAT": "P91",
      "DESCRICAO": "Outros distúrbios da função cerebral do recém-nascido"
    },
    {
      "CAT": "P92",
      "DESCRICAO": "Problemas de alimentação do recém-nascido"
    },
    {
      "CAT": "P93",
      "DESCRICAO": "Reações e intoxicações devidas a drogas administradas ao feto e ao recém-nascido"
    },
    {
      "CAT": "P94",
      "DESCRICAO": "Transtornos do tônus muscular do recém-nascido"
    },
    {
      "CAT": "P95",
      "DESCRICAO": "Morte fetal de causa não especificada"
    },
    {
      "CAT": "P96",
      "DESCRICAO": "Outras afecções originadas no período perinatal"
    },
    {
      "CAT": "Q00",
      "DESCRICAO": "Anencefalia e malformações similares"
    },
    {
      "CAT": "Q01",
      "DESCRICAO": "Encefalocele"
    },
    {
      "CAT": "Q02",
      "DESCRICAO": "Microcefalia"
    },
    {
      "CAT": "Q03",
      "DESCRICAO": "Hidrocefalia congênita"
    },
    {
      "CAT": "Q04",
      "DESCRICAO": "Outras malformações congênitas do cérebro"
    },
    {
      "CAT": "Q05",
      "DESCRICAO": "Espinha bífida"
    },
    {
      "CAT": "Q06",
      "DESCRICAO": "Outras malformações congênitas da medula espinhal"
    },
    {
      "CAT": "Q07",
      "DESCRICAO": "Outras malformações congênitas do sistema nervoso"
    },
    {
      "CAT": "Q10",
      "DESCRICAO": "Malformações congênitas das pálpebras"
    },
    {
      "CAT": "Q11",
      "DESCRICAO": "Anoftalmia"
    },
    {
      "CAT": "Q12",
      "DESCRICAO": "Malformações congênitas do cristalino"
    },
    {
      "CAT": "Q13",
      "DESCRICAO": "Malformações congênitas da câmara anterior do olho"
    },
    {
      "CAT": "Q14",
      "DESCRICAO": "Malformações congênitas da câmara posterior do olho"
    },
    {
      "CAT": "Q15",
      "DESCRICAO": "Outras malformações congênitas do olho"
    },
    {
      "CAT": "Q16",
      "DESCRICAO": "Malformações congênitas do ouvido causando comprometimento da audição"
    },
    {
      "CAT": "Q17",
      "DESCRICAO": "Outras malformações congênitas da orelha"
    },
    {
      "CAT": "Q18",
      "DESCRICAO": "Outras malformações congênitas da face e do pescoço"
    },
    {
      "CAT": "Q20",
      "DESCRICAO": "Malformações congênitas das câmaras e das comunicações cardíacas"
    },
    {
      "CAT": "Q21",
      "DESCRICAO": "Malformações congênitas dos septos cardíacos"
    },
    {
      "CAT": "Q22",
      "DESCRICAO": "Malformações congênitas das valvas pulmonar e tricúspide"
    },
    {
      "CAT": "Q23",
      "DESCRICAO": "Malformações congênitas das valvas aórtica e mitral"
    },
    {
      "CAT": "Q24",
      "DESCRICAO": "Outras malformações congênitas do coração"
    },
    {
      "CAT": "Q25",
      "DESCRICAO": "Malformações congênitas das grandes artérias"
    },
    {
      "CAT": "Q26",
      "DESCRICAO": "Malformações congênitas das grandes veias"
    },
    {
      "CAT": "Q27",
      "DESCRICAO": "Outras malformações congênitas do sistema vascular periférico"
    },
    {
      "CAT": "Q28",
      "DESCRICAO": "Outras malformações congênitas do aparelho circulatório"
    },
    {
      "CAT": "Q30",
      "DESCRICAO": "Malformação congênita do nariz"
    },
    {
      "CAT": "Q31",
      "DESCRICAO": "Malformações congênitas da laringe"
    },
    {
      "CAT": "Q32",
      "DESCRICAO": "Malformações congênitas da traquéia e dos brônquios"
    },
    {
      "CAT": "Q33",
      "DESCRICAO": "Malformações congênitas do pulmão"
    },
    {
      "CAT": "Q34",
      "DESCRICAO": "Outras malformações congênitas do aparelho respiratório"
    },
    {
      "CAT": "Q35",
      "DESCRICAO": "Fenda palatina"
    },
    {
      "CAT": "Q36",
      "DESCRICAO": "Fenda labial"
    },
    {
      "CAT": "Q37",
      "DESCRICAO": "Fenda labial com fenda palatina"
    },
    {
      "CAT": "Q38",
      "DESCRICAO": "Outras malformações congênitas da língua"
    },
    {
      "CAT": "Q39",
      "DESCRICAO": "Malformações congênitas do esôfago"
    },
    {
      "CAT": "Q40",
      "DESCRICAO": "Outras malformações congênitas do trato digestivo superior"
    },
    {
      "CAT": "Q41",
      "DESCRICAO": "Ausência"
    },
    {
      "CAT": "Q42",
      "DESCRICAO": "Ausência"
    },
    {
      "CAT": "Q43",
      "DESCRICAO": "Outras malformações congênitas do intestino"
    },
    {
      "CAT": "Q44",
      "DESCRICAO": "Malformações congênitas da vesícula biliar"
    },
    {
      "CAT": "Q45",
      "DESCRICAO": "Outras malformações congênitas do aparelho digestivo"
    },
    {
      "CAT": "Q50",
      "DESCRICAO": "Malformações congênitas dos ovários"
    },
    {
      "CAT": "Q51",
      "DESCRICAO": "Malformações congênitas do útero e do colo do útero"
    },
    {
      "CAT": "Q52",
      "DESCRICAO": "Outras malformações congênitas dos órgãos genitais femininos"
    },
    {
      "CAT": "Q53",
      "DESCRICAO": "Testículo não-descido"
    },
    {
      "CAT": "Q54",
      "DESCRICAO": "Hipospádias"
    },
    {
      "CAT": "Q55",
      "DESCRICAO": "Outras malformações congênitas dos órgãos genitais masculinos"
    },
    {
      "CAT": "Q56",
      "DESCRICAO": "Sexo indeterminado e pseudo-hermafroditismo"
    },
    {
      "CAT": "Q60",
      "DESCRICAO": "Agenesia renal e outros defeitos de redução do rim"
    },
    {
      "CAT": "Q61",
      "DESCRICAO": "Doenças císticas do rim"
    },
    {
      "CAT": "Q62",
      "DESCRICAO": "Anomalias congênitas obstrutivas da pelve renal e malformações congênitas do ureter"
    },
    {
      "CAT": "Q63",
      "DESCRICAO": "Outras malformações congênitas do rim"
    },
    {
      "CAT": "Q64",
      "DESCRICAO": "Outras malformações congênitas do aparelho urinário"
    },
    {
      "CAT": "Q65",
      "DESCRICAO": "Malformações congênitas do quadril"
    },
    {
      "CAT": "Q66",
      "DESCRICAO": "Deformidades congênitas do pé"
    },
    {
      "CAT": "Q67",
      "DESCRICAO": "Deformidades osteomusculares congênitas da cabeça"
    },
    {
      "CAT": "Q68",
      "DESCRICAO": "Outras deformidades osteomusculares congênitas"
    },
    {
      "CAT": "Q69",
      "DESCRICAO": "Polidactilia"
    },
    {
      "CAT": "Q70",
      "DESCRICAO": "Sindactilia"
    },
    {
      "CAT": "Q71",
      "DESCRICAO": "Defeitos"
    },
    {
      "CAT": "Q72",
      "DESCRICAO": "Defeitos"
    },
    {
      "CAT": "Q73",
      "DESCRICAO": "Defeitos por redução de membro não especificado"
    },
    {
      "CAT": "Q74",
      "DESCRICAO": "Outras malformações congênitas dos membros"
    },
    {
      "CAT": "Q75",
      "DESCRICAO": "Outras malformações congênitas dos ossos do crânio e da face"
    },
    {
      "CAT": "Q76",
      "DESCRICAO": "Malformações congênitas da coluna vertebral e dos ossos do tórax"
    },
    {
      "CAT": "Q77",
      "DESCRICAO": "Osteocondrodisplasia com anomalias de crescimento dos ossos longos e da coluna vertebral"
    },
    {
      "CAT": "Q78",
      "DESCRICAO": "Outras osteocondrodisplasias"
    },
    {
      "CAT": "Q79",
      "DESCRICAO": "Malformações congênitas do sistema osteomuscular não classificadas em outra parte"
    },
    {
      "CAT": "Q80",
      "DESCRICAO": "Ictiose congênita"
    },
    {
      "CAT": "Q81",
      "DESCRICAO": "Epidermólise bolhosa"
    },
    {
      "CAT": "Q82",
      "DESCRICAO": "Outras malformações congênitas da pele"
    },
    {
      "CAT": "Q83",
      "DESCRICAO": "Malformações congênitas da mama"
    },
    {
      "CAT": "Q84",
      "DESCRICAO": "Outras malformações congênitas do tegumento"
    },
    {
      "CAT": "Q85",
      "DESCRICAO": "Facomatoses não classificadas em outra parte"
    },
    {
      "CAT": "Q86",
      "DESCRICAO": "Síndromes com malformações congênitas devidas a causas exógenas conhecidas"
    },
    {
      "CAT": "Q87",
      "DESCRICAO": "Outras síndromes com malformações congênitas que acometem múltiplos sistemas"
    },
    {
      "CAT": "Q89",
      "DESCRICAO": "Outras malformações congênitas não classificadas em outra parte"
    },
    {
      "CAT": "Q90",
      "DESCRICAO": "Síndrome de Down"
    },
    {
      "CAT": "Q91",
      "DESCRICAO": "Síndrome de Edwards e síndrome de Patau"
    },
    {
      "CAT": "Q92",
      "DESCRICAO": "Outras trissomias e trissomias parciais dos autossomos"
    },
    {
      "CAT": "Q93",
      "DESCRICAO": "Monossomias e deleções dos autossomos"
    },
    {
      "CAT": "Q95",
      "DESCRICAO": "Rearranjos equilibrados e marcadores estruturais"
    },
    {
      "CAT": "Q96",
      "DESCRICAO": "Síndrome de Turner"
    },
    {
      "CAT": "Q97",
      "DESCRICAO": "Outras anomalias dos cromossomos sexuais"
    },
    {
      "CAT": "Q98",
      "DESCRICAO": "Outras anomalias dos cromossomos sexuais"
    },
    {
      "CAT": "Q99",
      "DESCRICAO": "Outras anomalias dos cromossomos"
    },
    {
      "CAT": "R00",
      "DESCRICAO": "Anormalidades do batimento cardíaco"
    },
    {
      "CAT": "R01",
      "DESCRICAO": "Sopros e outros ruídos cardíacos"
    },
    {
      "CAT": "R02",
      "DESCRICAO": "Gangrena não classificada em outra parte"
    },
    {
      "CAT": "R03",
      "DESCRICAO": "Valor anormal da pressão arterial sem diagnóstico"
    },
    {
      "CAT": "R04",
      "DESCRICAO": "Hemorragia das vias respiratórias"
    },
    {
      "CAT": "R05",
      "DESCRICAO": "Tosse"
    },
    {
      "CAT": "R06",
      "DESCRICAO": "Anormalidades da respiração"
    },
    {
      "CAT": "R07",
      "DESCRICAO": "Dor de garganta e no peito"
    },
    {
      "CAT": "R09",
      "DESCRICAO": "Outros sintomas e sinais relativos aos aparelhos circulatório e respiratório"
    },
    {
      "CAT": "R10",
      "DESCRICAO": "Dor abdominal e pélvica"
    },
    {
      "CAT": "R11",
      "DESCRICAO": "Náusea e vômitos"
    },
    {
      "CAT": "R12",
      "DESCRICAO": "Pirose"
    },
    {
      "CAT": "R13",
      "DESCRICAO": "Disfagia"
    },
    {
      "CAT": "R14",
      "DESCRICAO": "Flatulência e afecções correlatas"
    },
    {
      "CAT": "R15",
      "DESCRICAO": "Incontinência fecal"
    },
    {
      "CAT": "R16",
      "DESCRICAO": "Hepatomegalia e esplenomegalia não classificadas em outra parte"
    },
    {
      "CAT": "R17",
      "DESCRICAO": "Icterícia não especificada"
    },
    {
      "CAT": "R18",
      "DESCRICAO": "Ascite"
    },
    {
      "CAT": "R19",
      "DESCRICAO": "Outros sintomas e sinais relativos ao aparelho digestivo e ao abdome"
    },
    {
      "CAT": "R20",
      "DESCRICAO": "Distúrbios da sensibilidade cutânea"
    },
    {
      "CAT": "R21",
      "DESCRICAO": "Eritema e outras erupções cutâneas não especificadas"
    },
    {
      "CAT": "R22",
      "DESCRICAO": "Tumefação"
    },
    {
      "CAT": "R23",
      "DESCRICAO": "Outras alterações cutâneas"
    },
    {
      "CAT": "R25",
      "DESCRICAO": "Movimentos involuntários anormais"
    },
    {
      "CAT": "R26",
      "DESCRICAO": "Anormalidades da marcha e da mobilidade"
    },
    {
      "CAT": "R27",
      "DESCRICAO": "Outros distúrbios da coordenação"
    },
    {
      "CAT": "R29",
      "DESCRICAO": "Outros sintomas e sinais relativos aos sistemas nervoso e osteomuscular"
    },
    {
      "CAT": "R30",
      "DESCRICAO": "Dor associada à micção"
    },
    {
      "CAT": "R31",
      "DESCRICAO": "Hematúria não especificada"
    },
    {
      "CAT": "R32",
      "DESCRICAO": "Incontinência urinária não especificada"
    },
    {
      "CAT": "R33",
      "DESCRICAO": "Retenção urinária"
    },
    {
      "CAT": "R34",
      "DESCRICAO": "Anúria e oligúria"
    },
    {
      "CAT": "R35",
      "DESCRICAO": "Poliúria"
    },
    {
      "CAT": "R36",
      "DESCRICAO": "Secreção uretral"
    },
    {
      "CAT": "R39",
      "DESCRICAO": "Outros sintomas e sinais relativos ao aparelho urinário"
    },
    {
      "CAT": "R40",
      "DESCRICAO": "Sonolência"
    },
    {
      "CAT": "R41",
      "DESCRICAO": "Outros sintomas e sinais relativos à função cognitiva e à consciência"
    },
    {
      "CAT": "R42",
      "DESCRICAO": "Tontura e instabilidade"
    },
    {
      "CAT": "R43",
      "DESCRICAO": "Distúrbios do olfato e do paladar"
    },
    {
      "CAT": "R44",
      "DESCRICAO": "Outros sintomas e sinais relativos às sensações e às percepções gerais"
    },
    {
      "CAT": "R45",
      "DESCRICAO": "Sintomas e sinais relativos ao estado emocional"
    },
    {
      "CAT": "R46",
      "DESCRICAO": "Sintomas e sinais relativos à aparência e ao comportamento"
    },
    {
      "CAT": "R47",
      "DESCRICAO": "Distúrbios da fala não classificados em outra parte"
    },
    {
      "CAT": "R48",
      "DESCRICAO": "Dislexia e outras disfunções simbólicas"
    },
    {
      "CAT": "R49",
      "DESCRICAO": "Distúrbios da voz"
    },
    {
      "CAT": "R50",
      "DESCRICAO": "Febre de origem desconhecida e de outras origens"
    },
    {
      "CAT": "R51",
      "DESCRICAO": "Cefaléia"
    },
    {
      "CAT": "R52",
      "DESCRICAO": "Dor não classificada em outra parte"
    },
    {
      "CAT": "R53",
      "DESCRICAO": "Mal estar"
    },
    {
      "CAT": "R54",
      "DESCRICAO": "Senilidade"
    },
    {
      "CAT": "R55",
      "DESCRICAO": "Síncope e colapso"
    },
    {
      "CAT": "R56",
      "DESCRICAO": "Convulsões"
    },
    {
      "CAT": "R57",
      "DESCRICAO": "Choque não classificado em outra parte"
    },
    {
      "CAT": "R58",
      "DESCRICAO": "Hemorragia não classificada em outra parte"
    },
    {
      "CAT": "R59",
      "DESCRICAO": "Aumento de volume dos gânglios linfáticos"
    },
    {
      "CAT": "R60",
      "DESCRICAO": "Edema não classificado em outra parte"
    },
    {
      "CAT": "R61",
      "DESCRICAO": "Hiperidrose"
    },
    {
      "CAT": "R62",
      "DESCRICAO": "Retardo do desenvolvimento fisiológico normal"
    },
    {
      "CAT": "R63",
      "DESCRICAO": "Sintomas e sinais relativos à ingestão de alimentos e líquidos"
    },
    {
      "CAT": "R64",
      "DESCRICAO": "Caquexia"
    },
    {
      "CAT": "R68",
      "DESCRICAO": "Outros sintomas e sinais gerais"
    },
    {
      "CAT": "R69",
      "DESCRICAO": "Causas desconhecidas e não especificadas de morbidade"
    },
    {
      "CAT": "R70",
      "DESCRICAO": "Velocidade de hemossedimentação elevada e outras anormalidades da viscosidade plasmática"
    },
    {
      "CAT": "R71",
      "DESCRICAO": "Anormalidade das hemácias"
    },
    {
      "CAT": "R72",
      "DESCRICAO": "Anormalidade dos leucócitos não classificada em outra parte"
    },
    {
      "CAT": "R73",
      "DESCRICAO": "Aumento da glicemia"
    },
    {
      "CAT": "R74",
      "DESCRICAO": "Anormalidades dos níveis de enzimas séricas"
    },
    {
      "CAT": "R75",
      "DESCRICAO": "Evidência laboratorial do vírus da imunodeficiência humana [HIV]"
    },
    {
      "CAT": "R76",
      "DESCRICAO": "Outros achados imunológicos anormais no soro"
    },
    {
      "CAT": "R77",
      "DESCRICAO": "Outras anormalidades das proteínas plasmáticas"
    },
    {
      "CAT": "R78",
      "DESCRICAO": "Presença de drogas e de outras substâncias normalmente não encontradas no sangue"
    },
    {
      "CAT": "R79",
      "DESCRICAO": "Outros achados anormais de exames químicos do sangue"
    },
    {
      "CAT": "R80",
      "DESCRICAO": "Proteinúria isolada"
    },
    {
      "CAT": "R81",
      "DESCRICAO": "Glicosúria"
    },
    {
      "CAT": "R82",
      "DESCRICAO": "Outros achados anormais na urina"
    },
    {
      "CAT": "R83",
      "DESCRICAO": "Achados anormais no líquido cefalorraquidiano"
    },
    {
      "CAT": "R84",
      "DESCRICAO": "Achados anormais de material proveniente dos órgãos respiratórios e do tórax"
    },
    {
      "CAT": "R85",
      "DESCRICAO": "Achados anormais de material proveniente dos órgãos digestivos e da cavidade abdominal"
    },
    {
      "CAT": "R86",
      "DESCRICAO": "Achados anormais de material proveniente dos órgãos genitais masculinos"
    },
    {
      "CAT": "R87",
      "DESCRICAO": "Achados anormais de material proveniente dos órgãos genitais femininos"
    },
    {
      "CAT": "R89",
      "DESCRICAO": "Achados anormais de material proveniente de outros órgãos"
    },
    {
      "CAT": "R90",
      "DESCRICAO": "Resultados anormais de exames para diagnóstico por imagem do sistema nervoso central"
    },
    {
      "CAT": "R91",
      "DESCRICAO": "Achados anormais"
    },
    {
      "CAT": "R92",
      "DESCRICAO": "Achados anormais"
    },
    {
      "CAT": "R93",
      "DESCRICAO": "Achados anormais de exames para diagnóstico por imagem de outras estruturas do corpo"
    },
    {
      "CAT": "R94",
      "DESCRICAO": "Resultados anormais de estudos de função"
    },
    {
      "CAT": "R95",
      "DESCRICAO": "Síndrome da morte súbita na infância"
    },
    {
      "CAT": "R96",
      "DESCRICAO": "Outras mortes súbitas de causa desconhecida"
    },
    {
      "CAT": "R98",
      "DESCRICAO": "Morte sem assistência"
    },
    {
      "CAT": "R99",
      "DESCRICAO": "Outras causas mal definidas e as não especificadas de mortalidade"
    },
    {
      "CAT": "S00",
      "DESCRICAO": "Traumatismo superficial da cabeça"
    },
    {
      "CAT": "S01",
      "DESCRICAO": "Ferimento da cabeça"
    },
    {
      "CAT": "S02",
      "DESCRICAO": "Fratura do crânio e dos ossos da face"
    },
    {
      "CAT": "S03",
      "DESCRICAO": "Luxação"
    },
    {
      "CAT": "S04",
      "DESCRICAO": "Traumatismo dos nervos cranianos"
    },
    {
      "CAT": "S05",
      "DESCRICAO": "Traumatismo do olho e da órbita ocular"
    },
    {
      "CAT": "S06",
      "DESCRICAO": "Traumatismo intracraniano"
    },
    {
      "CAT": "S07",
      "DESCRICAO": "Lesões por esmagamento da cabeça"
    },
    {
      "CAT": "S08",
      "DESCRICAO": "Amputação traumática de parte da cabeça"
    },
    {
      "CAT": "S09",
      "DESCRICAO": "Outros traumatismos da cabeça e os não especificados"
    },
    {
      "CAT": "S10",
      "DESCRICAO": "Traumatismo superficial do pescoço"
    },
    {
      "CAT": "S11",
      "DESCRICAO": "Ferimento do pescoço"
    },
    {
      "CAT": "S12",
      "DESCRICAO": "Fratura do pescoço"
    },
    {
      "CAT": "S13",
      "DESCRICAO": "Luxação"
    },
    {
      "CAT": "S14",
      "DESCRICAO": "Traumatismo de nervos e da medula espinhal ao nível cervical"
    },
    {
      "CAT": "S15",
      "DESCRICAO": "Traumatismo dos vasos sangüíneos ao nível do pescoço"
    },
    {
      "CAT": "S16",
      "DESCRICAO": "Traumatismo de tendões e de músculos do pescoço"
    },
    {
      "CAT": "S17",
      "DESCRICAO": "Lesões por esmagamento do pescoço"
    },
    {
      "CAT": "S18",
      "DESCRICAO": "Amputação traumática ao nível do pescoço"
    },
    {
      "CAT": "S19",
      "DESCRICAO": "Outros traumatismos do pescoço e os não especificados"
    },
    {
      "CAT": "S20",
      "DESCRICAO": "Traumatismo superficial do tórax"
    },
    {
      "CAT": "S21",
      "DESCRICAO": "Ferimento do tórax"
    },
    {
      "CAT": "S22",
      "DESCRICAO": "Fratura de costela(s)"
    },
    {
      "CAT": "S23",
      "DESCRICAO": "Luxação"
    },
    {
      "CAT": "S24",
      "DESCRICAO": "Traumatismos de nervos e da medula espinhal ao nível do tórax"
    },
    {
      "CAT": "S25",
      "DESCRICAO": "Traumatismo de vasos sangüíneos do tórax"
    },
    {
      "CAT": "S26",
      "DESCRICAO": "Traumatismo do coração"
    },
    {
      "CAT": "S27",
      "DESCRICAO": "Traumatismo de outros órgãos intratorácicos e dos não especificados"
    },
    {
      "CAT": "S28",
      "DESCRICAO": "Lesão por esmagamento do tórax e amputação traumática de parte do tórax"
    },
    {
      "CAT": "S29",
      "DESCRICAO": "Outros traumatismos do tórax e os não especificados"
    },
    {
      "CAT": "S30",
      "DESCRICAO": "Traumatismo superficial do abdome"
    },
    {
      "CAT": "S31",
      "DESCRICAO": "Ferimento do abdome"
    },
    {
      "CAT": "S32",
      "DESCRICAO": "Fratura da coluna lombar e da pelve"
    },
    {
      "CAT": "S33",
      "DESCRICAO": "Luxação"
    },
    {
      "CAT": "S34",
      "DESCRICAO": "Traumatismo dos nervos e da medula lombar ao nível do abdome"
    },
    {
      "CAT": "S35",
      "DESCRICAO": "Traumatismo de vasos sangüíneos ao nível do abdome"
    },
    {
      "CAT": "S36",
      "DESCRICAO": "Traumatismo de órgãos intra-abdominais"
    },
    {
      "CAT": "S37",
      "DESCRICAO": "Traumatismo do aparelho urinário e de órgãos pélvicos"
    },
    {
      "CAT": "S38",
      "DESCRICAO": "Lesão por esmagamento e amputação traumática de parte do abdome"
    },
    {
      "CAT": "S39",
      "DESCRICAO": "Outros traumatismos e os não especificados do abdome"
    },
    {
      "CAT": "S40",
      "DESCRICAO": "Traumatismo superficial do ombro e do braço"
    },
    {
      "CAT": "S41",
      "DESCRICAO": "Ferimento do ombro e do braço"
    },
    {
      "CAT": "S42",
      "DESCRICAO": "Fratura do ombro e do braço"
    },
    {
      "CAT": "S43",
      "DESCRICAO": "Luxação"
    },
    {
      "CAT": "S44",
      "DESCRICAO": "Traumatismo de nervos ao nível do ombro e do braço"
    },
    {
      "CAT": "S45",
      "DESCRICAO": "Traumatismo dos vasos sangüíneos ao nível do ombro e do braço"
    },
    {
      "CAT": "S46",
      "DESCRICAO": "Traumatismo de tendão e músculo ao nível do ombro e do braço"
    },
    {
      "CAT": "S47",
      "DESCRICAO": "Lesão por esmagamento do ombro e do braço"
    },
    {
      "CAT": "S48",
      "DESCRICAO": "Amputação traumática do ombro e do braço"
    },
    {
      "CAT": "S49",
      "DESCRICAO": "Outros traumatismos e os não especificados do ombro e do braço"
    },
    {
      "CAT": "S50",
      "DESCRICAO": "Traumatismo superficial do cotovelo e do antebraço"
    },
    {
      "CAT": "S51",
      "DESCRICAO": "Ferimento do antebraço"
    },
    {
      "CAT": "S52",
      "DESCRICAO": "Fratura do antebraço"
    },
    {
      "CAT": "S53",
      "DESCRICAO": "Luxação"
    },
    {
      "CAT": "S54",
      "DESCRICAO": "Traumatismo de nervos ao nível do antebraço"
    },
    {
      "CAT": "S55",
      "DESCRICAO": "Traumatismo de vasos sangüíneos ao nível do antebraço"
    },
    {
      "CAT": "S56",
      "DESCRICAO": "Traumatismo do músculo e tendão ao nível do antebraço"
    },
    {
      "CAT": "S57",
      "DESCRICAO": "Lesão por esmagamento do antebraço"
    },
    {
      "CAT": "S58",
      "DESCRICAO": "Amputação traumática do cotovelo e do antebraço"
    },
    {
      "CAT": "S59",
      "DESCRICAO": "Outros traumatismos do antebraço e os não especificados"
    },
    {
      "CAT": "S60",
      "DESCRICAO": "Traumatismo superficial do punho e da mão"
    },
    {
      "CAT": "S61",
      "DESCRICAO": "Ferimento do punho e da mão"
    },
    {
      "CAT": "S62",
      "DESCRICAO": "Fratura ao nível do punho e da mão"
    },
    {
      "CAT": "S63",
      "DESCRICAO": "Luxação"
    },
    {
      "CAT": "S64",
      "DESCRICAO": "Traumatismo de nervos ao nível do punho e da mão"
    },
    {
      "CAT": "S65",
      "DESCRICAO": "Traumatismo de vasos sangüíneos ao nível do punho e da mão"
    },
    {
      "CAT": "S66",
      "DESCRICAO": "Traumatismo de músculo e tendão ao nível do punho e da mão"
    },
    {
      "CAT": "S67",
      "DESCRICAO": "Lesão por esmagamento do punho e da mão"
    },
    {
      "CAT": "S68",
      "DESCRICAO": "Amputação traumática ao nível do punho e da mão"
    },
    {
      "CAT": "S69",
      "DESCRICAO": "Outros traumatismos e os não especificados do punho e da mão"
    },
    {
      "CAT": "S70",
      "DESCRICAO": "Traumatismo superficial do quadril e da coxa"
    },
    {
      "CAT": "S71",
      "DESCRICAO": "Ferimento do quadril e da coxa"
    },
    {
      "CAT": "S72",
      "DESCRICAO": "Fratura do fêmur"
    },
    {
      "CAT": "S73",
      "DESCRICAO": "Luxação"
    },
    {
      "CAT": "S74",
      "DESCRICAO": "Traumatismo de nervos ao nível do quadril e da coxa"
    },
    {
      "CAT": "S75",
      "DESCRICAO": "Traumatismo de vasos sangüíneos ao nível do quadril e da coxa"
    },
    {
      "CAT": "S76",
      "DESCRICAO": "Traumatismo de músculo e de tendão ao nível do quadril e da coxa"
    },
    {
      "CAT": "S77",
      "DESCRICAO": "Lesão por esmagamento do quadril e da coxa"
    },
    {
      "CAT": "S78",
      "DESCRICAO": "Amputação traumática do quadril e da coxa"
    },
    {
      "CAT": "S79",
      "DESCRICAO": "Outros traumatismos e os não especificados do quadril e da coxa"
    },
    {
      "CAT": "S80",
      "DESCRICAO": "Traumatismo superficial da perna"
    },
    {
      "CAT": "S81",
      "DESCRICAO": "Ferimento da perna"
    },
    {
      "CAT": "S82",
      "DESCRICAO": "Fratura da perna"
    },
    {
      "CAT": "S83",
      "DESCRICAO": "Luxação"
    },
    {
      "CAT": "S84",
      "DESCRICAO": "Traumatismo de nervos periféricos da perna"
    },
    {
      "CAT": "S85",
      "DESCRICAO": "Traumatismo de vasos sangüíneos da perna"
    },
    {
      "CAT": "S86",
      "DESCRICAO": "Traumatismos de músculo e de tendão ao nível da perna"
    },
    {
      "CAT": "S87",
      "DESCRICAO": "Traumatismo por esmagamento da perna"
    },
    {
      "CAT": "S88",
      "DESCRICAO": "Amputação traumática da perna"
    },
    {
      "CAT": "S89",
      "DESCRICAO": "Outros traumatismos e os não especificados da perna"
    },
    {
      "CAT": "S90",
      "DESCRICAO": "Traumatismo superficial do tornozelo e do pé"
    },
    {
      "CAT": "S91",
      "DESCRICAO": "Ferimentos do tornozelo e do pé"
    },
    {
      "CAT": "S92",
      "DESCRICAO": "Fratura do pé (exceto do tornozelo)"
    },
    {
      "CAT": "S93",
      "DESCRICAO": "Luxação"
    },
    {
      "CAT": "S94",
      "DESCRICAO": "Traumatismo dos nervos ao nível do tornozelo e do pé"
    },
    {
      "CAT": "S95",
      "DESCRICAO": "Traumatismo de vasos sangüíneos ao nível do tornozelo e do pé"
    },
    {
      "CAT": "S96",
      "DESCRICAO": "Traumatismos do músculo e tendão ao nível do tornozelo e do pé"
    },
    {
      "CAT": "S97",
      "DESCRICAO": "Lesão por esmagamento do tornozelo e do pé"
    },
    {
      "CAT": "S98",
      "DESCRICAO": "Amputação traumática do tornozelo e do pé"
    },
    {
      "CAT": "S99",
      "DESCRICAO": "Outros traumatismos e os não especificados do tornozelo e do pé"
    },
    {
      "CAT": "T00",
      "DESCRICAO": "Traumatismos superficiais envolvendo múltiplas regiões do corpo"
    },
    {
      "CAT": "T01",
      "DESCRICAO": "Ferimentos envolvendo múltiplas regiões do corpo"
    },
    {
      "CAT": "T02",
      "DESCRICAO": "Fraturas envolvendo múltiplas regiões do corpo"
    },
    {
      "CAT": "T03",
      "DESCRICAO": "Luxações"
    },
    {
      "CAT": "T04",
      "DESCRICAO": "Traumatismos por esmagamento envolvendo múltiplas regiões do corpo"
    },
    {
      "CAT": "T05",
      "DESCRICAO": "Amputações traumáticas envolvendo múltiplas regiões do corpo"
    },
    {
      "CAT": "T06",
      "DESCRICAO": "Outros traumatismos envolvendo regiões múltiplas do corpo"
    },
    {
      "CAT": "T07",
      "DESCRICAO": "Traumatismos múltiplos não especificados"
    },
    {
      "CAT": "T08",
      "DESCRICAO": "Fratura da coluna"
    },
    {
      "CAT": "T09",
      "DESCRICAO": "Outros traumatismos de coluna e tronco"
    },
    {
      "CAT": "T10",
      "DESCRICAO": "Fratura do membro superior"
    },
    {
      "CAT": "T11",
      "DESCRICAO": "Outros traumatismos de membro superior"
    },
    {
      "CAT": "T12",
      "DESCRICAO": "Fratura do membro inferior"
    },
    {
      "CAT": "T13",
      "DESCRICAO": "Outros traumatismos de membro inferior"
    },
    {
      "CAT": "T14",
      "DESCRICAO": "Traumatismo de região não especificada do corpo"
    },
    {
      "CAT": "T15",
      "DESCRICAO": "Corpo estranho na parte externa do olho"
    },
    {
      "CAT": "T16",
      "DESCRICAO": "Corpo estranho no ouvido"
    },
    {
      "CAT": "T17",
      "DESCRICAO": "Corpo estranho no trato respiratório"
    },
    {
      "CAT": "T18",
      "DESCRICAO": "Corpo estranho no aparelho digestivo"
    },
    {
      "CAT": "T19",
      "DESCRICAO": "Corpo estranho no trato geniturinário"
    },
    {
      "CAT": "T20",
      "DESCRICAO": "Queimadura e corrosão da cabeça e pescoço"
    },
    {
      "CAT": "T21",
      "DESCRICAO": "Queimadura e corrosão do tronco"
    },
    {
      "CAT": "T22",
      "DESCRICAO": "Queimadura e corrosão do ombro e membro superior"
    },
    {
      "CAT": "T23",
      "DESCRICAO": "Queimadura e corrosão do punho e da mão"
    },
    {
      "CAT": "T24",
      "DESCRICAO": "Queimadura e corrosão do quadril e membro inferior"
    },
    {
      "CAT": "T25",
      "DESCRICAO": "Queimadura e corrosão do tornozelo e do pé"
    },
    {
      "CAT": "T26",
      "DESCRICAO": "Queimadura e corrosão limitadas ao olho e seus anexos"
    },
    {
      "CAT": "T27",
      "DESCRICAO": "Queimadura e corrosão do trato respiratório"
    },
    {
      "CAT": "T28",
      "DESCRICAO": "Queimadura e corrosão de outros órgãos internos"
    },
    {
      "CAT": "T29",
      "DESCRICAO": "Queimaduras e corrosões de múltiplas regiões do corpo"
    },
    {
      "CAT": "T30",
      "DESCRICAO": "Queimadura e corrosão"
    },
    {
      "CAT": "T31",
      "DESCRICAO": "Queimaduras classificadas segundo a extensão da superfície corporal atingida"
    },
    {
      "CAT": "T32",
      "DESCRICAO": "Corrosões classificadas segundo a extensão da superfície corporal atingida"
    },
    {
      "CAT": "T33",
      "DESCRICAO": "Geladura superficial"
    },
    {
      "CAT": "T34",
      "DESCRICAO": "Geladura com necrose de tecidos"
    },
    {
      "CAT": "T35",
      "DESCRICAO": "Geladura de múltiplas partes do corpo e das não especificadas"
    },
    {
      "CAT": "T36",
      "DESCRICAO": "Intoxicação por antibióticos sistêmicos"
    },
    {
      "CAT": "T37",
      "DESCRICAO": "Intoxicação por outras substâncias antiinfecciosas ou antiparasitárias sistêmicas"
    },
    {
      "CAT": "T38",
      "DESCRICAO": "Intoxicação por hormônios"
    },
    {
      "CAT": "T39",
      "DESCRICAO": "Intoxicação por analgésicos"
    },
    {
      "CAT": "T40",
      "DESCRICAO": "Intoxicação por narcóticos e psicodislépticos [alucinógenos]"
    },
    {
      "CAT": "T41",
      "DESCRICAO": "Intoxicação por anestésicos e gases terapêuticos"
    },
    {
      "CAT": "T42",
      "DESCRICAO": "Intoxicação por antiepilépticos"
    },
    {
      "CAT": "T43",
      "DESCRICAO": "Intoxicação por drogas psicotrópicas não classificadas em outra parte"
    },
    {
      "CAT": "T44",
      "DESCRICAO": "Intoxicação por drogas que afetam principalmente o sistema nervoso autônomo"
    },
    {
      "CAT": "T45",
      "DESCRICAO": "Intoxicação por substâncias de ação essencialmente sistêmica e substâncias hematológicas"
    },
    {
      "CAT": "T46",
      "DESCRICAO": "Intoxicação por substâncias que atuam primariamente sobre o aparelho circulatório"
    },
    {
      "CAT": "T47",
      "DESCRICAO": "Intoxicação por substâncias que atuam primariamente sobre o aparelho gastrointestinal"
    },
    {
      "CAT": "T48",
      "DESCRICAO": "Intoxicação por substâncias que atuam primariamente sobre os músculos lisos e esqueléticos e sobre o aparelho respiratório"
    },
    {
      "CAT": "T49",
      "DESCRICAO": "Intoxicação por substâncias de uso tópico que atuam primariamente sobre a pele e as mucosas e por medicamentos utilizados em oftalmologia"
    },
    {
      "CAT": "T50",
      "DESCRICAO": "Intoxicação por diuréticos e outras drogas"
    },
    {
      "CAT": "T51",
      "DESCRICAO": "Efeito tóxico do álcool"
    },
    {
      "CAT": "T52",
      "DESCRICAO": "Efeito tóxico de solventes orgânicos"
    },
    {
      "CAT": "T53",
      "DESCRICAO": "Efeito tóxico de derivados halogênicos de hidrocarbonetos alifáticos e aromáticos"
    },
    {
      "CAT": "T54",
      "DESCRICAO": "Efeito tóxico de corrosivos"
    },
    {
      "CAT": "T55",
      "DESCRICAO": "Efeito tóxico de sabões e detergentes"
    },
    {
      "CAT": "T56",
      "DESCRICAO": "Efeito tóxico de metais"
    },
    {
      "CAT": "T57",
      "DESCRICAO": "Efeito tóxico de outras substâncias inorgânicas"
    },
    {
      "CAT": "T58",
      "DESCRICAO": "Efeito tóxico do monóxido de carbono"
    },
    {
      "CAT": "T59",
      "DESCRICAO": "Efeito tóxico de outros gases"
    },
    {
      "CAT": "T60",
      "DESCRICAO": "Efeito tóxico de pesticidas"
    },
    {
      "CAT": "T61",
      "DESCRICAO": "Efeito tóxico de substâncias nocivas consumidas como fruto do mar"
    },
    {
      "CAT": "T62",
      "DESCRICAO": "Efeito tóxico de outras substâncias nocivas ingeridas como alimento"
    },
    {
      "CAT": "T63",
      "DESCRICAO": "Efeito tóxico de contato com animais venenosos"
    },
    {
      "CAT": "T64",
      "DESCRICAO": "Efeito tóxico da aflatoxina e de outras micotoxinas contaminantes de alimentos"
    },
    {
      "CAT": "T65",
      "DESCRICAO": "Efeito tóxico de outras substâncias e as não especificadas"
    },
    {
      "CAT": "T66",
      "DESCRICAO": "Efeitos não especificados de radiação"
    },
    {
      "CAT": "T67",
      "DESCRICAO": "Efeitos do calor e da luz"
    },
    {
      "CAT": "T68",
      "DESCRICAO": "Hipotermia"
    },
    {
      "CAT": "T69",
      "DESCRICAO": "Outros efeitos da temperatura reduzida"
    },
    {
      "CAT": "T70",
      "DESCRICAO": "Efeitos da pressão atmosférica e da pressão da água"
    },
    {
      "CAT": "T71",
      "DESCRICAO": "Asfixia"
    },
    {
      "CAT": "T73",
      "DESCRICAO": "Efeitos de outras privações"
    },
    {
      "CAT": "T74",
      "DESCRICAO": "Síndromes de maus tratos"
    },
    {
      "CAT": "T75",
      "DESCRICAO": "Efeitos de outras causas externas"
    },
    {
      "CAT": "T78",
      "DESCRICAO": "Efeitos adversos não classificados em outra parte"
    },
    {
      "CAT": "T79",
      "DESCRICAO": "Algumas complicações precoces dos traumatismos não classificadas em outra parte"
    },
    {
      "CAT": "T80",
      "DESCRICAO": "Complicações conseqüentes à infusão"
    },
    {
      "CAT": "T81",
      "DESCRICAO": "Complicações de procedimentos não classificadas em outra parte"
    },
    {
      "CAT": "T82",
      "DESCRICAO": "Complicações de dispositivos protéticos"
    },
    {
      "CAT": "T83",
      "DESCRICAO": "Complicações de dispositivos protéticos"
    },
    {
      "CAT": "T84",
      "DESCRICAO": "Complicações de dispositivos protéticos"
    },
    {
      "CAT": "T85",
      "DESCRICAO": "Complicações de outros dispositivos protéticos"
    },
    {
      "CAT": "T86",
      "DESCRICAO": "Falha e rejeição de órgãos e tecidos transplantados"
    },
    {
      "CAT": "T87",
      "DESCRICAO": "Complicações próprias de reimplante e amputação"
    },
    {
      "CAT": "T88",
      "DESCRICAO": "Outras complicações de cuidados médicos e cirúrgicos não classificadas em outra parte"
    },
    {
      "CAT": "T90",
      "DESCRICAO": "Seqüelas de traumatismo da cabeça"
    },
    {
      "CAT": "T91",
      "DESCRICAO": "Seqüelas de traumatismos do pescoço e do tronco"
    },
    {
      "CAT": "T92",
      "DESCRICAO": "Seqüelas de traumatismos do membro superior"
    },
    {
      "CAT": "T93",
      "DESCRICAO": "Seqüelas de traumatismos do membro inferior"
    },
    {
      "CAT": "T94",
      "DESCRICAO": "Seqüelas de traumatismos envolvendo múltiplas regiões do corpo e as não especificadas"
    },
    {
      "CAT": "T95",
      "DESCRICAO": "Seqüelas de queimaduras"
    },
    {
      "CAT": "T96",
      "DESCRICAO": "Seqüelas de intoxicação por drogas"
    },
    {
      "CAT": "T97",
      "DESCRICAO": "Seqüelas de efeitos tóxicos de substâncias de origem predominantemente não-medicinal"
    },
    {
      "CAT": "T98",
      "DESCRICAO": "Seqüelas de outros efeitos de causas externas e dos não especificados"
    },
    {
      "CAT": "V01",
      "DESCRICAO": "Pedestre traumatizado em colisão com um veículo a pedal"
    },
    {
      "CAT": "V02",
      "DESCRICAO": "Pedestre traumatizado em colisão com um veículo a motor de duas ou três rodas"
    },
    {
      "CAT": "V03",
      "DESCRICAO": "Pedestre traumatizado em colisão com um automóvel [carro]"
    },
    {
      "CAT": "V04",
      "DESCRICAO": "Pedestre traumatizado em colisão com um veículo de transporte pesado ou com um ônibus"
    },
    {
      "CAT": "V05",
      "DESCRICAO": "Pedestre traumatizado em colisão com trem [comboio] ou um veículo ferroviário"
    },
    {
      "CAT": "V06",
      "DESCRICAO": "Pedestre traumatizado em colisão com outro veículo não-motorizado"
    },
    {
      "CAT": "V09",
      "DESCRICAO": "Pedestre traumatizado em outros acidentes de transporte e em acidentes de transporte não especificados"
    },
    {
      "CAT": "V10",
      "DESCRICAO": "Ciclista traumatizado em colisão com um pedestre ou um animal"
    },
    {
      "CAT": "V11",
      "DESCRICAO": "Ciclista traumatizado em colisão com outro veículo a pedal"
    },
    {
      "CAT": "V12",
      "DESCRICAO": "Ciclista traumatizado em colisão com um veículo a motor de duas ou três rodas"
    },
    {
      "CAT": "V13",
      "DESCRICAO": "Ciclista traumatizado em colisão com um automóvel"
    },
    {
      "CAT": "V14",
      "DESCRICAO": "Ciclista traumatizado em colisão com um veículo de transporte pesado ou um ônibus"
    },
    {
      "CAT": "V15",
      "DESCRICAO": "Ciclista traumatizado em colisão com um trem ou um veículo ferroviário"
    },
    {
      "CAT": "V16",
      "DESCRICAO": "Ciclista traumatizado em colisão com outro veículo não-motorizado"
    },
    {
      "CAT": "V17",
      "DESCRICAO": "Ciclista traumatizado em colisão com um objeto fixo ou parado"
    },
    {
      "CAT": "V18",
      "DESCRICAO": "Ciclista traumatizado em um acidente de transporte sem colisão"
    },
    {
      "CAT": "V19",
      "DESCRICAO": "Ciclista traumatizado em outros acidentes de transporte e em acidentes de transporte não especificados"
    },
    {
      "CAT": "V20",
      "DESCRICAO": "Motociclista traumatizado em colisão com um pedestre ou um animal"
    },
    {
      "CAT": "V21",
      "DESCRICAO": "Motociclista traumatizado em colisão com um veículo a pedal"
    },
    {
      "CAT": "V22",
      "DESCRICAO": "Motociclista traumatizado em colisão com um veículo a motor de duas ou três rodas"
    },
    {
      "CAT": "V23",
      "DESCRICAO": "Motociclista traumatizado em colisão com um automóvel [carro]"
    },
    {
      "CAT": "V24",
      "DESCRICAO": "Motociclista traumatizado em colisão com um veículo de transporte pesado ou um ônibus"
    },
    {
      "CAT": "V25",
      "DESCRICAO": "Motociclista traumatizado em colisão com um trem ou um veículo ferroviário"
    },
    {
      "CAT": "V26",
      "DESCRICAO": "Motociclista traumatizado em colisão com outro veículo não-motorizado"
    },
    {
      "CAT": "V27",
      "DESCRICAO": "Motociclista traumatizado em colisão com um objeto fixo ou parado"
    },
    {
      "CAT": "V28",
      "DESCRICAO": "Motociclista traumatizado em um acidente de transporte sem colisão"
    },
    {
      "CAT": "V29",
      "DESCRICAO": "Motociclista traumatizado em outros acidentes de transporte e em acidentes de transporte não especificados"
    },
    {
      "CAT": "V30",
      "DESCRICAO": "Ocupante de um triciclo motorizado traumatizado em colisão com um pedestre ou um animal"
    },
    {
      "CAT": "V31",
      "DESCRICAO": "Ocupante de um triciclo motorizado traumatizado em colisão com um veículo a pedal"
    },
    {
      "CAT": "V32",
      "DESCRICAO": "Ocupante de um triciclo motorizado traumatizado em colisão com outro veículo a motor de duas ou três rodas"
    },
    {
      "CAT": "V33",
      "DESCRICAO": "Ocupante de um triciclo motorizado traumatizado em colisão com um automóvel"
    },
    {
      "CAT": "V34",
      "DESCRICAO": "Ocupante de um triciclo motorizado traumatizado em colisão com um veículo de transporte pesado ou um ônibus"
    },
    {
      "CAT": "V35",
      "DESCRICAO": "Ocupante de um triciclo motorizado traumatizado em colisão com um trem [comboio] ou um veículo ferroviário"
    },
    {
      "CAT": "V36",
      "DESCRICAO": "Ocupante de um triciclo motorizado traumatizado em colisão com outro veículo não-motorizado"
    },
    {
      "CAT": "V37",
      "DESCRICAO": "Ocupante de um triciclo motorizado traumatizado em colisão com um objeto fixo ou parado"
    },
    {
      "CAT": "V38",
      "DESCRICAO": "Ocupante de um triciclo motorizado traumatizado em um acidente de transporte sem colisão"
    },
    {
      "CAT": "V39",
      "DESCRICAO": "Ocupante de um triciclo motorizado traumatizado em outros acidentes de transporte e em acidentes de transporte não especificados"
    },
    {
      "CAT": "V40",
      "DESCRICAO": "Ocupante de um automóvel [carro] traumatizado em colisão com um pedestre ou um animal"
    },
    {
      "CAT": "V41",
      "DESCRICAO": "Ocupante de um automóvel [carro] traumatizado em colisão com um veículo a pedal"
    },
    {
      "CAT": "V42",
      "DESCRICAO": "Ocupante de um automóvel [carro] traumatizado em colisão com outro veículo a motor de duas ou três rodas"
    },
    {
      "CAT": "V43",
      "DESCRICAO": "Ocupante de um automóvel [carro] traumatizado em colisão com um automóvel [carro]"
    },
    {
      "CAT": "V44",
      "DESCRICAO": "Ocupante de um automóvel [carro] traumatizado em colisão com um veículo de transporte pesado ou um ônibus"
    },
    {
      "CAT": "V45",
      "DESCRICAO": "Ocupante de um automóvel [carro] traumatizado em colisão com um trem [comboio] ou um veículo ferroviário"
    },
    {
      "CAT": "V46",
      "DESCRICAO": "Ocupante de um automóvel [carro] traumatizado em colisão com outro veículo não-motorizado"
    },
    {
      "CAT": "V47",
      "DESCRICAO": "Ocupante de um automóvel [carro] traumatizado em colisão com um objeto fixo ou parado"
    },
    {
      "CAT": "V48",
      "DESCRICAO": "Ocupante de um automóvel [carro] traumatizado em um acidente de transporte sem colisão"
    },
    {
      "CAT": "V49",
      "DESCRICAO": "Ocupante de um automóvel [carro] traumatizado em outro acidentes de transporte e em acidentes de transporte não especificados"
    },
    {
      "CAT": "V50",
      "DESCRICAO": "Ocupante de uma caminhonete traumatizado em colisão com um pedestre ou um animal"
    },
    {
      "CAT": "V51",
      "DESCRICAO": "Ocupante de uma caminhonete traumatizado em colisão com um veículo a pedal"
    },
    {
      "CAT": "V52",
      "DESCRICAO": "Ocupante de uma caminhonete traumatizado em colisão com veículo a motor de duas ou três rodas"
    },
    {
      "CAT": "V53",
      "DESCRICAO": "Ocupante de uma caminhonete traumatizado em colisão com um automóvel [carro] ou uma caminhonete"
    },
    {
      "CAT": "V54",
      "DESCRICAO": "Ocupante de uma caminhonete traumatizado em colisão com um veículo de transporte pesado ou um ônibus"
    },
    {
      "CAT": "V55",
      "DESCRICAO": "Ocupante de uma caminhonete traumatizado em colisão com um trem [comboio] ou veículo ferroviário"
    },
    {
      "CAT": "V56",
      "DESCRICAO": "Ocupante de uma caminhonete traumatizado em colisão com outro veículo não-motorizado"
    },
    {
      "CAT": "V57",
      "DESCRICAO": "Ocupante de uma caminhonete traumatizado em colisão com um objeto fixo ou parado"
    },
    {
      "CAT": "V58",
      "DESCRICAO": "Ocupante de uma caminhonete traumatizado em um acidente de transporte sem colisão"
    },
    {
      "CAT": "V59",
      "DESCRICAO": "Ocupante de uma caminhonete traumatizado em outros acidentes de transporte e em acidentes de transporte não especificados"
    },
    {
      "CAT": "V60",
      "DESCRICAO": "Ocupante de um veículo de transporte pesado traumatizado em colisão com um pedestre ou um animal"
    },
    {
      "CAT": "V61",
      "DESCRICAO": "Ocupante de um veículo de transporte pesado traumatizado em colisão com um veículo a pedal"
    },
    {
      "CAT": "V62",
      "DESCRICAO": "Ocupante de um veículo de transporte pesado traumatizado em colisão com um veículo a motor de duas ou três rodas"
    },
    {
      "CAT": "V63",
      "DESCRICAO": "Ocupante de um veículo de transporte pesado traumatizado em colisão com um automóvel [carro] ou uma caminhonete"
    },
    {
      "CAT": "V64",
      "DESCRICAO": "Ocupante de um veículo de transporte pesado traumatizado em colisão com um outro veículo de transporte pesado ou um ônibus"
    },
    {
      "CAT": "V65",
      "DESCRICAO": "Ocupante de um veículo de transporte pesado traumatizado em colisão com um trem [comboio] ou um veículo ferroviário"
    },
    {
      "CAT": "V66",
      "DESCRICAO": "Ocupante de um veículo de transporte pesado traumatizado em colisão com um outro veículo não-motorizado"
    },
    {
      "CAT": "V67",
      "DESCRICAO": "Ocupante de um veículo de transporte pesado traumatizado em colisão com um objeto fixo ou parado"
    },
    {
      "CAT": "V68",
      "DESCRICAO": "Ocupante de um veículo de transporte pesado traumatizado em um acidente de transporte sem colisão"
    },
    {
      "CAT": "V69",
      "DESCRICAO": "Ocupante de um veículo de transporte pesado traumatizado em outros acidentes de transporte não especificados"
    },
    {
      "CAT": "V70",
      "DESCRICAO": "Ocupante de um ônibus traumatizado em colisão com um pedestre ou um animal"
    },
    {
      "CAT": "V71",
      "DESCRICAO": "Ocupante de um ônibus traumatizado em colisão com um veículo a pedal"
    },
    {
      "CAT": "V72",
      "DESCRICAO": "Ocupante de um ônibus traumatizado em colisão com um outro veículo a motor de duas ou três rodas"
    },
    {
      "CAT": "V73",
      "DESCRICAO": "Ocupante de um ônibus traumatizado em colisão com um automóvel [carro] ou uma caminhonete"
    },
    {
      "CAT": "V74",
      "DESCRICAO": "Ocupante de um ônibus traumatizado em colisão com um veículo de transporte pesado ou um ônibus"
    },
    {
      "CAT": "V75",
      "DESCRICAO": "Ocupante de um ônibus traumatizado em colisão com um trem [comboio] ou um veículo ferroviário"
    },
    {
      "CAT": "V76",
      "DESCRICAO": "Ocupante de um ônibus traumatizado em colisão com outro veículo não-motorizado"
    },
    {
      "CAT": "V77",
      "DESCRICAO": "Ocupante de um ônibus traumatizado em colisão com um objeto fixo ou parado"
    },
    {
      "CAT": "V78",
      "DESCRICAO": "Ocupante de um ônibus traumatizado em um acidente de transporte sem colisão"
    },
    {
      "CAT": "V79",
      "DESCRICAO": "Ocupante de um ônibus traumatizado em outros acidentes de transporte e em acidentes de transporte não especificados"
    },
    {
      "CAT": "V80",
      "DESCRICAO": "Pessoa montada em animal ou ocupante de um veículo a tração animal traumatizado em um acidente de transporte"
    },
    {
      "CAT": "V81",
      "DESCRICAO": "Ocupante de um trem [comboio] ou um veículo ferroviário traumatizado em um acidente de transporte"
    },
    {
      "CAT": "V82",
      "DESCRICAO": "Ocupante de um bonde [carro elétrico] traumatizado em um acidente de transporte"
    },
    {
      "CAT": "V83",
      "DESCRICAO": "Ocupante de um veículo especial a motor usado principalmente em áreas industriais traumatizado em um acidente de transporte"
    },
    {
      "CAT": "V84",
      "DESCRICAO": "Ocupante de um veículo especial a motor de uso essencialmente agrícola traumatizado em um acidente de transporte"
    },
    {
      "CAT": "V85",
      "DESCRICAO": "Ocupante de um veículo a motor especial de construções traumatizado em um acidente de transporte"
    },
    {
      "CAT": "V86",
      "DESCRICAO": "Ocupante de um veículo especial para qualquer terreno ou de outro veículo a motor projetado essencialmente para uso não em via pública"
    },
    {
      "CAT": "V87",
      "DESCRICAO": "Acidente de trânsito de tipo especificado"
    },
    {
      "CAT": "V88",
      "DESCRICAO": "Acidente não-de-trânsito de tipo especificado"
    },
    {
      "CAT": "V89",
      "DESCRICAO": "Acidente com um veículo a motor ou não-motorizado"
    },
    {
      "CAT": "V90",
      "DESCRICAO": "Acidente com embarcação causando afogamento e submersão"
    },
    {
      "CAT": "V91",
      "DESCRICAO": "Acidente com embarcação causando outro tipo de traumatismo"
    },
    {
      "CAT": "V92",
      "DESCRICAO": "Afogamento e submersão relacionados com transporte por água sem acidente com a embarcação"
    },
    {
      "CAT": "V93",
      "DESCRICAO": "Acidente a bordo de uma embarcação"
    },
    {
      "CAT": "V94",
      "DESCRICAO": "Outros acidentes de transporte por água e os não especificados"
    },
    {
      "CAT": "V95",
      "DESCRICAO": "Acidente de aeronave a motor causando traumatismo ao ocupante"
    },
    {
      "CAT": "V96",
      "DESCRICAO": "Acidente de uma aeronave sem motor causando traumatismo a ocupante"
    },
    {
      "CAT": "V97",
      "DESCRICAO": "Outros acidentes especificados de transporte aéreo"
    },
    {
      "CAT": "V98",
      "DESCRICAO": "Outros acidentes de transporte especificados"
    },
    {
      "CAT": "V99",
      "DESCRICAO": "Acidente de transporte não especificado"
    },
    {
      "CAT": "W00",
      "DESCRICAO": "Queda no mesmo nível envolvendo gelo e neve"
    },
    {
      "CAT": "W01",
      "DESCRICAO": "Queda no mesmo nível por escorregão"
    },
    {
      "CAT": "W02",
      "DESCRICAO": "Queda envolvendo patins de rodas ou para gelo"
    },
    {
      "CAT": "W03",
      "DESCRICAO": "Outras quedas no mesmo nível por colisão com ou empurrão por outra pessoa"
    },
    {
      "CAT": "W04",
      "DESCRICAO": "Queda"
    },
    {
      "CAT": "W05",
      "DESCRICAO": "Queda envolvendo uma cadeira de rodas"
    },
    {
      "CAT": "W06",
      "DESCRICAO": "Queda de um leito"
    },
    {
      "CAT": "W07",
      "DESCRICAO": "Queda de uma cadeira"
    },
    {
      "CAT": "W08",
      "DESCRICAO": "Queda de outro tipo de mobília"
    },
    {
      "CAT": "W09",
      "DESCRICAO": "Queda envolvendo equipamento de \"playground"
    },
    {
      "CAT": "W10",
      "DESCRICAO": "Queda em ou de escadas ou degraus"
    },
    {
      "CAT": "W11",
      "DESCRICAO": "Queda em ou de escadas de mão"
    },
    {
      "CAT": "W12",
      "DESCRICAO": "Queda em ou de um andaime"
    },
    {
      "CAT": "W13",
      "DESCRICAO": "Queda de ou para fora de edifícios ou outras estruturas"
    },
    {
      "CAT": "W14",
      "DESCRICAO": "Queda de árvore"
    },
    {
      "CAT": "W15",
      "DESCRICAO": "Queda de penhasco"
    },
    {
      "CAT": "W16",
      "DESCRICAO": "Mergulho ou pulo na água causando outro traumatismo que não afogamento ou submersão"
    },
    {
      "CAT": "W17",
      "DESCRICAO": "Outras quedas de um nível a outro"
    },
    {
      "CAT": "W18",
      "DESCRICAO": "Outras quedas no mesmo nível"
    },
    {
      "CAT": "W19",
      "DESCRICAO": "Queda sem especificação"
    },
    {
      "CAT": "W20",
      "DESCRICAO": "Impacto causado por objeto lançado"
    },
    {
      "CAT": "W21",
      "DESCRICAO": "Impacto acidental ativo ou passivo causado por equipamento esportivo"
    },
    {
      "CAT": "W22",
      "DESCRICAO": "Impacto acidental ativo ou passivo causado por outros objetos"
    },
    {
      "CAT": "W23",
      "DESCRICAO": "Apertado"
    },
    {
      "CAT": "W24",
      "DESCRICAO": "Contato com elevadores e instrumentos de transmissão"
    },
    {
      "CAT": "W25",
      "DESCRICAO": "Contato com vidro cortante"
    },
    {
      "CAT": "W26",
      "DESCRICAO": "Contato com faca"
    },
    {
      "CAT": "W27",
      "DESCRICAO": "Contato com ferramentas manuais sem motor"
    },
    {
      "CAT": "W28",
      "DESCRICAO": "Contato com segadeira motorizada para cortar ou aparar a grama"
    },
    {
      "CAT": "W29",
      "DESCRICAO": "Contato com outros utensílios manuais e aparelhos domésticos equipados com motor"
    },
    {
      "CAT": "W30",
      "DESCRICAO": "Contato com maquinaria agrícola"
    },
    {
      "CAT": "W31",
      "DESCRICAO": "Contato com outras máquinas e com as não especificadas"
    },
    {
      "CAT": "W32",
      "DESCRICAO": "Projétil de revólver"
    },
    {
      "CAT": "W33",
      "DESCRICAO": "Rifle"
    },
    {
      "CAT": "W34",
      "DESCRICAO": "Projéteis de outras armas de fogo e das não especificadas"
    },
    {
      "CAT": "W35",
      "DESCRICAO": "Explosão ou ruptura de caldeira"
    },
    {
      "CAT": "W36",
      "DESCRICAO": "Explosão ou ruptura de cilindro de gás"
    },
    {
      "CAT": "W37",
      "DESCRICAO": "Explosão ou ruptura de pneumático"
    },
    {
      "CAT": "W38",
      "DESCRICAO": "Explosão ou ruptura de outros aparelhos pressurizados especificados"
    },
    {
      "CAT": "W39",
      "DESCRICAO": "Queima de fogos de artifício"
    },
    {
      "CAT": "W40",
      "DESCRICAO": "Explosão de outros materiais"
    },
    {
      "CAT": "W41",
      "DESCRICAO": "Exposição a um jato de alta pressão"
    },
    {
      "CAT": "W42",
      "DESCRICAO": "Exposição ao ruído"
    },
    {
      "CAT": "W43",
      "DESCRICAO": "Exposição à vibração"
    },
    {
      "CAT": "W44",
      "DESCRICAO": "Penetração de corpo estranho no ou através de olho ou orifício natural"
    },
    {
      "CAT": "W45",
      "DESCRICAO": "Penetração de corpo ou objeto estranho através da pele"
    },
    {
      "CAT": "W46",
      "DESCRICAO": "Contato com agulha hipodérmica"
    },
    {
      "CAT": "W49",
      "DESCRICAO": "Exposição a outras forças mecânicas inanimadas e às não especificadas"
    },
    {
      "CAT": "W50",
      "DESCRICAO": "Golpe"
    },
    {
      "CAT": "W51",
      "DESCRICAO": "Colisão entre duas pessoas"
    },
    {
      "CAT": "W52",
      "DESCRICAO": "Esmagado"
    },
    {
      "CAT": "W53",
      "DESCRICAO": "Mordedura de rato"
    },
    {
      "CAT": "W54",
      "DESCRICAO": "Mordedura ou golpe provocado por cão"
    },
    {
      "CAT": "W55",
      "DESCRICAO": "Mordedura ou golpe provocado por outros animais mamíferos"
    },
    {
      "CAT": "W56",
      "DESCRICAO": "Contato com animais marinhos"
    },
    {
      "CAT": "W57",
      "DESCRICAO": "Mordeduras e picadas de inseto e de outros artrópodes"
    },
    {
      "CAT": "W58",
      "DESCRICAO": "Mordedura ou golpe provocado por crocodilo ou aligátor"
    },
    {
      "CAT": "W59",
      "DESCRICAO": "Mordedura ou esmagamento provocado por outros répteis"
    },
    {
      "CAT": "W60",
      "DESCRICAO": "Contato com espinhos de plantas ou com folhas aguçadas"
    },
    {
      "CAT": "W64",
      "DESCRICAO": "Exposição a outras forças mecânicas animadas e às não especificadas"
    },
    {
      "CAT": "W65",
      "DESCRICAO": "Afogamento e submersão durante banho em banheira"
    },
    {
      "CAT": "W66",
      "DESCRICAO": "Afogamento e submersão consecutiva a queda dentro de uma banheira"
    },
    {
      "CAT": "W67",
      "DESCRICAO": "Afogamento e submersão em piscina"
    },
    {
      "CAT": "W68",
      "DESCRICAO": "Afogamento e submersão conseqüente a queda dentro de uma piscina"
    },
    {
      "CAT": "W69",
      "DESCRICAO": "Afogamento e submersão em águas naturais"
    },
    {
      "CAT": "W70",
      "DESCRICAO": "Afogamento e submersão conseqüentes a queda dentro de águas naturais"
    },
    {
      "CAT": "W73",
      "DESCRICAO": "Outros afogamentos e submersão especificados"
    },
    {
      "CAT": "W74",
      "DESCRICAO": "Afogamento e submersão não especificados"
    },
    {
      "CAT": "W75",
      "DESCRICAO": "Sufocação e estrangulamento acidental na cama"
    },
    {
      "CAT": "W76",
      "DESCRICAO": "Outro enforcamento e estrangulamento acidental"
    },
    {
      "CAT": "W77",
      "DESCRICAO": "Risco a respiração devido a desmoronamento"
    },
    {
      "CAT": "W78",
      "DESCRICAO": "Inalação do conteúdo gástrico"
    },
    {
      "CAT": "W79",
      "DESCRICAO": "Inalação e ingestão de alimentos causando obstrução do trato respiratório"
    },
    {
      "CAT": "W80",
      "DESCRICAO": "Inalação e ingestão de outros objetos causando obstrução do trato respiratório"
    },
    {
      "CAT": "W81",
      "DESCRICAO": "Confinado ou aprisionado em um ambiente pobre em oxigênio"
    },
    {
      "CAT": "W83",
      "DESCRICAO": "Outros riscos especificados à respiração"
    },
    {
      "CAT": "W84",
      "DESCRICAO": "Riscos não especificados à respiração"
    },
    {
      "CAT": "W85",
      "DESCRICAO": "Exposição a linhas de transmissão de corrente elétrica"
    },
    {
      "CAT": "W86",
      "DESCRICAO": "Exposição a outra corrente elétrica especificada"
    },
    {
      "CAT": "W87",
      "DESCRICAO": "Exposição a corrente elétrica não especificada"
    },
    {
      "CAT": "W88",
      "DESCRICAO": "Exposição a radiação ionizante"
    },
    {
      "CAT": "W89",
      "DESCRICAO": "Exposição a fontes luminosas artificiais visíveis ou à luz ultravioleta"
    },
    {
      "CAT": "W90",
      "DESCRICAO": "Exposição a outros tipos de radiação não-ionizante"
    },
    {
      "CAT": "W91",
      "DESCRICAO": "Exposição a tipo não especificado de radiação"
    },
    {
      "CAT": "W92",
      "DESCRICAO": "Exposição a um calor excessivo de origem artificial"
    },
    {
      "CAT": "W93",
      "DESCRICAO": "Exposição a um frio excessivo de origem artificial"
    },
    {
      "CAT": "W94",
      "DESCRICAO": "Exposição a alta"
    },
    {
      "CAT": "W99",
      "DESCRICAO": "Exposição a outros fatores ambientais artificiais e aos não especificados"
    },
    {
      "CAT": "X00",
      "DESCRICAO": "Exposição a fogo não-controlado em um edifício ou outro tipo de construção"
    },
    {
      "CAT": "X01",
      "DESCRICAO": "Exposição a fogo não-controlado fora de um edifício ou de outro tipo de construção"
    },
    {
      "CAT": "X02",
      "DESCRICAO": "Exposição a fogo controlado em um edifício ou outro tipo de construção"
    },
    {
      "CAT": "X03",
      "DESCRICAO": "Exposição a fogo controlado fora de um edifício ou de outro tipo de construção"
    },
    {
      "CAT": "X04",
      "DESCRICAO": "Exposição a combustão de substância muito inflamável"
    },
    {
      "CAT": "X05",
      "DESCRICAO": "Exposição a combustão de roupa de dormir"
    },
    {
      "CAT": "X06",
      "DESCRICAO": "Exposição a combustão de outro tipo de roupa ou de acessórios"
    },
    {
      "CAT": "X08",
      "DESCRICAO": "Exposição a outro tipo especificado de fumaça"
    },
    {
      "CAT": "X09",
      "DESCRICAO": "Exposição a tipo não especificado de fumaça"
    },
    {
      "CAT": "X10",
      "DESCRICAO": "Contato com bebidas"
    },
    {
      "CAT": "X11",
      "DESCRICAO": "Contato com água corrente quente de torneira"
    },
    {
      "CAT": "X12",
      "DESCRICAO": "Contato com outros líquidos quentes"
    },
    {
      "CAT": "X13",
      "DESCRICAO": "Contato com vapor d'água e com vapores quentes"
    },
    {
      "CAT": "X14",
      "DESCRICAO": "Contato com ar e gases quentes"
    },
    {
      "CAT": "X15",
      "DESCRICAO": "Contato com aparelhos domésticos quentes"
    },
    {
      "CAT": "X16",
      "DESCRICAO": "Contato com aquecedores"
    },
    {
      "CAT": "X17",
      "DESCRICAO": "Contato com motores"
    },
    {
      "CAT": "X18",
      "DESCRICAO": "Contato com outros metais quentes"
    },
    {
      "CAT": "X19",
      "DESCRICAO": "Contato com outras fontes de calor ou com substâncias quentes não especificados"
    },
    {
      "CAT": "X20",
      "DESCRICAO": "Contato com serpentes e lagartos venenosos"
    },
    {
      "CAT": "X21",
      "DESCRICAO": "Contato com aranhas venenosas"
    },
    {
      "CAT": "X22",
      "DESCRICAO": "Contato com escorpiões"
    },
    {
      "CAT": "X23",
      "DESCRICAO": "Contato com abelhas"
    },
    {
      "CAT": "X24",
      "DESCRICAO": "Contato com centopéias e miriápodes venenosas (tropicais)"
    },
    {
      "CAT": "X25",
      "DESCRICAO": "Contato com outros artrópodes venenosos"
    },
    {
      "CAT": "X26",
      "DESCRICAO": "Contato com animais e plantas marinhos venenosos"
    },
    {
      "CAT": "X27",
      "DESCRICAO": "Contato com outros animais venenosos especificados"
    },
    {
      "CAT": "X28",
      "DESCRICAO": "Contato com outras plantas venenosas especificadas"
    },
    {
      "CAT": "X29",
      "DESCRICAO": "Contato com animais ou plantas venenosos"
    },
    {
      "CAT": "X30",
      "DESCRICAO": "Exposição a calor natural excessivo"
    },
    {
      "CAT": "X31",
      "DESCRICAO": "Exposição a frio natural excessivo"
    },
    {
      "CAT": "X32",
      "DESCRICAO": "Exposição à luz solar"
    },
    {
      "CAT": "X33",
      "DESCRICAO": "Vítima de raio"
    },
    {
      "CAT": "X34",
      "DESCRICAO": "Vítima de terremoto"
    },
    {
      "CAT": "X35",
      "DESCRICAO": "Vítima de erupção vulcânica"
    },
    {
      "CAT": "X36",
      "DESCRICAO": "Vítima de avalanche"
    },
    {
      "CAT": "X37",
      "DESCRICAO": "Vítima de tempestade cataclísmica"
    },
    {
      "CAT": "X38",
      "DESCRICAO": "Vítima de inundação"
    },
    {
      "CAT": "X39",
      "DESCRICAO": "Exposição a outras forças da natureza e às não especificadas"
    },
    {
      "CAT": "X40",
      "DESCRICAO": "Envenenamento [intoxicação] acidental por e exposição a analgésicos"
    },
    {
      "CAT": "X41",
      "DESCRICAO": "Envenenamento [intoxicação] acidental por e exposição a anticonvulsivantes [antiepilépticos]"
    },
    {
      "CAT": "X42",
      "DESCRICAO": "Envenenamento [intoxicação] acidental por e exposição a narcóticos e psicodislépticos [alucinógenos] não classificados em outra parte"
    },
    {
      "CAT": "X43",
      "DESCRICAO": "Envenenamento [intoxicação] acidental por e exposição a outras substâncias farmacológicas de ação sobre o sistema nervoso autônomo"
    },
    {
      "CAT": "X44",
      "DESCRICAO": "Envenenamento [intoxicação] acidental por e exposição a outras drogas"
    },
    {
      "CAT": "X45",
      "DESCRICAO": "Envenenamento [intoxicação] acidental por e exposição ao álcool"
    },
    {
      "CAT": "X46",
      "DESCRICAO": "Envenenamento [intoxicação] acidental por e exposição a solventes orgânicos e hidrocarbonetos halogenados e seus vapores"
    },
    {
      "CAT": "X47",
      "DESCRICAO": "Intoxicação acidental por e exposição a outros gases e vapores"
    },
    {
      "CAT": "X48",
      "DESCRICAO": "Envenenamento [intoxicação] acidental por e exposição a pesticidas"
    },
    {
      "CAT": "X49",
      "DESCRICAO": "Envenenamento [intoxicação] acidental por e exposição a outras substâncias químicas nocivas e às não especificadas"
    },
    {
      "CAT": "X50",
      "DESCRICAO": "Excesso de exercícios e movimentos vigorosos ou repetitivos"
    },
    {
      "CAT": "X51",
      "DESCRICAO": "Viagem e movimento"
    },
    {
      "CAT": "X52",
      "DESCRICAO": "Estadia prolongada em ambiente agravitacional"
    },
    {
      "CAT": "X53",
      "DESCRICAO": "Falta de alimento"
    },
    {
      "CAT": "X54",
      "DESCRICAO": "Falta de água"
    },
    {
      "CAT": "X57",
      "DESCRICAO": "Privação não especificada"
    },
    {
      "CAT": "X58",
      "DESCRICAO": "Exposição a outros fatores especificados"
    },
    {
      "CAT": "X59",
      "DESCRICAO": "Exposição a fatores não especificados"
    },
    {
      "CAT": "X60",
      "DESCRICAO": "Auto-intoxicação por e exposição"
    },
    {
      "CAT": "X61",
      "DESCRICAO": "Auto-intoxicação por e exposição"
    },
    {
      "CAT": "X62",
      "DESCRICAO": "Auto-intoxicação por e exposição"
    },
    {
      "CAT": "X63",
      "DESCRICAO": "Auto-intoxicação por e exposição"
    },
    {
      "CAT": "X64",
      "DESCRICAO": "Auto-intoxicação por e exposição"
    },
    {
      "CAT": "X65",
      "DESCRICAO": "Auto-intoxicação voluntária por álcool"
    },
    {
      "CAT": "X66",
      "DESCRICAO": "Auto-intoxicação intencional por solventes orgânicos"
    },
    {
      "CAT": "X67",
      "DESCRICAO": "Auto-intoxicação intencional por outros gases e vapores"
    },
    {
      "CAT": "X68",
      "DESCRICAO": "Auto-intoxicação por e exposição"
    },
    {
      "CAT": "X69",
      "DESCRICAO": "Auto-intoxicação por e exposição"
    },
    {
      "CAT": "X70",
      "DESCRICAO": "Lesão autoprovocada intencionalmente por enforcamento"
    },
    {
      "CAT": "X71",
      "DESCRICAO": "Lesão autoprovocada intencionalmente por afogamento e submersão"
    },
    {
      "CAT": "X72",
      "DESCRICAO": "Lesão autoprovocada intencionalmente por disparo de arma de fogo de mão"
    },
    {
      "CAT": "X73",
      "DESCRICAO": "Lesão autoprovocada intencionalmente por disparo de espingarda"
    },
    {
      "CAT": "X74",
      "DESCRICAO": "Lesão autoprovocada intencionalmente por disparo de outra arma de fogo e de arma de fogo não especificada"
    },
    {
      "CAT": "X75",
      "DESCRICAO": "Lesão autoprovocada intencionalmente por dispositivos explosivos"
    },
    {
      "CAT": "X76",
      "DESCRICAO": "Lesão autoprovocada intencionalmente pela fumaça"
    },
    {
      "CAT": "X77",
      "DESCRICAO": "Lesão autoprovocada intencionalmente por vapor de água"
    },
    {
      "CAT": "X78",
      "DESCRICAO": "Lesão autoprovocada intencionalmente por objeto cortante ou penetrante"
    },
    {
      "CAT": "X79",
      "DESCRICAO": "Lesão autoprovocada intencionalmente por objeto contundente"
    },
    {
      "CAT": "X80",
      "DESCRICAO": "Lesão autoprovocada intencionalmente por precipitação de um lugar elevado"
    },
    {
      "CAT": "X81",
      "DESCRICAO": "Lesão autoprovocada intencionalmente por precipitação ou permanência diante de um objeto em movimento"
    },
    {
      "CAT": "X82",
      "DESCRICAO": "Lesão autoprovocada intencionalmente por impacto de um veículo a motor"
    },
    {
      "CAT": "X83",
      "DESCRICAO": "Lesão autoprovocada intencionalmente por outros meios especificados"
    },
    {
      "CAT": "X84",
      "DESCRICAO": "Lesão autoprovocada intencionalmente por meios não especificados"
    },
    {
      "CAT": "X85",
      "DESCRICAO": "Agressão por meio de drogas"
    },
    {
      "CAT": "X86",
      "DESCRICAO": "Agressão por meio de substâncias corrosivas"
    },
    {
      "CAT": "X87",
      "DESCRICAO": "Agressão por pesticidas"
    },
    {
      "CAT": "X88",
      "DESCRICAO": "Agressão por meio de gases e vapores"
    },
    {
      "CAT": "X89",
      "DESCRICAO": "Agressão por meio de outros produtos químicos e substâncias nocivas especificados"
    },
    {
      "CAT": "X90",
      "DESCRICAO": "Agressão por meio de produtos químicos e substâncias nocivas não especificados"
    },
    {
      "CAT": "X91",
      "DESCRICAO": "Agressão por meio de enforcamento"
    },
    {
      "CAT": "X92",
      "DESCRICAO": "Agressão por meio de afogamento e submersão"
    },
    {
      "CAT": "X93",
      "DESCRICAO": "Agressão por meio de disparo de arma de fogo de mão"
    },
    {
      "CAT": "X94",
      "DESCRICAO": "Agressão por meio de disparo de espingarda"
    },
    {
      "CAT": "X95",
      "DESCRICAO": "Agressão por meio de disparo de outra arma de fogo ou de arma não especificada"
    },
    {
      "CAT": "X96",
      "DESCRICAO": "Agressão por meio de material explosivo"
    },
    {
      "CAT": "X97",
      "DESCRICAO": "Agressão por meio de fumaça"
    },
    {
      "CAT": "X98",
      "DESCRICAO": "Agressão por meio de vapor de água"
    },
    {
      "CAT": "X99",
      "DESCRICAO": "Agressão por meio de objeto cortante ou penetrante"
    },
    {
      "CAT": "Y00",
      "DESCRICAO": "Agressão por meio de um objeto contundente"
    },
    {
      "CAT": "Y01",
      "DESCRICAO": "Agressão por meio de projeção de um lugar elevado"
    },
    {
      "CAT": "Y02",
      "DESCRICAO": "Agressão por meio de projeção ou colocação da vítima diante de um objeto em movimento"
    },
    {
      "CAT": "Y03",
      "DESCRICAO": "Agressão por meio de impacto de um veículo a motor"
    },
    {
      "CAT": "Y04",
      "DESCRICAO": "Agressão por meio de força corporal"
    },
    {
      "CAT": "Y05",
      "DESCRICAO": "Agressão sexual por meio de força física"
    },
    {
      "CAT": "Y06",
      "DESCRICAO": "Negligência e abandono"
    },
    {
      "CAT": "Y07",
      "DESCRICAO": "Outras síndromes de maus tratos"
    },
    {
      "CAT": "Y08",
      "DESCRICAO": "Agressão por outros meios especificados"
    },
    {
      "CAT": "Y09",
      "DESCRICAO": "Agressão por meios não especificados"
    },
    {
      "CAT": "Y10",
      "DESCRICAO": "Envenenamento [intoxicação] por e exposição a analgésicos"
    },
    {
      "CAT": "Y11",
      "DESCRICAO": "Envenenamento [intoxicação] por e exposição a anticonvulsivantes [antiepilépticos]"
    },
    {
      "CAT": "Y12",
      "DESCRICAO": "Envenenamento [intoxicação] por e exposição a narcóticos e a psicodislépticos [alucinógenos] não classificados em outra parte"
    },
    {
      "CAT": "Y13",
      "DESCRICAO": "Envenenamento [intoxicação] por e exposição a outras substâncias farmacológicas de ação sobre o sistema nervoso autônomo"
    },
    {
      "CAT": "Y14",
      "DESCRICAO": "Envenenamento [intoxicação] por e exposição a outras drogas"
    },
    {
      "CAT": "Y15",
      "DESCRICAO": "Envenenamento [intoxicação] por e exposição ao álcool"
    },
    {
      "CAT": "Y16",
      "DESCRICAO": "Envenenamento [intoxicação] por e exposição a solventes orgânicos e hidrocarbonetos halogenados e seus vapores"
    },
    {
      "CAT": "Y17",
      "DESCRICAO": "Envenenamento [intoxicação] por e exposição a outros gases e vapores"
    },
    {
      "CAT": "Y18",
      "DESCRICAO": "Envenenamento [intoxicação] por e exposição a pesticidas"
    },
    {
      "CAT": "Y19",
      "DESCRICAO": "Envenenamento [intoxicação] por e exposição a outros produtos químicos e substâncias nocivas e aos não especificados"
    },
    {
      "CAT": "Y20",
      "DESCRICAO": "Enforcamento"
    },
    {
      "CAT": "Y21",
      "DESCRICAO": "Afogamento e submersão"
    },
    {
      "CAT": "Y22",
      "DESCRICAO": "Disparo de pistola"
    },
    {
      "CAT": "Y23",
      "DESCRICAO": "Disparo de fuzil"
    },
    {
      "CAT": "Y24",
      "DESCRICAO": "Disparo de outra arma de fogo e de arma de fogo não especificada"
    },
    {
      "CAT": "Y25",
      "DESCRICAO": "Contato com material explosivo"
    },
    {
      "CAT": "Y26",
      "DESCRICAO": "Exposição a fumaça"
    },
    {
      "CAT": "Y27",
      "DESCRICAO": "Exposição a vapor de água"
    },
    {
      "CAT": "Y28",
      "DESCRICAO": "Contato com objeto cortante ou penetrante"
    },
    {
      "CAT": "Y29",
      "DESCRICAO": "Contato com objeto contundente"
    },
    {
      "CAT": "Y30",
      "DESCRICAO": "Queda"
    },
    {
      "CAT": "Y31",
      "DESCRICAO": "Queda"
    },
    {
      "CAT": "Y32",
      "DESCRICAO": "Impacto de um veículo a motor"
    },
    {
      "CAT": "Y33",
      "DESCRICAO": "Outros fatos ou eventos especificados"
    },
    {
      "CAT": "Y34",
      "DESCRICAO": "Fatos ou eventos não especificados e intenção não determinada"
    },
    {
      "CAT": "Y35",
      "DESCRICAO": "Intervenção legal"
    },
    {
      "CAT": "Y36",
      "DESCRICAO": "Operações de guerra"
    },
    {
      "CAT": "Y40",
      "DESCRICAO": "Efeitos adversos de antibióticos sistêmicos"
    },
    {
      "CAT": "Y41",
      "DESCRICAO": "Efeitos adversos de outros antiinfecciosos e antiparasitários sistêmicos"
    },
    {
      "CAT": "Y42",
      "DESCRICAO": "Efeitos adversos de hormônios e seus substitutos sintéticos e antagonistas"
    },
    {
      "CAT": "Y43",
      "DESCRICAO": "Efeitos adversos de substâncias de ação primariamente sistêmica"
    },
    {
      "CAT": "Y44",
      "DESCRICAO": "Efeitos adversos de substâncias farmacológicas que atuam primariamente sobre os constituintes do sangue"
    },
    {
      "CAT": "Y45",
      "DESCRICAO": "Efeitos adversos de substâncias analgésicas"
    },
    {
      "CAT": "Y46",
      "DESCRICAO": "Efeitos adversos de drogas anticonvulsivantes (antiepilépticas) e antiparkinsonianas"
    },
    {
      "CAT": "Y47",
      "DESCRICAO": "Efeitos adversos de sedativos"
    },
    {
      "CAT": "Y48",
      "DESCRICAO": "Efeitos adversos de anestésicos e gases terapêuticos"
    },
    {
      "CAT": "Y49",
      "DESCRICAO": "Efeitos adversos de substâncias psicotrópicas"
    },
    {
      "CAT": "Y50",
      "DESCRICAO": "Efeitos adversos de estimulantes do sistema nervoso central"
    },
    {
      "CAT": "Y51",
      "DESCRICAO": "Efeitos adversos de drogas que atuam primariamente sobre o sistema nervoso autônomo"
    },
    {
      "CAT": "Y52",
      "DESCRICAO": "Efeitos adversos de substâncias que atuam primariamente sobre o aparelho cardiovascular"
    },
    {
      "CAT": "Y53",
      "DESCRICAO": "Efeitos adversos de substâncias que atuam primariamente sobre o aparelho gastrointestinal"
    },
    {
      "CAT": "Y54",
      "DESCRICAO": "Efeitos adversos de substâncias que atuam primariamente sobre o metabolismo da água"
    },
    {
      "CAT": "Y55",
      "DESCRICAO": "Efeitos adversos de substâncias que atuam primariamente sobre os músculos lisos e esqueléticos e sobre o aparelho respiratório"
    },
    {
      "CAT": "Y56",
      "DESCRICAO": "Efeitos adversos de substâncias de uso tópico que atuam primariamente sobre a pele e as membranas mucosas e drogas de uso oftalmológico"
    },
    {
      "CAT": "Y57",
      "DESCRICAO": "Efeitos adversos de outras drogas e medicamentos e as não especificadas"
    },
    {
      "CAT": "Y58",
      "DESCRICAO": "Efeitos adversos de vacinas bacterianas"
    },
    {
      "CAT": "Y59",
      "DESCRICAO": "Efeitos adversos de outras vacinas e substâncias biológicas e as não especificadas"
    },
    {
      "CAT": "Y60",
      "DESCRICAO": "Corte"
    },
    {
      "CAT": "Y61",
      "DESCRICAO": "Objeto estranho deixado acidentalmente no corpo durante a prestação de cuidados cirúrgicos e médicos"
    },
    {
      "CAT": "Y62",
      "DESCRICAO": "Assepsia insuficiente durante a prestação de cuidados cirúrgicos e médicos"
    },
    {
      "CAT": "Y63",
      "DESCRICAO": "Erros de dosagem durante a prestação de cuidados médicos e cirúrgicos"
    },
    {
      "CAT": "Y64",
      "DESCRICAO": "Medicamentos ou substâncias biológicas contaminados"
    },
    {
      "CAT": "Y65",
      "DESCRICAO": "Outros acidentes durante a prestação de cuidados médicos e cirúrgicos"
    },
    {
      "CAT": "Y66",
      "DESCRICAO": "Não administração de cuidado médico e cirúrgico"
    },
    {
      "CAT": "Y69",
      "DESCRICAO": "Acidente não especificado durante a prestação de cuidado médico e cirúrgico"
    },
    {
      "CAT": "Y70",
      "DESCRICAO": "Dispositivos (aparelhos) de anestesiologia"
    },
    {
      "CAT": "Y71",
      "DESCRICAO": "Dispositivos (aparelhos) cardiovasculares"
    },
    {
      "CAT": "Y72",
      "DESCRICAO": "Dispositivos (aparelhos) utilizados em otorrinolaringologia"
    },
    {
      "CAT": "Y73",
      "DESCRICAO": "Dispositivos (aparelhos) usados em gastroenterologia e em urologia"
    },
    {
      "CAT": "Y74",
      "DESCRICAO": "Dispositivos (aparelhos) gerais de uso hospitalar ou pessoal"
    },
    {
      "CAT": "Y75",
      "DESCRICAO": "Dispositivos (aparelhos) utilizados em neurologia"
    },
    {
      "CAT": "Y76",
      "DESCRICAO": "Dispositivos (aparelhos) utilizados em obstetrícia e em ginecologia"
    },
    {
      "CAT": "Y77",
      "DESCRICAO": "Dispositivos (aparelhos) utilizados em oftalmologia"
    },
    {
      "CAT": "Y78",
      "DESCRICAO": "Dispositivos (aparelhos) utilizados em radiologia"
    },
    {
      "CAT": "Y79",
      "DESCRICAO": "Dispositivos (aparelhos) ortopédicos"
    },
    {
      "CAT": "Y80",
      "DESCRICAO": "Dispositivos (aparelhos) utilizados em medicina física (fisiatria)"
    },
    {
      "CAT": "Y81",
      "DESCRICAO": "Dispositivos (aparelhos) utilizados em cirurgia geral ou cirurgia plástica"
    },
    {
      "CAT": "Y82",
      "DESCRICAO": "Outros dispositivos (aparelhos) associados a incidentes adversos e os não especificados"
    },
    {
      "CAT": "Y83",
      "DESCRICAO": "Reação anormal em paciente ou complicação tardia"
    },
    {
      "CAT": "Y84",
      "DESCRICAO": "Reação anormal em paciente ou complicação tardia"
    },
    {
      "CAT": "Y85",
      "DESCRICAO": "Seqüelas de acidentes de transporte"
    },
    {
      "CAT": "Y86",
      "DESCRICAO": "Seqüelas de outros acidentes"
    },
    {
      "CAT": "Y87",
      "DESCRICAO": "Seqüelas de uma lesão autoprovocada intencionalmente"
    },
    {
      "CAT": "Y88",
      "DESCRICAO": "Seqüelas de cuidado médico ou cirúrgico considerados como uma causa externa"
    },
    {
      "CAT": "Y89",
      "DESCRICAO": "Seqüelas de outras causas externas"
    },
    {
      "CAT": "Y90",
      "DESCRICAO": "Evidência de alcoolismo determinada por taxas de alcoolemia"
    },
    {
      "CAT": "Y91",
      "DESCRICAO": "Evidência de alcoolismo determinada pelo nível da intoxicação"
    },
    {
      "CAT": "Y95",
      "DESCRICAO": "Circunstância relativa as condições nosocomiais (hospitalares)"
    },
    {
      "CAT": "Y96",
      "DESCRICAO": "Circunstância relativa às condições de trabalho"
    },
    {
      "CAT": "Y97",
      "DESCRICAO": "Circunstâncias relativas a condições de poluição ambiental"
    },
    {
      "CAT": "Y98",
      "DESCRICAO": "Circunstâncias relativas a condições do modo de vida"
    },
    {
      "CAT": "Z00",
      "DESCRICAO": "Exame geral e investigação de pessoas sem queixas ou diagnóstico relatado"
    },
    {
      "CAT": "Z01",
      "DESCRICAO": "Outros exames e investigações especiais de pessoas sem queixa ou diagnóstico relatado"
    },
    {
      "CAT": "Z02",
      "DESCRICAO": "Exame médico e consulta com finalidades administrativas"
    },
    {
      "CAT": "Z03",
      "DESCRICAO": "Observação e avaliação médica por doenças e afecções suspeitas"
    },
    {
      "CAT": "Z04",
      "DESCRICAO": "Exame e observação por outras razões"
    },
    {
      "CAT": "Z08",
      "DESCRICAO": "Exame de seguimento após tratamento por neoplasia maligna"
    },
    {
      "CAT": "Z09",
      "DESCRICAO": "Exame de seguimento após tratamento de outras afecções que não neoplasias malignas"
    },
    {
      "CAT": "Z10",
      "DESCRICAO": "Exame geral de rotina (\"check up\") de uma subpopulação definida"
    },
    {
      "CAT": "Z11",
      "DESCRICAO": "Exame especial de rastreamento (\"screening\") de doenças infecciosas e parasitárias"
    },
    {
      "CAT": "Z12",
      "DESCRICAO": "Exame especial de rastreamento (\"screening\") de neoplasias"
    },
    {
      "CAT": "Z13",
      "DESCRICAO": "Exame especial de rastreamento (\"screening\") de outros transtornos e doenças"
    },
    {
      "CAT": "Z20",
      "DESCRICAO": "Contato com e exposição a doenças transmissíveis"
    },
    {
      "CAT": "Z21",
      "DESCRICAO": "Estado de infecção assintomática pelo vírus da imunodeficiência humana [HIV]"
    },
    {
      "CAT": "Z22",
      "DESCRICAO": "Portador de doença infecciosa"
    },
    {
      "CAT": "Z23",
      "DESCRICAO": "Necessidade de imunização contra uma única doença bacteriana"
    },
    {
      "CAT": "Z24",
      "DESCRICAO": "Necessidade de imunização contra algumas doenças virais únicas"
    },
    {
      "CAT": "Z25",
      "DESCRICAO": "Necessidade de imunização contra outras doenças virais únicas"
    },
    {
      "CAT": "Z26",
      "DESCRICAO": "Necessidade de imunização contra outras doenças infecciosas únicas"
    },
    {
      "CAT": "Z27",
      "DESCRICAO": "Necessidade de imunização associada contra combinações de doenças infecciosas"
    },
    {
      "CAT": "Z28",
      "DESCRICAO": "Imunização não realizada"
    },
    {
      "CAT": "Z29",
      "DESCRICAO": "Necessidade de outras medidas profiláticas"
    },
    {
      "CAT": "Z30",
      "DESCRICAO": "Anticoncepção"
    },
    {
      "CAT": "Z31",
      "DESCRICAO": "Medidas de procriação"
    },
    {
      "CAT": "Z32",
      "DESCRICAO": "Exame ou teste de gravidez"
    },
    {
      "CAT": "Z33",
      "DESCRICAO": "Gravidez como achado casual"
    },
    {
      "CAT": "Z34",
      "DESCRICAO": "Supervisão de gravidez normal"
    },
    {
      "CAT": "Z35",
      "DESCRICAO": "Supervisão de gravidez de alto risco"
    },
    {
      "CAT": "Z36",
      "DESCRICAO": "Rastreamento (\"screening\") pré-natal"
    },
    {
      "CAT": "Z37",
      "DESCRICAO": "Resultado do parto"
    },
    {
      "CAT": "Z38",
      "DESCRICAO": "Nascidos vivos [nado-vivos] segundo o local de nascimento"
    },
    {
      "CAT": "Z39",
      "DESCRICAO": "Assistência e exame pós-natal"
    },
    {
      "CAT": "Z40",
      "DESCRICAO": "Cirurgia profilática"
    },
    {
      "CAT": "Z41",
      "DESCRICAO": "Procedimentos para outros propósitos exceto cuidados de saúde"
    },
    {
      "CAT": "Z42",
      "DESCRICAO": "Seguimento envolvendo cirurgia plástica"
    },
    {
      "CAT": "Z43",
      "DESCRICAO": "Atenção a orifícios artificiais"
    },
    {
      "CAT": "Z44",
      "DESCRICAO": "Colocação e ajustamento de aparelhos de prótese externa"
    },
    {
      "CAT": "Z45",
      "DESCRICAO": "Ajustamento e manuseio de dispositivo implantado"
    },
    {
      "CAT": "Z46",
      "DESCRICAO": "Colocação e ajustamento de outros aparelhos"
    },
    {
      "CAT": "Z47",
      "DESCRICAO": "Outros cuidados de seguimento ortopédico"
    },
    {
      "CAT": "Z48",
      "DESCRICAO": "Outro seguimento cirúrgico"
    },
    {
      "CAT": "Z49",
      "DESCRICAO": "Cuidados envolvendo diálise"
    },
    {
      "CAT": "Z50",
      "DESCRICAO": "Cuidados envolvendo o uso de procedimentos de reabilitação"
    },
    {
      "CAT": "Z51",
      "DESCRICAO": "Outros cuidados médicos"
    },
    {
      "CAT": "Z52",
      "DESCRICAO": "Doadores de órgãos e tecidos"
    },
    {
      "CAT": "Z53",
      "DESCRICAO": "Pessoas em contato com serviços de saúde para procedimentos específicos não realizados"
    },
    {
      "CAT": "Z54",
      "DESCRICAO": "Convalescença"
    },
    {
      "CAT": "Z55",
      "DESCRICAO": "Problemas relacionados com a educação e com a alfabetização"
    },
    {
      "CAT": "Z56",
      "DESCRICAO": "Problemas relacionados com o emprego e com o desemprego"
    },
    {
      "CAT": "Z57",
      "DESCRICAO": "Exposição ocupacional a fatores de risco"
    },
    {
      "CAT": "Z58",
      "DESCRICAO": "Problemas relacionados com o ambiente físico"
    },
    {
      "CAT": "Z59",
      "DESCRICAO": "Problemas relacionados com a habitação e com as condições econômicas"
    },
    {
      "CAT": "Z60",
      "DESCRICAO": "Problemas relacionados com o meio social"
    },
    {
      "CAT": "Z61",
      "DESCRICAO": "Problemas relacionados com eventos negativos de vida na infância"
    },
    {
      "CAT": "Z62",
      "DESCRICAO": "Outros problemas relacionados com a educação da criança"
    },
    {
      "CAT": "Z63",
      "DESCRICAO": "Outros problemas relacionados com o grupo primário de apoio"
    },
    {
      "CAT": "Z64",
      "DESCRICAO": "Problemas relacionados com algumas outras circunstâncias psicossociais"
    },
    {
      "CAT": "Z65",
      "DESCRICAO": "Problemas relacionados com outras circunstâncias psicossociais"
    },
    {
      "CAT": "Z70",
      "DESCRICAO": "Aconselhamento relativo às atitudes"
    },
    {
      "CAT": "Z71",
      "DESCRICAO": "Pessoas em contato com os serviços de saúde para outros aconselhamentos e conselho médico"
    },
    {
      "CAT": "Z72",
      "DESCRICAO": "Problemas relacionados com o estilo de vida"
    },
    {
      "CAT": "Z73",
      "DESCRICAO": "Problemas relacionados com a organização de seu modo de vida"
    },
    {
      "CAT": "Z74",
      "DESCRICAO": "Problemas relacionados com a dependência de uma pessoa que oferece cuidados de saúde"
    },
    {
      "CAT": "Z75",
      "DESCRICAO": "Problemas relacionados com as facilidades médicas e outros cuidados de saúde"
    },
    {
      "CAT": "Z76",
      "DESCRICAO": "Pessoas em contato com os serviços de saúde em outras circunstâncias"
    },
    {
      "CAT": "Z80",
      "DESCRICAO": "História familiar de neoplasia maligna"
    },
    {
      "CAT": "Z81",
      "DESCRICAO": "História familiar de transtornos mentais e comportamentais"
    },
    {
      "CAT": "Z82",
      "DESCRICAO": "História familiar de algumas incapacidades e doenças crônicas que conduzem a incapacitação"
    },
    {
      "CAT": "Z83",
      "DESCRICAO": "História familiar de outros transtornos específicos"
    },
    {
      "CAT": "Z84",
      "DESCRICAO": "História familiar de outras afecções"
    },
    {
      "CAT": "Z85",
      "DESCRICAO": "História pessoal de neoplasia maligna"
    },
    {
      "CAT": "Z86",
      "DESCRICAO": "História pessoal de algumas outras doenças"
    },
    {
      "CAT": "Z87",
      "DESCRICAO": "História pessoal de outras doenças e afecções"
    },
    {
      "CAT": "Z88",
      "DESCRICAO": "História pessoal de alergia a drogas"
    },
    {
      "CAT": "Z89",
      "DESCRICAO": "Ausência adquirida de membros"
    },
    {
      "CAT": "Z90",
      "DESCRICAO": "Ausência adquirida de órgãos não classificados em outra parte"
    },
    {
      "CAT": "Z91",
      "DESCRICAO": "História pessoal de fatores de risco"
    },
    {
      "CAT": "Z92",
      "DESCRICAO": "História pessoal de tratamento médico"
    },
    {
      "CAT": "Z93",
      "DESCRICAO": "Orifícios artificiais"
    },
    {
      "CAT": "Z94",
      "DESCRICAO": "Órgãos e tecidos transplantados"
    },
    {
      "CAT": "Z95",
      "DESCRICAO": "Presença de implantes e enxertos cardíacos e vasculares"
    },
    {
      "CAT": "Z96",
      "DESCRICAO": "Presença de outros implantes funcionais"
    },
    {
      "CAT": "Z97",
      "DESCRICAO": "Presença de outros dispositivos protéticos"
    },
    {
      "CAT": "Z98",
      "DESCRICAO": "Outros estados pós-cirúrgicos"
    },
    {
      "CAT": "Z99",
      "DESCRICAO": "Dependência de máquinas e dispositivos capacitantes"
    },
    {
      "CAT": "U04",
      "DESCRICAO": "Síndrome respiratória aguda grave [severe acute respiratory syndrome SARS]"
    },
    {
      "CAT": "U80",
      "DESCRICAO": "Agente resistente à penicilina e antibióticos relacionados"
    },
    {
      "CAT": "U81",
      "DESCRICAO": "Agente resistente à vancomicina e antibióticos relacionados"
    },
    {
      "CAT": "U88",
      "DESCRICAO": "Agente resistente a múltiplos antibióticos"
    },
    {
      "CAT": "U89",
      "DESCRICAO": "Agente resistente a outros antibióticos e a antibióticos não especificados"
    },
    {
      "CAT": "U99",
      "DESCRICAO": "CID 10ª Revisão não disponível"
    }
  ]

  return cid10;
}
export default Cid10;